import React from 'react';
import './ReportView.css';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import withShipment from '../../../withShipment';
import {
  userInfoSelector,
  viewOnlySelector,
} from '../../../redux/selectors/auth';
import {
  allSessionIdsSelector,
  employeeSummarySelector,
  loadingSelector,
  managerSettingSelector,
  managerSummarySelector,
  reportSelector,
  shortAnalysisSelector,
  summaryBreakdownSelector,
  summarySelector,
} from '../../../redux/selectors/settings';
import {
  clearWeeklyReport,
  getManagerSummary,
  listReport,
  listSessionIds,
  listShortAnalysis,
  saveManagerSetting,
  saveManagerSummary,
  updateManagerBank,
  editBankBoardEntry,
  deleteBankBoardEntry,
  updateReportField,
} from '../../../redux/actions/settings';
import { listWeeklyReportAudit } from '../../../redux/actions/audit';
import { weeklyReportAuditLogsSelector } from '../../../redux/selectors/audit';

import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Tooltip from '@material-ui/core/Tooltip';
import FilterIcon from '../../global/FilterIcon';
import Chip from '@material-ui/core/Chip';
import DescriptionIcon from '@mui/icons-material/Description';
import {
  Stack,
  IconButton,
  Typography,
  Box,
  Alert,
  Divider,
} from '@mui/material';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@mui/icons-material/Close';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import {
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
} from '../../../redux/actions/ticketOut';
import { globalPDFPreviewReadySelector } from '../../../redux/selectors/ticketOut';
import { DEFAULT_PDF_ZOOM } from '../../raffle/constants';
// Platform 15-color pastel employee identity — keyed by userId so an employee
// keeps the same avatar colour everywhere in NDS (Daily Analysis spec §4.3).
import { empMeta, initialOf } from '../../pointsWatching/employeeColors';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../../reading/masterReading/constants';
import { GetApp } from '@material-ui/icons';
import PrintIcon from '@mui/icons-material/Print';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import CustomToolbar from '../../global/CustomToolbar';
import Utils from '../../Utils/Utils';
import RenderPurchaseOrderPDFPreview from '../../transaction/RenderPurchaseOrderPDFPreview';
import SettingsIcon from '@material-ui/icons/Settings';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ManagerSetting from './ManagerSetting';
import WeeklyReportAuditLog from '../../audit/WeeklyReportAuditLog';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ShiftDetail from '../../employeeSession/reports/ShiftDetail';
import PdfBody from '../../employeeSession/shared/PdfBody';
import generateSessionPdf, {
  suggestedFilename,
} from '../../employeeSession/shared/generateSessionPdf';
import { deriveAssignedDay } from '../../employeeSession/screens/EmployeeSessionsScreen';
import { TOKENS, formatHoursWorked } from '../../employeeSession/theme';
import {
  loadSessionReports,
  clearSessionReports,
} from '../../../redux/actions/employeeSessionV2';
import {
  sessionDataSelector,
  loadingSessionReportsSelector,
} from '../../../redux/selectors/employeeSessionV2';
import { listAllCustomers } from '../../../redux/actions/customer';
import { customersSelector } from '../../../redux/selectors/customer';
import { getEmployees } from '../../../redux/actions/auth';
import { employeesSelector } from '../../../redux/selectors/auth';
import { listManageBonus, listCategory } from '../../../redux/actions/settings';
import {
  categorySelector,
  manageBonusSelector,
} from '../../../redux/selectors/settings';
import { Backdrop, CircularProgress } from '@mui/material';

import { Grid, Paper } from '@mui/material';
import InputAdornment from '@material-ui/core/InputAdornment';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { expenses } from '../../transaction/constants';
import { ATM_TYPES, PDF_COLORS } from './constants';
import {
  allowedPercentageRows,
  allowedWeeklyTabs,
  canViewAuditHistory,
  canViewReadingSummary,
  hasFullWeeklyReport,
  BASIC_EXPENSE_PCT_FIELDS,
  BASIC_MACHINE_PCT_FIELDS,
} from '../../../constants/planFeatures';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import TableChartIcon from '@mui/icons-material/TableChart';
import CalculateIcon from '@mui/icons-material/Calculate';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const WEEKLY_TABS = [
  {
    key: 'profit',
    label: 'Cash Flow',
    emoji: '💵',
    Icon: TableChartIcon,
    color: '#16a34a',
  },
  {
    key: 'readings',
    label: 'Readings',
    emoji: '🎰',
    Icon: CalculateIcon,
    color: '#0d9488',
  },
  {
    key: 'expenses',
    label: 'Expenses',
    emoji: '📋',
    Icon: AssignmentIcon,
    color: '#2563eb',
  },
  {
    key: 'closingBalance',
    label: 'Closing Balance',
    emoji: '🏦',
    Icon: AccountBalanceIcon,
    color: '#0891b2',
  },
  {
    key: 'managerLoan',
    label: 'Manager Loan',
    emoji: '📒',
    Icon: StickyNote2Icon,
    color: '#ca8a04',
  },
  {
    // Merged tab: replaces the former standalone Activity and Equation X tabs.
    // Daily Activity summary on top, a single Equation X proof card with a
    // collapsible breakdown below. See Daily Analysis Developer Spec v1.
    key: 'dailyAnalysis',
    label: 'Daily Analysis',
    emoji: '📊',
    Icon: BarChartIcon,
    color: '#4a4fba',
  },
  {
    key: 'percentages',
    label: 'Percentages',
    emoji: '🥧',
    Icon: PieChartIcon,
    color: '#7c3aed',
  },
];

// A tab restored from navigation state (coming back from Match Tickets)
// can be one this company's plan doesn't include -- Standard has no
// Manager Loan or Daily Analysis -- which would render an empty pane with
// no tab lit. Fall back to Cash Flow, which every plan has. Kept a free
// function because the constructor needs it before class fields exist.
function resolveInitialTab(userInfo, requested) {
  const tabs = allowedWeeklyTabs(userInfo, WEEKLY_TABS);
  return tabs.some((t) => t.key === requested) ? requested : 'profit';
}

// Cash Flow fields whose inline editor also takes a note. Loan In is the
// only one today: its amount is derived from CUSTOMER PAY LOANS bank rows,
// so a manager overriding the total needs somewhere to say why - otherwise
// the breakdown shows a number nobody can account for. The note is merged
// into that same breakdown server-side.
const NOTE_FIELDS = ['loanIn'];

// One self-describing breakdown line for a hand-edited Loan In:
//
//     LOAN IN (reason - $500.00) - Hasnain
//
// Deliberately carries no heading — the line names itself. Mirrors
// ReportService.loanInNoteLine; the server builds the same string for the
// Summary tab, and the two must not drift.
function formatLoanInNoteLine(row) {
  const note = (row?.loanInNote || '').trim();
  if (!note) return '';

  const amount = row?.loanInNoteAmount;
  const inner =
    amount === null || amount === undefined
      ? note
      : `${note} - $${Number(amount).toFixed(2)}`;

  const by = (row?.loanInNoteBy || '').trim();
  const line = `LOAN IN (${inner})`;
  return by ? `${line} - ${by}` : line;
}

class ReportView extends React.Component {
  constructor(props) {
    super(props);
    const todayHouston = this.getHoustonToday();
    const currentDay = todayHouston.getDay(); // 0=Sun, 1=Mon, 2=Tue

    // Distance to last Tuesday
    const diffToLastTuesday =
      currentDay >= 2 ? currentDay - 2 : 7 - (2 - currentDay);

    const fromDate = new Date(todayHouston);
    fromDate.setDate(todayHouston.getDate() - diffToLastTuesday);

    const toDate = new Date(fromDate);
    toDate.setDate(fromDate.getDate() + 6);

    // Returning from the Match Tickets screen (opened via Daily Analysis →
    // Open Match Tickets): restore the exact week/day/tab the user left, rather
    // than defaulting to the current week. `restoreReport` is passed through
    // react-router location state (dates as epoch ms).
    const restore = props.location?.state?.restoreReport;
    let restoredFrom = fromDate;
    let restoredTo = toDate;
    if (restore) {
      if (restore.fromDate) restoredFrom = new Date(restore.fromDate);
      if (restore.toDate) restoredTo = new Date(restore.toDate);
    }

    this.state = {
      feedbackBarOpen: false,
      feedbackMessage: '',
      feedbackStatus: '',
      selectedDay: restore?.selectedDay || null,
      fromDate: restoredFrom,
      toDate: restoredTo,
      selectedSessionIds: [],
      isDialogOpen: false,
      isCommentDialogOpen: false,
      selectedComment: '',
      editingFields: {
        jpOtherIn: false,
        jpOtherOut: false,
        addBank: false,
        loanIn: false,
        minusBank: false,
        jackpotNotPay: false,
      },
      fieldValues: {},
      // Amount-plus-reason editor for the fields in NOTE_FIELDS.
      noteEditor: {
        open: false,
        field: null,
        label: '',
        amount: '',
        note: '',
        savedBy: '',
      },
      showAddExpenseDialog: false,
      newExpense: {
        description: '',
        expenseType: '',
        amount: '',
        comments: '',
      },
      showDeleteDialog: false,
      rowToDelete: null,
      amountInput: '',
      nameInput: '',
      type: true,
      // Manager Loan To Bank — owner edit / delete of an existing row.
      bankEntryToEdit: null,
      bankEditAmount: '',
      bankEditName: '',
      bankEditType: 'add',
      bankEntryToDelete: null,
      bankEntryBusy: false,
      activeATMField: null,
      activeATMValue: '',
      //report
      showPdfViewer: false,
      // New interactive shift-report overlay (replaces the legacy PDF preview
      // for the audit-log "View shift report" chip). Holds the clicked
      // employee's target {userId, userName, clockId, locationId} so we can
      // build the header and match the loaded sessionData.
      showShiftDetail: false,
      shiftDetailTarget: null,
      shiftPdfBusy: false,
      savedScrollY: 0,
      pdfLoadSuccess: true,
      pdfData: null,
      scale: DEFAULT_PDF_ZOOM,
      isSettings: false,
      showAuditLog: false,
      managerSummary: null,
      editedWeeklyNetProfit: null,
      editMode: false,
      editSummaryMode: false,
      deliveryInputValues: {
        cash: '0',
        managerZelle: '0',
        atmReceipts: '0',
        atmAdv: '0',
      },
      pdfPopperAnchor: null,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
      selectedTab: resolveInitialTab(props.userInfo, restore?.selectedTab),
      // Daily Analysis breakdown collapse — collapsed by default; resets to
      // collapsed whenever the selected day or tab changes (spec §8).
      dailyAnalysisOpen: false,
      atmTransactions: [
        {
          type: 'ATM_CASH' | 'ATM_FROM_PROFIT' | 'ATM_DIDNT_USE' | 'ATM_ADV',
          amount: 0,
          permanent: false,
        },
      ],
    };

    this.pdfBtnRef = React.createRef();
    this.dayRowRef = React.createRef();
    this.shiftPdfRef = React.createRef();
  }

  componentDidMount() {
    this.props.listSessionIds(
      this.getChicagoDateFromDate(this.state.fromDate),
      this.getChicagoDateFromDate(this.state.toDate),
      this.props.userInfo.selectedLocationId
    );
    this.props.getManagerSummary({
      locationId: this.props.userInfo?.selectedLocationId,
    });
    // Lookup data the interactive ShiftDetail overlay needs to enrich
    // transaction rows (customer/employee names) and the Manager
    // Modifications list when opened from the audit-log chip.
    const locationId = this.props.userInfo?.selectedLocationId;
    if (locationId) {
      this.props.listAllCustomers({ locationId });
      this.props.getEmployees({ locationId });
      this.props.listManageBonus({ locationId });
      this.props.listCategory({ locationId });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.managerSummary !== this.props.managerSummary) {
      const delivery = this.props.managerSummary?.delivery;
      this.setState({
        managerSummary: this.withManagerNameFallback(this.props.managerSummary),
        deliveryInputValues: {
          cash: String(delivery?.cash ?? 0),
          managerZelle: String(delivery?.managerZelle ?? 0),
          atmReceipts: String(delivery?.atmReceipts ?? 0),
          atmAdv: String(delivery?.atmAdv ?? 0),
        },
      });
    }

    // Manager Settings may arrive AFTER managerSummary on first load.
    // If they do and the summary's managerName is still blank, retro-fill
    // it from the setting so the ATM Cash Flow header isn't empty.
    if (
      prevProps.managerSetting !== this.props.managerSetting &&
      this.state.managerSummary &&
      !String(this.state.managerSummary.managerName || '').trim()
    ) {
      const filled = this.withManagerNameFallback(this.state.managerSummary);
      if (filled !== this.state.managerSummary) {
        this.setState({ managerSummary: filled });
      }
    }

    if (prevProps.allSessionIds !== this.props.allSessionIds) {
      this.setState({ selectedSessionIds: this.props.allSessionIds }, () => {
        this.refreshComponent(this.state.selectedSessionIds);
        // Keep the Daily Analysis tab populated when the week's sessions load —
        // covers restoring onto this tab (back from Match Tickets) and changing
        // the week while it is open.
        if (this.state.selectedTab === 'dailyAnalysis') {
          this.fetchShortAnalysis();
        }
      });
    }

    if (
      !this.arrayEquals(prevProps.PDFPreviewReady, this.props.PDFPreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFPreviewReady,
      });
    }

    // Auto-select first day when report data arrives and no day is selected
    if (
      this.props.report &&
      Object.keys(this.props.report).length > 0 &&
      (!this.state.selectedDay || !this.props.report[this.state.selectedDay]) &&
      prevProps.report !== this.props.report // only fire when report actually changes
    ) {
      const days = Object.keys(this.props.report);
      if (days.length > 0) {
        this.handleDaySelect(days[0]);
        // Scroll the day row into view so the days are at the top
        // and the session ID input is above the fold.
        setTimeout(() => {
          if (this.dayRowRef.current) {
            this.dayRowRef.current.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 100);
      }
    }
  }

  handlePdfPopperToggle = () => {
    this.setState((prev) => ({
      pdfPopperAnchor: prev.pdfPopperAnchor ? null : this.pdfBtnRef.current,
    }));
  };

  handlePdfPopperClose = () => {
    this.setState({ pdfPopperAnchor: null });
  };

  handlePdfOptionSelect = (mode) => {
    this.downloadWeeklyPdf(mode);
    this.setState({ pdfPopperAnchor: null });
  };

  //report

  showPdfErrorMessage = (isFailed) => {
    this.props.resetGlobalPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  closePdfViewer = () => {
    const scrollY = this.state.savedScrollY;
    this.setState({ showPdfViewer: false, pdfData: null }, () => {
      setTimeout(() => {
        const el = document.querySelector('.report-container');
        if (el) el.scrollTop = scrollY;
      }, 200);
    });
  };

  // Loads a specific employee shift's report data and opens the new
  // interactive ShiftDetail overlay (read-only) instead of the legacy PDF.
  // Invoked from the Readings tab "Employees Shift" chips and the audit-log
  // "View shift report" rows. `target` carries { userId, locationId, clockId,
  // userName? }. When closed, whatever was mounted underneath (readings tab
  // or audit log) is restored so the manager lands back where they were.
  handleViewShiftReport = (target) => {
    const { userId, locationId, clockId } = target || {};
    if (!userId || !locationId || !clockId) return;
    this.props.loadSessionReports({ userId, locationId, clockId });
    const rc = document.querySelector('.report-container');
    this.setState({
      showShiftDetail: true,
      shiftDetailTarget: target,
      savedScrollY: rc ? rc.scrollTop : 0,
    });
  };

  closeShiftDetail = () => {
    const scrollY = this.state.savedScrollY;
    this.props.clearSessionReports();
    this.setState({ showShiftDetail: false, shiftDetailTarget: null }, () => {
      setTimeout(() => {
        const el = document.querySelector('.report-container');
        if (el) el.scrollTop = scrollY;
      }, 200);
    });
  };

  // Snapshot the offscreen PdfBody (mounted in renderShiftDetail) into a PDF,
  // mirroring EmployeeSession.handleDownloadPdf. `sessionMeta` is the same
  // { id, employee, clockIn, clockOut, hoursWorked, assignedDay } shape the
  // PdfBody/suggestedFilename expect.
  handleDownloadShiftPdf = async (sessionMeta) => {
    if (!this.shiftPdfRef.current || this.state.shiftPdfBusy || !sessionMeta) {
      return;
    }
    this.setState({ shiftPdfBusy: true });
    try {
      const buffer = await generateSessionPdf({
        element: this.shiftPdfRef.current,
      });
      if (!buffer) return;
      const locationName = this.props.userInfo?.selectedLocationName;
      Utils.handlePdfAction(
        buffer,
        'download',
        suggestedFilename({ type: 'shift', session: sessionMeta, locationName })
      );
    } finally {
      this.setState({ shiftPdfBusy: false });
    }
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const timestamp = date.getTime();
    const fileName = `Shift Report - ${getTodayDate} - ${timestamp}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  //end report

  handleEditClick = (field, value) => {
    this.setState((prevState) => ({
      editingFields: {
        ...prevState.editingFields,
        [field]: true,
      },
      fieldValues: {
        ...prevState.fieldValues,
        [field]: value,
      },
    }));
  };

  // Amount + reason belong together in one form, saved in one request.
  // The inline row could not hold both without squeezing each into half a
  // column, and the reason is the part people actually need to read back.
  openNoteEditor = (field, label, selectedReport) => {
    this.setState({
      noteEditor: {
        open: true,
        field,
        label,
        amount: String(selectedReport[field] ?? 0),
        // Seeded with what is saved, so reopening to change the figure
        // does not silently drop the reason attached to it.
        note: selectedReport.loanInNote || '',
        savedBy: selectedReport.loanInNoteBy || '',
      },
    });
  };

  closeNoteEditor = () => {
    this.setState((prev) => ({
      noteEditor: { ...prev.noteEditor, open: false },
    }));
  };

  handleNoteEditorChange = (key, value) => {
    this.setState((prev) => ({
      noteEditor: { ...prev.noteEditor, [key]: value },
    }));
  };

  saveNoteEditor = () => {
    const { field, amount, note } = this.state.noteEditor;

    // Mandatory. The button is disabled without one; this is the guard
    // behind it, and the server refuses the write regardless.
    if (!(note || '').trim()) return;
    const { report } = this.props;
    const { selectedDay } = this.state;
    const selectedReport = (report && report[selectedDay]) || {};

    const callback = (success, message) => {
      if (!success) {
        this.openFeedbackBar('error', message);
        return;
      }
      this.closeNoteEditor();
      this.refreshComponent(this.state.selectedSessionIds);
    };

    this.props.updateReportField(
      selectedReport.sessionIds,
      field,
      parseFloat(amount) || 0,
      this.props.userInfo.selectedLocationId,
      callback,
      (note || '').trim()
    );
  };

  handleFieldChange = (field, event) => {
    const value = event.target.value;
    this.setState((prevState) => ({
      fieldValues: {
        ...prevState.fieldValues,
        [field]: value,
      },
    }));
  };

  handleApplyClick = (field) => {
    const { fieldValues } = this.state;
    const newValue = parseFloat(fieldValues[field]) || 0;

    const { report } = this.props;
    const { selectedDay } = this.state;

    const hasReportData = report && Object.keys(report).length > 0;
    const selectedReport = hasReportData ? report[selectedDay] || {} : {};

    const callback = (success, message) => {
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.setState((prevState) => ({
          editingFields: {
            ...prevState.editingFields,
            [field]: false,
          },
        }));

        this.refreshComponent(this.state.selectedSessionIds);
      }
    };

    this.props.updateReportField(
      selectedReport.sessionIds,
      field,
      newValue,
      this.props.userInfo.selectedLocationId,
      callback
    );
  };

  handleBankBoardUpdate = (amount, nameInput, type) => {
    const { report } = this.props;
    const { selectedDay } = this.state;
    const selectedReport = report[selectedDay] || {};
    const data = {
      sessionIds: selectedReport.sessionIds,
      locationId: this.props.userInfo.selectedLocationId,
      amount: amount,
      nameInput: nameInput,
      employeeName: this.props.userInfo.firstname,
      type: type,
    };

    this.props.updateManagerBank(data, (success, message) => {
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.refreshComponent(this.state.selectedSessionIds);
      }
    });
  };

  // ── Manager Loan To Bank — owner edit / delete ────────────────────────
  // A board row is either a manager entry (lives in the reading session's
  // managerBank list) or an employee bank transaction. The row carries its
  // own identity from the server, so the same handlers cover both and the
  // server routes on `source`.
  bankEntryPayload = (trx) => {
    const { report } = this.props;
    const selectedReport = report[this.state.selectedDay] || {};
    const { userInfo } = this.props;
    return {
      sessionIds: selectedReport.sessionIds,
      locationId: userInfo.selectedLocationId,
      source: trx.source,
      entryId: trx.entryId,
      readingSessionId: trx.readingSessionId,
      transactionId: trx.transactionId,
      modifiedBy: userInfo.userId,
      modifiedByName:
        userInfo.displayName || userInfo.firstname || userInfo.username,
    };
  };

  handleOpenBankEntryEdit = (trx) => {
    this.setState({
      bankEntryToEdit: trx,
      bankEditAmount: String(Math.abs(Number(trx.amount) || 0)),
      bankEditName: trx.userName === 'N/A' ? '' : trx.userName || '',
      bankEditType: Number(trx.amount) < 0 ? 'minus' : 'add',
    });
  };

  handleCloseBankEntryEdit = () => {
    this.setState({ bankEntryToEdit: null });
  };

  handleSaveBankEntryEdit = () => {
    const { bankEntryToEdit, bankEditAmount, bankEditName, bankEditType } =
      this.state;
    if (!bankEntryToEdit || !bankEditAmount || !bankEditName.trim()) return;

    this.setState({ bankEntryBusy: true });
    this.props.editBankBoardEntry(
      {
        ...this.bankEntryPayload(bankEntryToEdit),
        amount: parseInt(bankEditAmount, 10),
        nameInput: bankEditName.trim(),
        type: bankEditType,
      },
      (success, message) => {
        this.setState({ bankEntryBusy: false });
        if (!success) {
          this.openFeedbackBar('error', message);
          return;
        }
        this.setState({ bankEntryToEdit: null });
        this.openFeedbackBar('success', 'Bank entry updated.');
        this.refreshComponent(this.state.selectedSessionIds);
      }
    );
  };

  handleConfirmBankEntryDelete = () => {
    const { bankEntryToDelete } = this.state;
    if (!bankEntryToDelete) return;

    this.setState({ bankEntryBusy: true });
    this.props.deleteBankBoardEntry(
      this.bankEntryPayload(bankEntryToDelete),
      (success, message) => {
        this.setState({ bankEntryBusy: false });
        if (!success) {
          this.openFeedbackBar('error', message);
          return;
        }
        this.setState({ bankEntryToDelete: null });
        this.openFeedbackBar('success', 'Bank entry removed.');
        this.refreshComponent(this.state.selectedSessionIds);
      }
    );
  };

  handleNameChange = (e) => {
    this.setState({ nameInput: e.target.value });
  };

  handleAmountChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // numbers only
    this.setState({ amountInput: value });
  };

  handleTypeChange = (e) => {
    this.setState({ type: e.target.value });
  };

  handleApply = () => {
    const { amountInput, type, nameInput } = this.state;
    if (!amountInput || !type || !nameInput) return;

    const amount = parseInt(amountInput, 10);
    this.handleBankBoardUpdate(amount, nameInput, type === 'add');

    this.setState({ amountInput: '', type: '', nameInput: '' });
  };

  handleCommentOpenDialog = (comment) => {
    this.setState({ isCommentDialogOpen: true, selectedComment: comment });
  };

  handleCommentCloseDialog = () => {
    this.setState({ isCommentDialogOpen: false, selectedComment: '' });
  };

  handleDaySelect = (day) => {
    // Changing the day resets the Daily Analysis breakdown to collapsed (spec §8).
    this.setState({ selectedDay: day, dailyAnalysisOpen: false });
  };

  // Weekly Report tabs this company's plan includes. Standard gets the
  // basic report (Cash Flow / Readings / Expenses / Closing Balance /
  // Percentages); Manager Loan and Daily Analysis are paid-tier.
  visibleTabs = () => allowedWeeklyTabs(this.props.userInfo, WEEKLY_TABS);

  handleTabSelect = (tabKey) => {
    // Switching tabs resets the Daily Analysis breakdown to collapsed (spec §8).
    this.setState({ selectedTab: tabKey, dailyAnalysisOpen: false });
    if (tabKey === 'dailyAnalysis') {
      this.fetchShortAnalysis();
    }
  };

  // "Totals by Machine Type" card for the Readings tab. Data comes from the
  // weekly-report response (selectedReport.machineTypeTotals) which the server
  // aggregates per day, mirroring the Master Reading PDF's summary. Columns:
  // In → Out → Difference (In − Out) → Points → Bonus → Net (Diff − Points −
  // Bonus). Rows with no activity are hidden; a navy total row footers it.
  renderMachineTypeTotalsCard = (selectedReport) => {
    const raw = selectedReport?.machineTypeTotals || [];
    const rows = raw.filter(
      (r) => r.inValue || r.outValue || r.points || r.bonus
    );
    if (rows.length === 0) return null;

    const money = (n) =>
      (n < 0 ? '-$' : '$') +
      Math.abs(Math.round(n || 0)).toLocaleString('en-US');
    const num = (n) => Math.round(n || 0).toLocaleString('en-US');
    const totals = rows.reduce(
      (a, r) => ({
        inValue: a.inValue + (r.inValue || 0),
        outValue: a.outValue + (r.outValue || 0),
        difference: a.difference + (r.difference || 0),
        points: a.points + (r.points || 0),
        bonus: a.bonus + (r.bonus || 0),
        net: a.net + (r.net || 0),
      }),
      { inValue: 0, outValue: 0, difference: 0, points: 0, bonus: 0, net: 0 }
    );

    const NAVY = '#0a0e2a';
    const MUTED = '#6b7280';
    const GREEN = '#0f8a5f';
    const RED = '#c8443c';
    const BORDER = '#e5e7f2';
    const th = (align = 'right', divider = false) => ({
      textAlign: align,
      padding: '8px 10px',
      fontSize: 10,
      letterSpacing: 0.6,
      textTransform: 'uppercase',
      fontWeight: 700,
      color: MUTED,
      borderBottom: `1px solid ${BORDER}`,
      borderLeft: divider ? `1px solid ${BORDER}` : 'none',
      whiteSpace: 'nowrap',
    });
    const td = (color = NAVY, weight = 500) => ({
      padding: '7px 10px',
      textAlign: 'right',
      fontSize: 12,
      fontWeight: weight,
      color,
      whiteSpace: 'nowrap',
    });
    const foot = (color = '#fff', weight = 700) => ({
      padding: '9px 10px',
      textAlign: 'right',
      fontSize: 12,
      fontWeight: weight,
      color,
      whiteSpace: 'nowrap',
    });

    return (
      <div
        style={{
          marginTop: 20,
          background: '#fff',
          border: `1px solid ${BORDER}`,
          borderRadius: 12,
          overflow: 'hidden',
        }}
      >
        <div style={{ background: NAVY, padding: '12px 14px' }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>
            Totals by Machine Type
          </div>
          <div style={{ marginTop: 2, fontSize: 11, color: '#b9bde8' }}>
            {rows.length} machine types
          </div>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table
            style={{
              width: '100%',
              minWidth: 560,
              borderCollapse: 'collapse',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            <thead>
              <tr>
                <th style={th('left')}>Machine Type</th>
                <th style={th('right')}>In</th>
                <th style={th('right')}>Out</th>
                <th style={th('right', true)}>Difference</th>
                <th style={th('right')}>Points</th>
                <th style={th('right')}>Bonus</th>
                <th style={th('right', true)}>Net</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.type} style={{ borderBottom: '1px solid #f2f3f8' }}>
                  <td
                    style={{
                      padding: '7px 10px',
                      fontSize: 12,
                      fontWeight: 600,
                      color: NAVY,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {r.type}
                  </td>
                  <td style={td()}>{money(r.inValue)}</td>
                  <td style={td(MUTED)}>{money(r.outValue)}</td>
                  <td
                    style={{
                      ...td(r.difference >= 0 ? NAVY : RED, 700),
                      borderLeft: `1px solid ${BORDER}`,
                      background: '#fbfbfe',
                    }}
                  >
                    {money(r.difference)}
                  </td>
                  <td style={td()}>{num(r.points)}</td>
                  <td style={td()}>{num(r.bonus)}</td>
                  <td
                    style={{
                      ...td(r.net === 0 ? MUTED : r.net > 0 ? GREEN : RED, 700),
                      borderLeft: `1px solid ${BORDER}`,
                    }}
                  >
                    {money(r.net)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: NAVY }}>
                <td
                  style={{
                    padding: '9px 10px',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: 11,
                    letterSpacing: 0.8,
                    textTransform: 'uppercase',
                  }}
                >
                  Total
                </td>
                <td style={foot('#fff')}>{money(totals.inValue)}</td>
                <td style={foot('#b9bde8')}>{money(totals.outValue)}</td>
                <td style={{ ...foot('#fff'), background: '#141a3d' }}>
                  {money(totals.difference)}
                </td>
                <td style={foot('#fff')}>{num(totals.points)}</td>
                <td style={foot('#fff')}>{num(totals.bonus)}</td>
                <td
                  style={{
                    ...foot(totals.net >= 0 ? '#4ade9b' : '#ff8b83', 800),
                    fontSize: 13,
                    background: '#141a3d',
                  }}
                >
                  {money(totals.net)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  };

  fetchShortAnalysis = () => {
    const sessionIds = this.state.selectedSessionIds;
    if (!sessionIds || sessionIds.length === 0) return;
    this.props.listShortAnalysis({
      sessionIds,
      locationId: this.props.userInfo.selectedLocationId,
    });
  };

  // Navigate from Daily Analysis (Block C) to the Match Tickets screen for the
  // selected day's reading session. The current week/day/tab is passed along as
  // `restoreReport` so Match Tickets' Back button lands the user back on this
  // exact Weekly Report view instead of the default (current week).
  openMatchTicketsForDay = (dayData) => {
    if (!this.props.history) return;
    const { fromDate, toDate, selectedDay } = this.state;
    const daySessionIds = (dayData && dayData.sessionIds) || [];
    const sessionId = daySessionIds[0] || null;
    const toMs = (d) => (d instanceof Date ? d.getTime() : d);
    this.props.history.push('/master-reading', {
      // When we have the day's reading session, deep-link straight into its
      // Match Tickets view; otherwise fall back to the reading table.
      openMatchTickets: !!sessionId,
      sessionId,
      locationId: this.props.userInfo?.selectedLocationId,
      restoreReport: {
        fromDate: toMs(fromDate),
        toDate: toMs(toDate),
        selectedDay,
        selectedTab: 'dailyAnalysis',
      },
    });
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    });
  };

  refreshComponent = (sessionIds) => {
    this.props.listReport({
      sessionIds: sessionIds,
      locationId: this.props.userInfo.selectedLocationId,
    });
    // Pre-fetch audit logs for the selected sessions so the toolbar
    // button can show/flash if entries exist. Only fires for users
    // authorized to view the audit log (the backend also enforces this).
    if (this.canViewAuditLog() && sessionIds && sessionIds.length > 0) {
      this.props.listWeeklyReportAudit({
        locationId: this.props.userInfo.selectedLocationId,
        readingSessionIds: sessionIds,
      });
    }
  };

  canViewAuditLog = () => {
    // Change history is a paid-tier feature -- Standard sees the report's
    // current state only. Gating it here also suppresses the audit fetch
    // (refreshComponent above guards on it), so the flashing Audit Log
    // button can never appear on a late response.
    if (!canViewAuditHistory(this.props.userInfo)) return false;
    const roles = this.props.userInfo?.authority || [];
    return (
      roles.includes('ROLE_OWNER') ||
      roles.includes('ROLE_MASTER_ADMIN') ||
      roles.includes('ROLE_TECH_ADMIN') ||
      roles.includes('ROLE_MANAGER')
    );
  };

  hasAuditLogForCurrentSessions = () => {
    const logs = this.props.weeklyReportAuditLogs || [];
    const sessionIds = this.state.selectedSessionIds || [];
    if (!logs.length || !sessionIds.length) return false;
    const idSet = new Set(sessionIds.map(String));
    return logs.some((l) => idSet.has(String(l.readingSessionId)));
  };

  dateSelectRow = () => {
    const { selectedDay, selectedTab } = this.state;
    const { report } = this.props;

    const hasReportData = report && Object.keys(report).length > 0;
    const firstAvailableDay = hasReportData ? Object.keys(report)[0] : null;
    const dayToUse = selectedDay || firstAvailableDay;
    const isDayChip =
      dayToUse && dayToUse !== 'MANAGER' && dayToUse !== 'SUMMARY';

    if (!hasReportData) return null; // return nothing while loading

    return (
      <div className="dateselectroww">
        <div className="chip-container">
          {Object.keys(report).map((day) => (
            <div
              key={day}
              className={`chip ${dayToUse === day ? 'chip-selected' : ''}`}
              onClick={() => this.handleDaySelect(day)}
            >
              {day}
            </div>
          ))}

          {this.state.managerSummary && this.userHasATMRole() && (
            <div
              key="MANAGER_SUMMARY"
              className={`chip ${
                dayToUse === 'MANAGER' ? 'chip-selected' : ''
              }`}
              onClick={() => this.handleDaySelect('MANAGER')}
            >
              Manager
            </div>
          )}

          <div
            key="SUMMARY"
            className={`chip ${dayToUse === 'SUMMARY' ? 'chip-selected' : ''}`}
            onClick={() => this.handleDaySelect('SUMMARY')}
          >
            Summary
          </div>
        </div>

        {isDayChip && (
          <div className="weekly-tabs-bar">
            <div className="weekly-tabs-list">
              {this.visibleTabs().map((t) => {
                const isActive = selectedTab === t.key;
                return (
                  <div
                    key={t.key}
                    className={`weekly-tab ${
                      isActive ? 'weekly-tab-selected' : ''
                    }`}
                    onClick={() => this.handleTabSelect(t.key)}
                  >
                    <span className="weekly-tab-icon">{t.emoji}</span>
                    <span className="weekly-tab-label">{t.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Returns true if the current user is allowed to edit (manager summary
  // + per-day fields) the report for `this.state.fromDate`.
  //
  //  - Mondays: always editable so the prior week's manager summary stays
  //    open for finalization regardless of whether the week was ended.
  //  - ROLE_OWNER: always editable.
  //  - ROLE_MASTER_ADMIN / ROLE_MANAGER: editable for any report whose
  //    fromDate is within the last 14 days (two-week grace window).
  //  - Everyone else (ROLE_SUPERVISOR, ROLE_READING_GUY, …): editable
  //    only while the report falls within the current Tue-anchored week.
  canEditReport = () => {
    // A VIEW-ONLY location is read-only regardless of role or date window.
    // Checked first because every other branch below can return true.
    // This is the single gate for the whole weekly-report edit surface —
    // per-day fields, manager summary, ATM cash flow — so one check here
    // covers all of them. See constants/readOnlyAccess.js.
    if (this.props.viewOnly) return false;

    const roles = this.props.userInfo?.authority || [];
    const fromDate = this.state.fromDate;
    if (!fromDate) return true;

    const todayHouston = this.getHoustonToday();
    if (todayHouston.getUTCDay() === 1) return true;

    if (roles.includes('ROLE_OWNER')) return true;

    if (roles.includes('ROLE_MASTER_ADMIN') || roles.includes('ROLE_MANAGER')) {
      const twoWeeksAgo = new Date(todayHouston);
      twoWeeksAgo.setDate(todayHouston.getDate() - 14);
      twoWeeksAgo.setHours(0, 0, 0, 0);
      return fromDate >= twoWeeksAgo;
    }

    const currentDay = todayHouston.getDay();
    const diffToLastTuesday =
      currentDay >= 2 ? currentDay - 2 : 7 - (2 - currentDay);
    const thisWeekStart = new Date(todayHouston);
    thisWeekStart.setDate(todayHouston.getDate() - diffToLastTuesday);
    thisWeekStart.setHours(0, 0, 0, 0);
    return fromDate >= thisWeekStart;
  };

  getHoustonToday() {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const parts = formatter.formatToParts(new Date());

    let year, month, day;
    parts.forEach((p) => {
      if (p.type === 'year') year = p.value;
      if (p.type === 'month') month = p.value;
      if (p.type === 'day') day = p.value;
    });

    // Create a Date that represents midnight Houston time
    return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
  }

  getChicagoDateFromDate(date) {
    // Get the Chicago date parts
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const parts = formatter.formatToParts(date);
    let year, month, day;

    for (const part of parts) {
      switch (part.type) {
        case 'year':
          year = part.value;
          break;
        case 'month':
          month = part.value;
          break;
        case 'day':
          day = part.value;
          break;
        default:
          break;
      }
    }
    // Return only YYYY-MM-DD
    return `${year}-${month}-${day}`;
  }

  applyDateRange = () => {
    const { fromDate, toDate } = this.state;
    const fromDateInChicago = this.getChicagoDateFromDate(fromDate);
    const toDateInChicago = this.getChicagoDateFromDate(toDate);

    this.props.listSessionIds(
      fromDateInChicago,
      toDateInChicago,
      this.props.userInfo.selectedLocationId
    );
    this.clearSessionId();
    this.setState({ isDialogOpen: false });
  };

  handleDialogOpen = () => {
    this.setState({ isDialogOpen: true });
  };

  handleDialogClose = () => {
    this.setState({ isDialogOpen: false });
  };

  clearSessionId = () => {
    this.setState({ selectedSessionIds: [] }, () => {
      this.props.clearWeeklyReport();
    });
  };

  recomputeAdjustedTotal = (managerSummary, newAdjustments) => {
    const totalAdditions = (newAdjustments.additions || []).reduce(
      (sum, a) => sum + (parseFloat(a.amount) || 0),
      0
    );
    const totalDeductions = (newAdjustments.deductions || []).reduce(
      (sum, d) => sum + (parseFloat(d.amount) || 0),
      0
    );
    const ownerBase =
      managerSummary.ownerProfit != null
        ? managerSummary.ownerProfit
        : managerSummary.remainingProfit;
    return (ownerBase || 0) + totalAdditions - totalDeductions;
  };

  addAdjustmentRow = (type) => {
    const { managerSummary } = this.state;
    const newAdjustments = {
      ...managerSummary.adjustments,
      [type]: [
        ...(managerSummary.adjustments[type] || []),
        {
          description: '',
          amount: '',
          assignedTo: '',
        },
      ],
    };
    newAdjustments.adjustedTotal = this.recomputeAdjustedTotal(
      managerSummary,
      newAdjustments
    );
    this.setState({
      managerSummary: { ...managerSummary, adjustments: newAdjustments },
    });
  };

  removeAdjustmentRow = (type, index) => {
    const { managerSummary } = this.state;
    const newAdjustments = {
      ...managerSummary.adjustments,
      [type]: (managerSummary.adjustments[type] || []).filter(
        (_, i) => i !== index
      ),
    };
    newAdjustments.adjustedTotal = this.recomputeAdjustedTotal(
      managerSummary,
      newAdjustments
    );
    this.setState({
      managerSummary: { ...managerSummary, adjustments: newAdjustments },
    });
  };

  handleAdjustmentChange = (type, index, field, value) => {
    const { managerSummary } = this.state;

    // 1. Create a shallow copy of the additions/deductions array
    const currentList = [...managerSummary.adjustments[type]];

    // 2. Create a brand new object for the item being changed
    currentList[index] = {
      ...currentList[index],
      [field]: value,
    };

    // 3. Create the new adjustments state object
    const newAdjustments = {
      ...managerSummary.adjustments,
      [type]: currentList,
    };

    // 4. Calculate totals
    const totalAdditions = newAdjustments.additions.reduce(
      (sum, a) => sum + (parseFloat(a.amount) || 0),
      0
    );
    const totalDeductions = newAdjustments.deductions.reduce(
      (sum, d) => sum + (parseFloat(d.amount) || 0),
      0
    );
    const ownerBase =
      managerSummary.ownerProfit != null
        ? managerSummary.ownerProfit
        : managerSummary.remainingProfit;
    const adjustedTotal = (ownerBase || 0) + totalAdditions - totalDeductions;

    // 5. Apply to state
    this.setState({
      managerSummary: {
        ...managerSummary,
        adjustments: {
          ...newAdjustments,
          adjustedTotal,
        },
      },
    });
  };

  handleSaveManagerSummary = () => {
    const { managerSummary } = this.state;

    const { additions, deductions } = managerSummary.adjustments;
    const { otherItems } = managerSummary;

    // Helper function to validate rows
    const validateRows = (rows, typeLabel) => {
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];

        if (!row.assignedTo) {
          this.openFeedbackBar(
            'error',
            `${typeLabel} row #${i + 1}: Please select Assign To.`
          );
          return false;
        }

        if (!row.description || !row.description.trim()) {
          this.openFeedbackBar(
            'error',
            `${typeLabel} row #${i + 1}: Description cannot be empty.`
          );
          return false;
        }

        if (
          row.amount === '' ||
          row.amount === null ||
          row.amount === undefined
        ) {
          this.openFeedbackBar(
            'error',
            `${typeLabel} row #${i + 1}: Amount cannot be empty.`
          );
          return false;
        }

        if (isNaN(parseFloat(row.amount))) {
          this.openFeedbackBar(
            'error',
            `${typeLabel} row #${i + 1}: Amount must be a valid number.`
          );
          return false;
        }
      }

      return true;
    };

    // Validate Additions
    if (!validateRows(additions, 'Addition')) return;

    // Validate Deductions
    if (!validateRows(deductions, 'Deduction')) return;

    // Validate Other Items
    if (!validateRows(otherItems, 'Other')) return;

    // $5 rule: Adjusted Total and Total Delivered must agree within
    // DELIVERY_VS_ADJUSTED_TOLERANCE. A larger gap is almost always a
    // data-entry mistake — saving anyway would lock a real accounting
    // discrepancy into the manager summary, so block the request.
    const { delta } = this.getDeliveryDelta();
    const tol = ReportView.DELIVERY_VS_ADJUSTED_TOLERANCE;
    if (Math.abs(delta) > tol) {
      const comparison = delta > 0 ? 'less than' : 'more than';
      // FeedbackBar.jsx splits messages on the literal "$" (each "$"
      // becomes a line break + a "See logs for more detail" link),
      // so use the fullwidth dollar U+FF04 — it looks like "$" but
      // does NOT trigger that split. Don't change to a literal "$".
      this.openFeedbackBar(
        'error',
        `Total Delivered is ＄${this.fmtMoney2(
          Math.abs(delta)
        )} ${comparison} Adjusted Total. The two must match within ＄${this.fmtMoney2(
          tol
        )} before saving.`
      );
      return;
    }

    // If all validations pass
    const payload = {
      locationId: this.props.userInfo.selectedLocationId,
      sessionId: managerSummary.sessionId,
      managerSummary,
    };

    this.props.saveManagerSummary(payload, (success, message) => {
      if (success) {
        this.openFeedbackBar('success', message);
        this.setState({ editMode: false }); // move it here after success
      } else {
        this.openFeedbackBar('error', message);
      }
    });
  };

  handleAddOther = () => {
    this.setState((prevState) => {
      // 1. Create the new row with ALL required fields
      const newItem = {
        description: '',
        amount: '',
        assignedTo: '',
      };

      const updatedOtherItems = [
        ...(prevState.managerSummary.otherItems || []),
        newItem,
      ];

      // 2. Recalculate totals immediately
      const delivery = prevState.managerSummary.delivery || {};
      const deliveryTotal =
        (parseFloat(delivery.cash) || 0) +
        (parseFloat(delivery.managerZelle) || 0) +
        (parseFloat(delivery.atmReceipts) || 0);

      const otherTotal = updatedOtherItems.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      const totalDelivered = deliveryTotal + otherTotal;

      // 3. Update the state
      return {
        managerSummary: {
          ...prevState.managerSummary,
          otherItems: updatedOtherItems,
          delivery: {
            ...prevState.managerSummary.delivery,
            totalDelivered,
          },
        },
      };
    });
  };

  handleRemoveOther = (index) => {
    this.setState((prevState) => {
      const updatedOtherItems = prevState.managerSummary.otherItems.filter(
        (_, i) => i !== index
      );

      const deliveryTotal =
        (prevState.managerSummary.delivery.cash || 0) +
        (prevState.managerSummary.delivery.managerZelle || 0) +
        (prevState.managerSummary.delivery.atmReceipts || 0) +
        (prevState.managerSummary.delivery.atmAdv || 0);

      const otherTotal = updatedOtherItems.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      const totalDelivered = deliveryTotal + otherTotal;

      return {
        managerSummary: {
          ...prevState.managerSummary,
          otherItems: updatedOtherItems,
          delivery: {
            ...prevState.managerSummary.delivery,
            totalDelivered,
          },
        },
      };
    });
  };

  handleOtherChange = (index, field, value) => {
    this.setState((prevState) => {
      // 1. Create a shallow copy of the array
      const updatedOtherItems = [...prevState.managerSummary.otherItems];

      // 2. Create a BRAND NEW object for the item at this index
      // This is the "Magic" that makes the UI/Chips update instantly
      const updatedItem = {
        ...updatedOtherItems[index],
        [field]: value,
      };

      // 3. Handle specific parsing for the Amount field
      if (field === 'amount') {
        // Allow empty string while typing, otherwise parse it
        updatedItem.amount = value === '' ? '' : parseFloat(value) || 0;
      }

      // 4. Put the new item back into our array copy
      updatedOtherItems[index] = updatedItem;

      // 5. Recalculate totals
      const delivery = prevState.managerSummary.delivery || {};
      const deliveryTotal =
        (parseFloat(delivery.cash) || 0) +
        (parseFloat(delivery.managerZelle) || 0) +
        (parseFloat(delivery.atmReceipts) || 0) +
        (parseFloat(delivery.atmAdv) || 0);

      const otherTotal = updatedOtherItems.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      const totalDelivered = deliveryTotal + otherTotal;

      // 6. Return the new state
      return {
        managerSummary: {
          ...prevState.managerSummary,
          otherItems: updatedOtherItems,
          delivery: {
            ...prevState.managerSummary.delivery,
            totalDelivered,
          },
        },
      };
    });
  };

  handleWeeklyNetProfitBlur = (weeklyProfit) => {
    const { managerSummary } = this.state;
    if (weeklyProfit === null || weeklyProfit === '') return;

    weeklyProfit = parseFloat(weeklyProfit) || 0;

    const managerPct = parseFloat(managerSummary.manager.percentage) || 0;
    const profitThreshold =
      parseFloat(managerSummary.manager.profitThreshold) || 0;

    let managerShare = 0;
    if (weeklyProfit > profitThreshold) {
      const profitAboveThreshold = weeklyProfit - profitThreshold;
      managerShare = +(profitAboveThreshold * (managerPct / 100)).toFixed(2);
    }

    const remainingProfit = +(weeklyProfit - managerShare).toFixed(2);

    const additionsTotal = (managerSummary.adjustments.additions || []).reduce(
      (sum, item) => sum + (parseFloat(item.amount) || 0),
      0
    );
    const deductionsTotal = (
      managerSummary.adjustments.deductions || []
    ).reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

    // Recompute partner shares off the new remaining profit. Percentages come from
    // the summary's own (frozen) partner list — no live settings lookup.
    const partners = (managerSummary.partners || []).map((p) => {
      const pct = parseFloat(p.percentage) || 0;
      return {
        ...p,
        share: +(remainingProfit * (pct / 100)).toFixed(2),
      };
    });
    const totalPartnerShare = +partners
      .reduce((sum, p) => sum + (p.share || 0), 0)
      .toFixed(2);
    const ownerProfit = +(remainingProfit - totalPartnerShare).toFixed(2);

    // Adjusted Total is what the manager reconciles/delivers to the owner(s), so it
    // starts from the owners' remaining profit (after manager AND partners).
    const adjustedTotal = +(
      ownerProfit +
      additionsTotal -
      deductionsTotal
    ).toFixed(2);

    this.setState({
      editedWeeklyNetProfit: null, // ← clear after blur
      managerSummary: {
        ...managerSummary,
        weeklyNetProfit: weeklyProfit,
        isWeeklyNetProfitEdited: true,
        manager: {
          ...managerSummary.manager,
          share: managerShare,
        },
        remainingProfit: remainingProfit,
        partners: partners,
        totalPartnerShare: totalPartnerShare,
        ownerProfit: ownerProfit,
        adjustments: {
          ...managerSummary.adjustments,
          adjustedTotal: adjustedTotal,
        },
      },
    });
  };

  handleDeliveryFocus = (field) => {
    this.setState((prevState) => ({
      deliveryInputValues: {
        ...prevState.deliveryInputValues,
        [field]:
          prevState.deliveryInputValues[field] === '0'
            ? ''
            : prevState.deliveryInputValues[field],
      },
    }));
  };

  handleDeliveryBlur = (field) => {
    this.setState((prevState) => {
      const raw = prevState.deliveryInputValues[field];
      if (raw === '' || raw === '-') {
        return {
          deliveryInputValues: {
            ...prevState.deliveryInputValues,
            [field]: '0',
          },
        };
      }
      return null;
    });
  };

  handleDeliveryChange = (field, value) => {
    // Update the raw string display value
    this.setState((prevState) => ({
      deliveryInputValues: {
        ...prevState.deliveryInputValues,
        [field]: value,
      },
    }));

    // Then update the numeric state (your existing logic)
    this.setState((prevState) => {
      let newValue = parseFloat(value);
      if (isNaN(newValue) || newValue < 0) newValue = 0;

      const updatedDelivery = {
        ...prevState.managerSummary.delivery,
        [field]: newValue,
      };

      const deliveryTotal =
        (updatedDelivery.cash || 0) +
        (updatedDelivery.managerZelle || 0) +
        (updatedDelivery.atmReceipts || 0) +
        (updatedDelivery.atmAdv || 0);

      const otherTotal = (prevState.managerSummary.otherItems || []).reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      // ── Sync delivery fields → matching ATM Cash Flow transactions ──────
      //   atmReceipts → ATM_FROM_PROFIT (ATM Added From Profit)
      //   atmAdv      → ATM_ADV
      // Keeps the two sections from drifting apart when the user edits
      // a value on the delivery side.
      let updatedATMTransactions =
        prevState.managerSummary.atmTransactions || [];
      const SYNC_MAP = {
        atmAdv: 'ATM_ADV',
        atmReceipts: 'ATM_FROM_PROFIT',
      };
      const syncedType = SYNC_MAP[field];
      if (syncedType) {
        const idx = updatedATMTransactions.findIndex(
          (t) => t.type === syncedType
        );
        if (idx > -1) {
          updatedATMTransactions = updatedATMTransactions.map((t, i) =>
            i === idx ? { ...t, amount: newValue } : t
          );
        } else {
          updatedATMTransactions = [
            ...updatedATMTransactions,
            { type: syncedType, amount: newValue, permanent: false },
          ];
        }
      }
      // ─────────────────────────────────────────────────────────────────────

      return {
        managerSummary: {
          ...prevState.managerSummary,
          delivery: {
            ...updatedDelivery,
            totalDelivered: deliveryTotal + otherTotal,
          },
          atmTransactions: updatedATMTransactions, // ← add this line
        },
      };
    });
  };

  handleATMFocus = (index, field, currentValue) => {
    this.setState({
      activeATMField: `${index}-${field}`,
      activeATMValue:
        currentValue === 0 || currentValue === '0' || currentValue == null
          ? ''
          : String(currentValue),
    });
  };

  handleATMBlur = () => {
    this.setState({ activeATMField: null, activeATMValue: '' });
  };

  handleATMChange = (index, field, value) => {
    this.setState((prevState) => {
      if (index === null) {
        // Update top-level Manager Name or Amount
        return {
          managerSummary: {
            ...prevState.managerSummary,
            [field]: value,
          },
        };
      }

      // Update ATM transaction row
      return {
        managerSummary: {
          ...prevState.managerSummary,
          atmTransactions: (prevState.managerSummary.atmTransactions || []).map(
            (atm, i) => {
              if (i !== index) return atm;

              let newValue = value;
              if (field === 'amount') {
                if (value === '') {
                  newValue = '';
                } else {
                  const reg = /^[0-9\b]+(\.[0-9]{0,2})?$/;
                  if (reg.test(value)) {
                    newValue = parseFloat(value);
                  }
                }
              }
              return { ...atm, [field]: newValue };
            }
          ),
        },
      };
    });
  };

  userHasATMRole = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return roles.includes('ROLE_ATM_TRANSACTION');
  };

  isOwner = () => {
    const roles = this.props.userInfo?.authority || [];
    return roles.includes('ROLE_OWNER');
  };

  // Editing or removing an existing Manager Loan To Bank row is limited to
  // the company owner (ROLE_MASTER_ADMIN) and the NDS owner (ROLE_OWNER).
  // Adding a row stays open to anyone who can edit the report. The backend
  // enforces the same pair on /report/editBankBoardEntry|deleteBankBoardEntry.
  canManageBankBoard = () => {
    if (this.props.viewOnly) return false;
    const roles = this.props.userInfo?.authority || [];
    return roles.includes('ROLE_OWNER') || roles.includes('ROLE_MASTER_ADMIN');
  };

  // Manager Name in ATM Cash Flow defaults to whatever the Manager
  // Setting holds, but ONLY when the summary doesn't already have one.
  // Once the Owner edits it manually and saves, the stored value wins
  // and we never overwrite it from settings again. Returns the same
  // object reference when no change is needed so equality checks stay
  // cheap.
  withManagerNameFallback = (ms) => {
    if (!ms) return ms;
    const current = String(ms.managerName || '').trim();
    if (current) return ms;
    const fromSetting = this.props.managerSetting?.managerName;
    if (!fromSetting) return ms;
    return { ...ms, managerName: fromSetting };
  };

  handleStaticATMChange = (type, value) => {
    const { atmTransactions } = this.state.managerSummary;
    const index = atmTransactions.findIndex((t) => t.type === type);

    if (index > -1) {
      // Update existing
      this.handleATMChange(index, 'amount', value);
    } else {
      // If for some reason the type isn't in the array yet, add it
      const newTransactions = [...atmTransactions, { type, amount: value }];
      this.setState({
        managerSummary: {
          ...this.state.managerSummary,
          atmTransactions: newTransactions,
        },
      });
    }
  };

  getATMTOTAL = () => {
    const { atmTransactions = [] } = this.state.managerSummary;
    return atmTransactions
      .filter(
        (atm) => atm.type === 'ATM_CASH' || atm.type === 'ATM_FROM_PROFIT'
      )
      .reduce((sum, atm) => sum + Number(atm.amount || 0), 0);
  };

  renderManagerTable = () => {
    const { managerSummary, editMode } = this.state;
    if (!managerSummary) return null;

    const { manager, remainingProfit, delivery, otherItems } = managerSummary;
    const partners = managerSummary.partners || [];
    const ownerProfit =
      managerSummary.ownerProfit != null
        ? managerSummary.ownerProfit
        : remainingProfit;

    const disableButton = !this.canEditReport();

    return (
      <Grid
        container
        justifyContent="flex-start"
        sx={{
          p: { xs: 2, sm: 4 },
          width: '100%',
          height: 'calc(100vh - 300px)',
          overflowX: 'auto',
        }}
      >
        <Grid item xs={12}>
          {/* Toggle Edit/View Button */}
          <Button
            variant="outlined"
            style={{ marginBottom: '16px', marginTop: '-16px' }}
            startIcon={editMode ? <VisibilityIcon /> : <EditIcon />}
            onClick={() => this.setState({ editMode: !editMode })}
            sx={{ mb: 2 }}
            disabled={disableButton}
          >
            {editMode ? 'View Summary' : 'Edit Summary'}
          </Button>

          <Paper
            elevation={0}
            sx={{
              p: 0,
              width: '100%',
              maxWidth: '100%',
              textAlign: 'left',
              background: 'transparent',
              border: 'none',
              boxShadow: 'none',
            }}
          >
            {/* Profit Summary */}
            <Paper
              elevation={0}
              sx={{
                mb: 3,
                borderRadius: 3,
                overflow: 'hidden',
                border: '1px solid #e5e9f0',
                boxShadow: '0 4px 18px rgba(15, 23, 42, 0.06)',
              }}
            >
              {/* Header */}
              <Box
                sx={{
                  px: { xs: 2, sm: 3 },
                  py: 1.75,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.25,
                  background:
                    'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
                }}
              >
                <CalculateIcon sx={{ color: '#fff' }} />
                <Typography
                  variant="h6"
                  fontWeight={700}
                  sx={{ color: '#fff' }}
                >
                  Profit Summary
                </Typography>
              </Box>

              <Box sx={{ p: { xs: 2, sm: 2.5 } }}>
                {/* Weekly Net Profit */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: 1,
                      minWidth: 0,
                    }}
                  >
                    <Box
                      sx={{
                        width: 22,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <TrendingUpIcon sx={{ fontSize: 20, color: '#2563eb' }} />
                    </Box>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      noWrap
                      sx={{ color: '#334155', minWidth: 0 }}
                    >
                      Weekly Net Profit
                    </Typography>
                  </Box>

                  {editMode ? (
                    <TextField
                      type="number"
                      variant="outlined"
                      size="small"
                      sx={{ width: { xs: 120, sm: 180 }, flexShrink: 0 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      value={
                        this.state.editedWeeklyNetProfit ??
                        managerSummary.weeklyNetProfit
                      }
                      onFocus={() =>
                        this.setState({
                          editedWeeklyNetProfit:
                            (this.state.editedWeeklyNetProfit ??
                              managerSummary.weeklyNetProfit) === 0
                              ? ''
                              : String(
                                  this.state.editedWeeklyNetProfit ??
                                    managerSummary.weeklyNetProfit
                                ),
                        })
                      }
                      onChange={(e) =>
                        this.setState({
                          editedWeeklyNetProfit: parseFloat(e.target.value),
                        })
                      }
                      onBlur={() => {
                        const val = this.state.editedWeeklyNetProfit;
                        this.handleWeeklyNetProfitBlur(val);
                      }}
                    />
                  ) : (
                    <Typography
                      fontWeight={700}
                      sx={{
                        color: '#0f172a',
                        flexShrink: 0,
                        whiteSpace: 'nowrap',
                        fontSize: { xs: '1.15rem', sm: '1.35rem' },
                      }}
                    >
                      ${this.fmtMoney2(managerSummary.weeklyNetProfit)}
                    </Typography>
                  )}
                </Box>

                <Divider sx={{ my: 1.5 }} />

                {/* Distribution — deductions before the owners' share */}
                <Typography
                  variant="caption"
                  sx={{
                    display: 'block',
                    mb: 1,
                    color: '#94a3b8',
                    fontWeight: 700,
                  }}
                >
                  DISTRIBUTION
                </Typography>

                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}
                >
                  {/* Manager row */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 1,
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: 22,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                        }}
                      >
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            bgcolor: '#7c3aed',
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body2"
                        noWrap
                        sx={{ minWidth: 0, color: '#1e293b' }}
                      >
                        <Box component="span" sx={{ fontWeight: 700 }}>
                          {manager.name || 'Manager'}
                        </Box>
                        <Box
                          component="span"
                          sx={{ color: '#94a3b8', ml: 0.75 }}
                        >
                          Manager · {manager.percentage}
                        </Box>
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      sx={{
                        color: '#7c3aed',
                        flexShrink: 0,
                        whiteSpace: 'nowrap',
                        pl: 1,
                      }}
                    >
                      −${this.fmtMoney2(manager.share)}
                    </Typography>
                  </Box>

                  {/* Partner rows */}
                  {partners.map((p, i) => (
                    <Box
                      key={i}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 1,
                          minWidth: 0,
                        }}
                      >
                        <Box
                          sx={{
                            width: 22,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                          }}
                        >
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              borderRadius: '50%',
                              bgcolor: '#16a34a',
                            }}
                          />
                        </Box>
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{ minWidth: 0, color: '#1e293b' }}
                        >
                          <Box component="span" sx={{ fontWeight: 700 }}>
                            {p.name}
                          </Box>
                          <Box
                            component="span"
                            sx={{ color: '#94a3b8', ml: 0.75 }}
                          >
                            Partner · {p.percentage}%
                          </Box>
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        fontWeight={700}
                        sx={{
                          color: '#16a34a',
                          flexShrink: 0,
                          whiteSpace: 'nowrap',
                          pl: 1,
                        }}
                      >
                        −${this.fmtMoney2(p.share)}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                {/* Owner remaining — highlighted total bar */}
                <Box
                  sx={{
                    mt: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    px: 1.5,
                    py: 1.25,
                    borderRadius: 2,
                    bgcolor: '#ecfdf5',
                    border: '1px solid #a7f3d0',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: 1,
                      minWidth: 0,
                    }}
                  >
                    <Box
                      sx={{
                        width: 22,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <AccountBalanceWalletIcon
                        sx={{ fontSize: 20, color: '#059669' }}
                      />
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography
                        variant="body2"
                        fontWeight={700}
                        noWrap
                        sx={{ color: '#065f46' }}
                      >
                        Remaining · Owner(s)
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#047857' }}>
                        After manager &amp; partners
                      </Typography>
                    </Box>
                  </Box>
                  <Typography
                    fontWeight={700}
                    sx={{
                      color: '#065f46',
                      flexShrink: 0,
                      whiteSpace: 'nowrap',
                      pl: 1,
                      fontSize: { xs: '1.15rem', sm: '1.35rem' },
                    }}
                  >
                    ${this.fmtMoney2(ownerProfit)}
                  </Typography>
                </Box>
              </Box>
            </Paper>

            {/* Adjustments */}
            {/* --- ADJUSTMENTS SECTION --- */}
            <Box sx={{ mb: 3 }}>
              <Grid container spacing={3}>
                {/* 1. ADDITIONS CARD (GREEN) */}
                <Grid item xs={12} md={6}>
                  <Paper
                    sx={{
                      p: 2,
                      bgcolor: '#e8f5e9',
                      borderRadius: 2,
                      height: '100%',
                      boxShadow: 'none',
                      border: '1px solid #c8e6c9',
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      color="#2e7d32"
                      gutterBottom
                    >
                      Additions (+)
                    </Typography>

                    {managerSummary.adjustments.additions.map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          mb: 2,
                          p: 2,
                          bgcolor: 'white',
                          borderRadius: 2,
                          border: '1px solid #a5d6a7',
                        }}
                      >
                        {editMode ? (
                          <Stack spacing={2}>
                            <Box sx={{ mb: 2 }}>
                              <Grid
                                container
                                alignItems="center"
                                wrap="nowrap" // Forces the Grid to stay on one line
                                spacing={1}
                              >
                                {/* Left Side: Label - Shrink to fit content */}
                                <Grid item>
                                  <Typography
                                    variant="caption"
                                    fontWeight={700}
                                    style={{
                                      color: '#666',
                                      textTransform: 'uppercase',
                                      whiteSpace: 'nowrap', // Prevents "Assign To" from breaking into two lines
                                      marginRight: '8px',
                                    }}
                                  >
                                    Assign To:
                                  </Typography>
                                </Grid>

                                {/* Right Side: Chips and Delete Button - Take up remaining space */}
                                <Grid item xs>
                                  <Box
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                      flexWrap: 'nowrap', // Forces chips to stay on one line
                                      overflowX: 'auto', // Allows scrolling if the names are very long on tiny screens
                                    }}
                                  >
                                    {['Liz', 'Eric'].map((name) => {
                                      const isSelected =
                                        item.assignedTo === name;
                                      return (
                                        <Chip
                                          key={name}
                                          label={name}
                                          onClick={() =>
                                            this.handleAdjustmentChange(
                                              'additions',
                                              index,
                                              'assignedTo',
                                              name
                                            )
                                          }
                                          style={{
                                            fontWeight: isSelected ? 700 : 500,
                                            cursor: 'pointer',
                                            backgroundColor: isSelected
                                              ? '#001251'
                                              : '#eaeaea',
                                            color: isSelected
                                              ? '#ffffff'
                                              : '#333333',
                                            minWidth: '55px',
                                            height: '28px', // Slightly shorter for a tighter one-row look
                                            marginRight: '6px',
                                          }}
                                        />
                                      );
                                    })}

                                    <IconButton
                                      color="error"
                                      size="small"
                                      onClick={() =>
                                        this.removeAdjustmentRow(
                                          'additions',
                                          index
                                        )
                                      }
                                      style={{ padding: '4px' }} // Smaller padding to save space
                                    >
                                      <RemoveCircleIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>

                            <TextField
                              fullWidth
                              label="Description"
                              size="small"
                              variant="outlined"
                              InputLabelProps={{ shrink: true }}
                              value={item.description}
                              onChange={(e) =>
                                this.handleAdjustmentChange(
                                  'additions',
                                  index,
                                  'description',
                                  e.target.value
                                )
                              }
                            />

                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <TextField
                                label="Amount"
                                type="number"
                                fullWidth
                                variant="outlined"
                                size="small"
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  ),
                                }}
                                value={item.amount}
                                onChange={(e) =>
                                  this.handleAdjustmentChange(
                                    'additions',
                                    index,
                                    'amount',
                                    e.target.value
                                  )
                                }
                              />
                            </Box>
                          </Stack>
                        ) : (
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Box>
                              <Typography fontWeight={500}>
                                {item.description}
                              </Typography>
                            </Box>
                            <Typography fontWeight={700} color="#2e7d32">
                              +${this.fmtMoney2(item.amount)}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ))}
                    {editMode && (
                      <Button
                        startIcon={<AddCircleIcon />}
                        onClick={() => this.addAdjustmentRow('additions')}
                        color="success"
                      >
                        Add Addition
                      </Button>
                    )}
                  </Paper>
                </Grid>

                {/* 2. DEDUCTIONS CARD (RED) */}
                <Grid item xs={12} md={6}>
                  <Paper
                    sx={{
                      p: 2,
                      bgcolor: '#ffebee',
                      borderRadius: 2,
                      height: '100%',
                      boxShadow: 'none',
                      border: '1px solid #ffcdd2',
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      color="#c62828"
                      gutterBottom
                    >
                      Deductions (–)
                    </Typography>

                    {managerSummary.adjustments.deductions.map(
                      (item, index) => (
                        <Box
                          key={index}
                          sx={{
                            mb: 2,
                            p: 2,
                            bgcolor: 'white',
                            borderRadius: 2,
                            border: '1px solid #ef9a9a',
                          }}
                        >
                          {editMode ? (
                            <Stack spacing={2}>
                              <Box sx={{ mb: 2 }}>
                                <Grid
                                  container
                                  alignItems="center"
                                  wrap="nowrap" // Forces the Grid to stay on one line
                                  spacing={1}
                                >
                                  {/* Left Side: Label - Shrink to fit content */}
                                  <Grid item>
                                    <Typography
                                      variant="caption"
                                      fontWeight={700}
                                      style={{
                                        color: '#666',
                                        textTransform: 'uppercase',
                                        whiteSpace: 'nowrap', // Prevents "Assign To" from breaking into two lines
                                        marginRight: '8px',
                                      }}
                                    >
                                      Assign To:
                                    </Typography>
                                  </Grid>

                                  {/* Right Side: Chips and Delete Button - Take up remaining space */}
                                  <Grid item xs>
                                    <Box
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end',
                                        flexWrap: 'nowrap', // Forces chips to stay on one line
                                        overflowX: 'auto', // Allows scrolling if the names are very long on tiny screens
                                      }}
                                    >
                                      {['Liz', 'Eric'].map((name) => {
                                        const isSelected =
                                          item.assignedTo === name;
                                        return (
                                          <Chip
                                            key={name}
                                            label={name}
                                            onClick={() =>
                                              this.handleAdjustmentChange(
                                                'deductions',
                                                index,
                                                'assignedTo',
                                                name
                                              )
                                            }
                                            style={{
                                              fontWeight: isSelected
                                                ? 700
                                                : 500,
                                              cursor: 'pointer',
                                              backgroundColor: isSelected
                                                ? '#001251'
                                                : '#eaeaea',
                                              color: isSelected
                                                ? '#ffffff'
                                                : '#333333',
                                              minWidth: '55px',
                                              height: '28px', // Slightly shorter for a tighter one-row look
                                              marginRight: '6px',
                                            }}
                                          />
                                        );
                                      })}

                                      <IconButton
                                        color="error"
                                        size="small"
                                        onClick={() =>
                                          this.removeAdjustmentRow(
                                            'deductions',
                                            index
                                          )
                                        }
                                        style={{ padding: '4px' }} // Smaller padding to save space
                                      >
                                        <RemoveCircleIcon fontSize="small" />
                                      </IconButton>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Box>

                              <TextField
                                fullWidth
                                label="Description"
                                size="small"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={item.description}
                                onChange={(e) =>
                                  this.handleAdjustmentChange(
                                    'deductions',
                                    index,
                                    'description',
                                    e.target.value
                                  )
                                }
                              />

                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <TextField
                                  label="Amount"
                                  type="number"
                                  fullWidth
                                  variant="outlined"
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        $
                                      </InputAdornment>
                                    ),
                                  }}
                                  value={item.amount}
                                  onChange={(e) =>
                                    this.handleAdjustmentChange(
                                      'deductions',
                                      index,
                                      'amount',
                                      e.target.value
                                    )
                                  }
                                />
                              </Box>
                            </Stack>
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <Box>
                                <Typography fontWeight={500}>
                                  {item.description}
                                </Typography>
                              </Box>
                              <Typography fontWeight={700} color="#c62828">
                                -${this.fmtMoney2(item.amount)}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      )
                    )}
                    {editMode && (
                      <Button
                        startIcon={<AddCircleIcon />}
                        onClick={() => this.addAdjustmentRow('deductions')}
                        color="error"
                      >
                        Add Deduction
                      </Button>
                    )}
                  </Paper>
                </Grid>
              </Grid>

              {/* Summary Bar */}
              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  bgcolor: 'rgb(235, 240, 255)',
                  color: 'black',
                  borderRadius: 2,
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Typography variant="h5" fontWeight={700}>
                  Adjusted Total: $
                  {this.fmtMoney2(managerSummary.adjustments.adjustedTotal)}
                </Typography>
              </Box>
            </Box>

            {/* Delivery & Other */}
            <Paper
              sx={{
                mb: 3,
                bgcolor: '#e1f5fe',
                boxShadow: 'none',
                p: 2,
                borderRadius: 2,
              }}
            >
              <Typography variant="h6" fontWeight={600} gutterBottom>
                How Was It Delivered?
              </Typography>

              <Grid container spacing={2} style={{ marginTop: '4px' }}>
                {[
                  { key: 'cash', label: 'Cash' },
                  { key: 'managerZelle', label: 'Zelle' },
                  { key: 'atmReceipts', label: 'ATM Receipts' },
                  { key: 'atmAdv', label: 'ATM ADV' },
                ].map(({ key, label }) => (
                  <Grid item xs={12} sm={6} key={key}>
                    {editMode ? (
                      <TextField
                        label={label}
                        type="number"
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={this.state.deliveryInputValues[key]}
                        onFocus={() => this.handleDeliveryFocus(key)} // ← clears "0" on focus
                        onBlur={() => this.handleDeliveryBlur(key)} // ← restores "0" if empt
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        defaultValue={delivery[key]}
                        onChange={(e) =>
                          this.handleDeliveryChange(key, e.target.value)
                        }
                        sx={{ mb: 1 }}
                      />
                    ) : this.state.isMobile ? (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          fontWeight={700}
                          noWrap
                          sx={{ color: '#334155', minWidth: 0 }}
                        >
                          {label}
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight={700}
                          sx={{
                            color: '#0f172a',
                            flexShrink: 0,
                            whiteSpace: 'nowrap',
                            pl: 1,
                          }}
                        >
                          ${this.fmtMoney2(delivery[key])}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>
                        <strong>{label}:</strong> $
                        {this.fmtMoney2(delivery[key])}
                      </Typography>
                    )}
                  </Grid>
                ))}
              </Grid>

              <Grid item xs={12}>
                <Paper
                  sx={{
                    p: 0,
                    bgcolor: '#e3f2fd', // Light Blue background
                    borderRadius: 2,
                    boxShadow: 'none',
                    mt: 2,
                  }}
                >
                  {otherItems.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 2,
                        p: 2,
                        bgcolor: 'white',
                        borderRadius: 2,
                        border: '1px solid #90caf9',
                      }}
                    >
                      {editMode ? (
                        <Stack spacing={2}>
                          <Box sx={{ mb: 2 }}>
                            <Grid
                              container
                              alignItems="center"
                              wrap="nowrap" // Forces the Grid to stay on one line
                              spacing={1}
                            >
                              {/* Left Side: Label - Shrink to fit content */}
                              <Grid item>
                                <Typography
                                  variant="caption"
                                  fontWeight={700}
                                  style={{
                                    color: '#666',
                                    textTransform: 'uppercase',
                                    whiteSpace: 'nowrap', // Prevents "Assign To" from breaking into two lines
                                    marginRight: '8px',
                                  }}
                                >
                                  Assign To:
                                </Typography>
                              </Grid>

                              {/* Right Side: Chips and Delete Button - Take up remaining space */}
                              <Grid item xs>
                                <Box
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    flexWrap: 'nowrap', // Forces chips to stay on one line
                                    overflowX: 'auto', // Allows scrolling if the names are very long on tiny screens
                                  }}
                                >
                                  {['Liz', 'Eric'].map((name) => {
                                    const isSelected = item.assignedTo === name;
                                    return (
                                      <Chip
                                        key={name}
                                        label={name}
                                        onClick={() =>
                                          this.handleOtherChange(
                                            index,
                                            'assignedTo',
                                            name
                                          )
                                        }
                                        style={{
                                          fontWeight: isSelected ? 700 : 500,
                                          cursor: 'pointer',
                                          backgroundColor: isSelected
                                            ? '#001251'
                                            : '#eaeaea',
                                          color: isSelected
                                            ? '#ffffff'
                                            : '#333333',
                                          minWidth: '55px',
                                          height: '28px', // Slightly shorter for a tighter one-row look
                                          marginRight: '6px',
                                        }}
                                      />
                                    );
                                  })}

                                  <IconButton
                                    color="error"
                                    size="small"
                                    onClick={() =>
                                      this.handleRemoveOther(index)
                                    }
                                    style={{ padding: '4px' }} // Smaller padding to save space
                                  >
                                    <RemoveCircleIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>

                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <TextField
                              fullWidth
                              label="Description"
                              size="small"
                              variant="outlined"
                              InputLabelProps={{ shrink: true }}
                              value={item.description}
                              onChange={(e) =>
                                this.handleOtherChange(
                                  index,
                                  'description',
                                  e.target.value
                                )
                              }
                            />
                          </Box>

                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <TextField
                              label="Amount"
                              type="number"
                              fullWidth
                              variant="outlined"
                              size="small"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                ),
                              }}
                              value={item.amount}
                              onChange={(e) =>
                                this.handleOtherChange(
                                  index,
                                  'amount',
                                  e.target.value
                                )
                              }
                            />
                          </Box>
                        </Stack>
                      ) : (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <Box>
                            <Typography fontWeight={500}>
                              {item.description}
                            </Typography>
                          </Box>
                          <Typography fontWeight={700} color="#1565c0">
                            ${this.fmtMoney2(item.amount)}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  ))}

                  {editMode && (
                    <Button
                      startIcon={<AddCircleIcon />}
                      onClick={this.handleAddOther}
                      sx={{ justifyContent: 'flex-start', color: '#1565c0' }}
                    >
                      Add Other
                    </Button>
                  )}
                </Paper>
              </Grid>

              <Typography
                variant="h5"
                fontWeight={700}
                align="right"
                sx={{ mt: 2 }}
              >
                Total Delivered: ${this.fmtMoney2(delivery.totalDelivered)}
              </Typography>

              {/* $5 rule: Adjusted Total vs Total Delivered. A real-time
                  warning so the user sees the discrepancy while they're
                  still editing — the Save handler enforces the same
                  rule and blocks the request if it isn't resolved. */}
              {(() => {
                const { delta } = this.getDeliveryDelta();
                const tol = ReportView.DELIVERY_VS_ADJUSTED_TOLERANCE;
                if (Math.abs(delta) <= tol) return null;
                const comparison = delta > 0 ? 'less than' : 'more than';
                return (
                  <Alert
                    severity="warning"
                    variant="filled"
                    sx={{ mt: 2, fontWeight: 600 }}
                  >
                    Total Delivered is ${this.fmtMoney2(Math.abs(delta))}{' '}
                    {comparison} Adjusted Total. The two must match within $
                    {this.fmtMoney2(tol)} before saving.
                  </Alert>
                );
              })()}
            </Paper>

            {/*ATM Transactions*/}
            {this.userHasATMRole() && (
              <Paper
                sx={{
                  mb: 3,
                  bgcolor: '#fbd9d3',
                  boxShadow: 'none',
                  p: 3,
                  borderRadius: 2,
                }}
              >
                <Typography variant="h6" fontWeight={600} sx={{ mb: 3 }}>
                  ATM Cash Flow
                </Typography>

                {/* Header: Manager & Overall Total */}
                {/* Manager Name + Amount at the top */}
                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    mb: 2,
                    flexDirection: editMode ? 'column' : 'row',
                    alignItems: 'center',
                  }}
                >
                  {editMode ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          label="Manager Name"
                          name="managerName"
                          type="text"
                          value={managerSummary.managerName || ''}
                          onChange={(e) =>
                            this.handleATMChange(
                              null,
                              'managerName',
                              e.target.value
                            )
                          }
                          disabled={!this.isOwner()}
                          InputProps={{ readOnly: !this.isOwner() }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          label="Weekly Starting Cash"
                          name="totalATMCash"
                          type="number"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                $
                              </InputAdornment>
                            ),
                          }}
                          value={
                            this.state.activeATMField === 'null-totalATMCash'
                              ? this.state.activeATMValue
                              : String(managerSummary.totalATMCash ?? 0)
                          }
                          onFocus={() =>
                            this.handleATMFocus(
                              null,
                              'totalATMCash',
                              managerSummary.totalATMCash
                            )
                          }
                          onBlur={this.handleATMBlur}
                          onChange={(e) => {
                            this.setState({ activeATMValue: e.target.value });
                            this.handleATMChange(
                              null,
                              'totalATMCash',
                              e.target.value
                            );
                          }}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <>
                      <Box
                        sx={{
                          p: 2,
                          width: '100%',
                          borderRadius: 2,
                          bgcolor: '#FFB09C',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="caption"
                          fontWeight={700}
                          sx={{ textTransform: 'uppercase' }}
                        >
                          {managerSummary.managerName || '—'}
                        </Typography>

                        <Typography variant="h6" fontWeight={600}>
                          ${this.fmtMoney2(managerSummary.totalATMCash)}
                        </Typography>
                      </Box>
                    </>
                  )}
                </Box>

                <Grid container spacing={2}>
                  {[
                    'ATM_CASH',
                    'ATM_FROM_PROFIT',
                    'ATM_ADV',
                    'ATM_DIDNT_USE',
                  ].map((typeCode) => {
                    // Find the existing data for this type or default to 0
                    const txn = managerSummary.atmTransactions?.find(
                      (t) => t.type === typeCode
                    ) || { type: typeCode, amount: 0 };
                    // Find the label from your constant
                    const label =
                      ATM_TYPES.find((t) => t.value === typeCode)?.label ||
                      typeCode;

                    return (
                      <Grid item xs={12} sm={6} key={typeCode}>
                        <Box
                          sx={{
                            p: editMode ? 0 : 2,
                            borderRadius: 2,
                            display: 'flex',
                            bgcolor: !editMode ? '#FFB09C' : 'none',
                            flexDirection: 'column',
                            gap: 1,
                          }}
                        >
                          {editMode ? (
                            <TextField
                              fullWidth
                              variant="outlined"
                              label={
                                label === 'ATM Cash'
                                  ? 'ATM Cash Used'
                                  : label === 'ATM From Profit'
                                  ? 'ATM Added From Profit'
                                  : label
                              }
                              name={typeCode}
                              type="number"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                ),
                              }}
                              value={
                                this.state.activeATMField ===
                                `static-${typeCode}`
                                  ? this.state.activeATMValue
                                  : String(txn.amount ?? 0)
                              }
                              onFocus={() =>
                                this.handleATMFocus(
                                  `static`,
                                  typeCode,
                                  txn.amount
                                )
                              }
                              onBlur={this.handleATMBlur}
                              onChange={(e) => {
                                this.setState({
                                  activeATMValue: e.target.value,
                                });
                                this.handleStaticATMChange(
                                  typeCode,
                                  e.target.value
                                );
                              }}
                            />
                          ) : (
                            <>
                              <Typography
                                variant="caption"
                                fontWeight={700}
                                sx={{ textTransform: 'uppercase' }}
                              >
                                {label === 'ATM Cash'
                                  ? 'ATM Cash Used'
                                  : label === 'ATM From Profit'
                                  ? 'ATM Added From Profit'
                                  : label}
                              </Typography>
                              <Typography variant="h6" fontWeight={600}>
                                ${this.fmtMoney2(txn.amount)}
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>

                <Typography
                  variant="h5"
                  fontWeight={700}
                  align="right"
                  sx={{ mt: 2 }}
                >
                  ATM Cash Total: ${this.fmtMoney2(this.getATMTOTAL())}
                </Typography>
              </Paper>
            )}

            {/* Save Button */}
            {editMode && (
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                justifyContent="flex-start"
                sx={{ mt: 3 }}
              >
                <Button
                  size="large"
                  onClick={() => {
                    this.handleSaveManagerSummary();
                  }}
                  variant="contained"
                  color="primary"
                >
                  Save
                </Button>
              </Stack>
            )}
          </Paper>
        </Grid>
      </Grid>
    );
  };

  // ──────────────────────────────────────────────────────────────
  // Short Analysis (Equation X)
  // ──────────────────────────────────────────────────────────────
  fmtMoney = (n) => {
    const v = Number(n) || 0;
    const str = '$' + Math.abs(v).toLocaleString('en-US');
    if (v < 0) return `-${str}`;
    if (v > 0) return `+${str}`;
    return str;
  };

  fmtPlain = (n) => '$' + Math.abs(Number(n) || 0).toLocaleString('en-US');

  // Display-only currency formatter for the Manager Summary section.
  // Always renders 2 decimal places with thousands separators
  // (e.g. 1234 → "1,234.00"). Use this instead of `.toLocaleString()`
  // for any money value shown in that section — plain `.toLocaleString()`
  // drops trailing zeros so "$540" reads differently from "$540.00".
  fmtMoney2 = (n) =>
    (Number(n) || 0).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  // Adjusted Total vs Total Delivered must agree within this tolerance
  // (in dollars). Anything beyond is treated as a real discrepancy:
  // an inline warning surfaces it in the UI and Save is blocked.
  static DELIVERY_VS_ADJUSTED_TOLERANCE = 5;

  getDeliveryDelta = () => {
    const ms = this.state.managerSummary || {};
    const adjusted = Number(ms?.adjustments?.adjustedTotal) || 0;
    const delivered = Number(ms?.delivery?.totalDelivered) || 0;
    return { adjusted, delivered, delta: adjusted - delivered };
  };

  sxBadge = (value, size = 'sm') => {
    const v = Number(value) || 0;
    const neg = v < 0;
    const pos = v > 0;
    const bg = neg ? '#FEE2E2' : pos ? '#D1FAE5' : '#F3F4F6';
    const color = neg ? '#DC2626' : pos ? '#059669' : '#6B7280';
    const fs = size === 'lg' ? 22 : size === 'md' ? 15 : 13;
    const pad =
      size === 'lg' ? '8px 16px' : size === 'md' ? '4px 10px' : '3px 8px';
    return (
      <span
        style={{
          background: bg,
          color,
          fontSize: fs,
          fontWeight: 700,
          padding: pad,
          borderRadius: 8,
          display: 'inline-block',
          fontFamily: "'JetBrains Mono', monospace",
        }}
      >
        {this.fmtMoney(v)}
      </span>
    );
  };

  sxCard = ({ title, icon, accent, children, alert }) => (
    <div
      style={{
        background: alert ? '#FFF5F5' : '#FFF',
        borderRadius: 16,
        padding: '18px 16px',
        marginBottom: 12,
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        borderLeft: `4px solid ${accent || '#E5E7EB'}`,
        border: alert ? '1px solid #FECACA' : undefined,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginBottom: 12,
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: 1.1,
          color: alert ? '#DC2626' : '#9CA3AF',
        }}
      >
        <span style={{ fontSize: 15 }}>{icon}</span>
        {title}
      </div>
      {children}
    </div>
  );

  sxRow = ({ label, value, sub, bold, border }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '9px 0',
        borderBottom: border ? '1px solid #F3F4F6' : 'none',
      }}
    >
      <div>
        <div
          style={{
            fontSize: 13,
            color: '#374151',
            fontWeight: bold ? 700 : 400,
          }}
        >
          {label}
        </div>
        {sub && (
          <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 1 }}>
            {sub}
          </div>
        )}
      </div>
      <div
        style={{
          fontSize: 13,
          fontWeight: bold ? 700 : 500,
          fontFamily: "'JetBrains Mono', monospace",
        }}
      >
        {value}
      </div>
    </div>
  );

  sxEmployeeRow = (emp, isWorst) => (
    <div
      key={(emp.userId || emp.name) + '-' + (emp.clockId || '')}
      style={{
        background: isWorst ? '#FFF5F5' : '#FAFAFA',
        border: isWorst ? '1px solid #FECACA' : '1px solid #F3F4F6',
        borderRadius: 12,
        padding: '12px 14px',
        marginBottom: 8,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div
            style={{
              width: 34,
              height: 34,
              borderRadius: 10,
              background: isWorst ? '#FEE2E2' : '#EEF2FF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 13,
              fontWeight: 700,
              color: isWorst ? '#DC2626' : '#4F46E5',
            }}
          >
            {(emp.name || '?').charAt(0).toUpperCase()}
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>
              {emp.name}
            </div>
            <div style={{ fontSize: 11, color: '#9CA3AF' }}>
              {emp.didPulls ? `Pulls: ${this.fmtPlain(emp.pulls)}` : 'No pulls'}{' '}
              · Tickets: {this.fmtPlain(emp.ticketOut)}
            </div>
          </div>
        </div>
        {this.sxBadge(emp.shiftShort)}
      </div>
      {emp.note && (
        <div
          style={{
            marginTop: 8,
            fontSize: 11,
            color: '#D97706',
            background: '#FFFBEB',
            borderRadius: 8,
            padding: '6px 10px',
            border: '1px solid #FDE68A',
          }}
        >
          <span role="img" aria-label="warning">
            ⚠️
          </span>{' '}
          {emp.note}
        </div>
      )}
    </div>
  );

  sxNoteCard = (note, i) => {
    const colors = {
      alert: { bg: '#FEF2F2', border: '#FECACA', title: '#991B1B' },
      action: { bg: '#EFF6FF', border: '#BFDBFE', title: '#1E40AF' },
      warning: { bg: '#FFFBEB', border: '#FDE68A', title: '#92400E' },
      info: { bg: '#F0FDF4', border: '#BBF7D0', title: '#166534' },
      critical: { bg: '#FEF2F2', border: '#FCA5A5', title: '#7F1D1D' },
    };
    const icons = {
      alert: '🔴',
      action: '🔧',
      warning: '⚠️',
      info: '💡',
      critical: '🚨',
    };
    const c = colors[note.type] || colors.info;
    return (
      <div
        key={i}
        style={{
          background: c.bg,
          border: `1px solid ${c.border}`,
          borderRadius: 12,
          padding: '14px',
          marginBottom: 8,
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 6,
          }}
        >
          <span style={{ fontSize: 14 }}>{icons[note.type] || '📝'}</span>
          <span style={{ fontSize: 13, fontWeight: 700, color: c.title }}>
            {note.title}
          </span>
        </div>
        <div
          style={{
            fontSize: 12,
            color: '#475569',
            lineHeight: 1.5,
            whiteSpace: 'pre-line',
          }}
        >
          {note.body}
        </div>
      </div>
    );
  };

  buildShortAnalysisNotes = (dayData) => {
    const notes = [];
    const pullsGap = Number(dayData.pullsGap) || 0;
    const matchDiff = Number(dayData.matchTicketsDiff) || 0;
    const matchDiffRaw = Number(dayData.matchTicketsDiffRaw) || 0;
    const jackpotNotPay = Number(dayData.jackpotNotPay) || 0;
    const weeklyShort = Number(dayData.weeklyShortOver) || 0;
    const overTicketMachines = dayData.overTicketMachines || [];
    const missingExpenses = dayData.missingDailyExpenses || [];
    const duplicateExpenses = dayData.duplicateDailyExpenses || [];
    const fp = this.fmtPlain;
    const fm = this.fmtMoney;
    const absShort = Math.abs(weeklyShort);
    const absPulls = Math.abs(pullsGap);

    // 1. Over-tickets analysis — per machine, source tracing via matching
    // tickets. Only surface over-ticket amounts greater than $10; trivial
    // amounts ($1–$2) are almost always counting dust and flood the
    // recommendation panel without being actionable.
    const OVER_TICKET_THRESHOLD = 10;
    overTicketMachines
      .filter(
        (m) => Math.abs(Number(m.overAmount) || 0) > OVER_TICKET_THRESHOLD
      )
      .forEach((m) => {
        const matches = m.matches || [];
        const lines = matches
          .map((x) => `- ${x.employee} entered ${fp(x.amount)}`)
          .join('\n');
        // Use unique employee names, not unique (employee, amount)
        // pairs. That way a single employee who entered two separate
        // candidate tickets on the same machine is still reported as
        // the sole source, and "either employee" only appears when
        // two or more distinct people entered tickets on it.
        const uniqueEmployees = [
          ...new Set(matches.map((x) => x.employee).filter(Boolean)),
        ];
        let source = '';
        if (uniqueEmployees.length === 1) {
          source = `\nMost likely source: ${uniqueEmployees[0]}`;
        } else if (uniqueEmployees.length > 1) {
          source = `\nPossible source: ${uniqueEmployees.join(' or ')}`;
        }
        notes.push({
          type: 'warning',
          title: `Machine #${m.machine} has ${fp(m.overAmount)} over tickets`,
          body:
            (matches.length
              ? `Matching tickets found:\n${lines}`
              : 'No matching ticket entries found for this machine.') + source,
        });
      });

    // 2. Money In (Room Over) — strict causes only
    if (weeklyShort > 0) {
      notes.push({
        type: 'info',
        title: `Room over: ${fp(weeklyShort)}`,
        body:
          `Room shows more money than the actual reading.\n` +
          `Most likely cause: miscount or incorrect PULLS entry.\n` +
          `Wait until end of day and verify final balance.`,
      });
    }

    // 3. Money Shortage Analysis — tiered by magnitude
    if (weeklyShort < 0) {
      if (absShort < 40) {
        notes.push({
          type: 'info',
          title: `Small shortage: ${fm(weeklyShort)}`,
          body: `Likely cause: miscount.`,
        });
      } else if (absShort <= 300) {
        notes.push({
          type: 'warning',
          title: `Shortage: ${fm(weeklyShort)}`,
          body:
            `Possible causes:\n` +
            `- Employee counting error\n` +
            `- Machine was not opened (most likely the last active machine)\n` +
            `Wait until next session and check if the money appears in the next reading.`,
        });
      } else {
        notes.push({
          type: 'alert',
          title: `Significant shortage: ${fm(weeklyShort)}`,
          body:
            `Possible causes:\n` +
            `- Cash still inside machines\n` +
            `- Reading error\n` +
            `- Employee-related issue\n` +
            `Step 1: Open all machines immediately and verify internal cash.\n` +
            `Step 2: If not found, wait until next session to check for reading correction.\n` +
            `Step 3: If still missing, escalate as internal issue.`,
        });
      }
    }

    // 4. Pulls Gap — only surface when the gap is negative (employees
    // pulled less than the machines read, i.e. money is missing). A
    // positive gap means employees pulled more than the reading shows,
    // which is expected counting noise and doesn't need an analysis row.
    if (pullsGap < 0 && absPulls > 300) {
      notes.push({
        type: 'alert',
        title: `Pulls gap: ${fm(pullsGap)}`,
        body:
          `Open all machines immediately and verify if the missing money is still inside.\n` +
          `- If found: issue resolved, no escalation required.\n` +
          `- If not found: wait until next session and check if the discrepancy corrects in the next reading.\n` +
          `- If still missing: escalate as internal issue.`,
      });
    } else if (pullsGap < 0 && absPulls > 0) {
      notes.push({
        type: 'info',
        title: `Pulls gap: ${fm(pullsGap)}`,
        body: `Likely a minor counting difference. Review final balance and monitor next session.`,
      });
    }

    // 5. Unrecorded ticket-outs (cushion).
    // matchDiff is the REAL diff (raw − jackpotNotPay), so if jackpots fully
    // explain the raw gap, no warning fires. When a jackpot partially explains
    // it, note that the residual is what's unaccounted for.
    if (matchDiff > 0) {
      const jackpotNote =
        jackpotNotPay > 0
          ? `\n${fp(
              jackpotNotPay
            )} of the raw gap is explained by a jackpot that was not paid; the remaining ${fp(
              matchDiff
            )} is unaccounted for.`
          : '';
      notes.push({
        type: 'warning',
        title: `${fp(matchDiff)} in ticket-outs not recorded`,
        body:
          `Some ticket-outs were paid but not entered into the system. Unable to determine which employee recorded them.` +
          jackpotNote,
      });
    } else if (matchDiffRaw > 0 && jackpotNotPay > 0) {
      notes.push({
        type: 'info',
        title: `Ticket-out gap fully explained by jackpot not paid`,
        body: `Raw reading-out vs. ticket-out gap of ${fp(
          matchDiffRaw
        )} is covered by ${fp(
          jackpotNotPay
        )} in jackpots not paid. No missing ticket entries.`,
      });
    }

    // 6. Missing fixed daily expenses (only when one or more are missing)
    if (missingExpenses.length > 0) {
      const lines = missingExpenses.map((x) => `- ${x}`).join('\n');
      notes.push({
        type: 'warning',
        title: 'Missing daily expense',
        body: `${lines}\nVerify if this payment was made but not recorded.`,
      });
    }

    // 6b. Duplicate fixed daily expenses — same payroll or food entry
    // recorded more than once in the same shift.
    if (duplicateExpenses.length > 0) {
      const lines = duplicateExpenses.map((x) => `- ${x}`).join('\n');
      notes.push({
        type: 'warning',
        title: 'Duplicate daily expense',
        body: `${lines}\nThis expense was recorded more than once. Verify it wasn't paid twice.`,
      });
    }

    // 7. Recommended actions — only when the room is actually short
    // (negative). If the room is over or exactly matched, the prompt
    // to hunt for missing expenses doesn't apply.
    if (weeklyShort < 0) {
      const actions = [];
      if (absShort > 300 || (pullsGap < 0 && absPulls > 300)) {
        actions.push('- Open all machines immediately (shortage above $300).');
      }
      if (missingExpenses.length > 0) {
        actions.push(
          '- Verify missing daily expense(s) — check if paid but not recorded.'
        );
      }
      if (duplicateExpenses.length > 0) {
        actions.push(
          '- Review duplicate daily expense(s) — confirm the payment was not double-counted.'
        );
      }
      actions.push('- Ask employees if any expense was paid but not recorded.');

      notes.push({
        type: 'action',
        title: 'Recommended actions',
        body: actions.join('\n'),
      });
    }

    return notes;
  };

  // ──────────────────────────────────────────────────────────────
  // Daily Analysis (merged Activity + Equation X) — Developer Spec v1.
  // Block A: Daily Activity summary. Block B: Equation X proof card with a
  // collapsible breakdown. Block C: Open Match Tickets navigation card.
  // Read-only: no edit/delete affordances render here (spec §10).
  // ──────────────────────────────────────────────────────────────
  // ──────────────────────────────────────────────────────────────
  // Daily Analysis (merged Activity + Equation X) — Developer Spec v1.
  // Rendered as standard .grid-section cards inside the shared .grid-slider
  // so it inherits the same responsive desktop/mobile layout as Cash Flow and
  // the other Weekly Report tabs. Read-only: no edit/delete affordances here.
  // ──────────────────────────────────────────────────────────────
  renderDailyAnalysis = () => {
    const { shortAnalysis, report } = this.props;
    const { selectedDay, dailyAnalysisOpen } = this.state;

    // Neutral currency (no sign, thousands separator) and signed currency
    // (typographic minus U+2212, explicit +, $0 for zero) — spec §7.4.
    const plain = (n) =>
      '$' + Math.round(Math.abs(Number(n) || 0)).toLocaleString('en-US');
    const signed = (n) => {
      const v = Math.round(Number(n) || 0);
      const s = '$' + Math.abs(v).toLocaleString('en-US');
      if (v < 0) return '−' + s;
      if (v > 0) return '+' + s;
      return s;
    };
    // Tone colors — light background vs. the dark proof panel (spec §5).
    const toneLight = (n) =>
      Number(n) < 0 ? '#e11d48' : Number(n) > 0 ? '#059669' : '#94a3b8';
    const toneDark = (n) =>
      Number(n) < 0 ? '#fda4af' : Number(n) > 0 ? '#6ee7b7' : '#94a3b8';
    const titleCase = (s) =>
      (s || '').replace(
        /\w\S*/g,
        (t) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase()
      );
    const MONO = "'JetBrains Mono', monospace";
    const monoStyle = { fontFamily: MONO, fontVariantNumeric: 'tabular-nums' };

    // Loading — skeleton card, no spinner overlay (spec §8).
    if (!shortAnalysis || !shortAnalysis.days) {
      const skel = (h) => (
        <div
          style={{
            background: '#f1f5f9',
            border: '1px solid #e2e8f0',
            borderRadius: 10,
            height: h,
            marginBottom: 12,
          }}
        />
      );
      return (
        <div className="grid-section">
          {skel(120)}
          {skel(180)}
        </div>
      );
    }

    // Activity numbers come from the weekly-report day object; the Equation X
    // reconciliation comes from shortAnalysis.days — both keyed by day.
    const dayReport = (report && report[selectedDay]) || {};
    const dayData = (shortAnalysis.days || []).find(
      (d) => d.day === selectedDay
    );

    const morningPull = Number(dayReport.morningPull) || 0;
    const nightPull = Number(dayReport.nightPull) || 0;
    const morningCount = Number(dayReport.morningCount) || 0;
    const nightCount = Number(dayReport.nightCount) || 0;
    const totalPulls = morningPull + nightPull;
    const totalCustomers = morningCount + nightCount;

    // A shift is "present" only when it has activity; a location that ran one
    // shift renders a single full-width column at 100% share (spec §9.4).
    const shifts = [];
    if (morningPull !== 0 || morningCount !== 0)
      shifts.push({
        label: 'Morning Shift',
        pull: morningPull,
        customers: morningCount,
        dot: '#f5b942',
      });
    if (nightPull !== 0 || nightCount !== 0)
      shifts.push({
        label: 'Night Shift',
        pull: nightPull,
        customers: nightCount,
        dot: '#7b7fd4',
      });

    const hasActivity = shifts.length > 0;
    const hasRecon = !!dayData;

    // No data — the day has no records at all (spec §8).
    if (!hasActivity && !hasRecon) {
      return (
        <div className="grid-section">
          <div
            style={{
              padding: '32px 16px',
              textAlign: 'center',
              color: '#94a3b8',
              fontSize: 14,
            }}
          >
            No activity recorded for this day.
          </div>
        </div>
      );
    }

    // Per-shift share (of total pulls); a single present shift is 100%.
    if (shifts.length === 1) {
      shifts[0].share = 100;
    } else if (shifts.length === 2) {
      const mShare =
        totalPulls > 0 ? Math.round((morningPull / totalPulls) * 100) : 50;
      shifts[0].share = mShare;
      shifts[1].share = 100 - mShare;
    }
    const avgPerCustomer =
      totalCustomers > 0 ? Math.round(totalPulls / totalCustomers) : null;

    // ── Equation X reconciliation values ──
    const pullsGap = Number(dayData?.pullsGap) || 0;
    const matchDiff = Number(dayData?.matchTicketsDiff) || 0;
    const empShorts = Number(dayData?.employeeShortsTotal) || 0;
    const equationX = Number(dayData?.equationX) || 0;
    const hasShortOver = dayData && dayData.weeklyShortOver != null;
    const shortOver = Number(dayData?.weeklyShortOver) || 0;
    const isBalanced = !!dayData?.match;

    const readingIn = Number(dayData?.readingTotalIn) || 0;
    const readingOut = Number(dayData?.readingTotalOut) || 0;
    // Other In / Other Out (jackpot/other reading values) fold into the two
    // reconciliations: other-in on the reading-in side of Pulls, other-out on
    // the reading-out side of Match Tickets. Both are already baked into
    // pullsGap / matchTicketsDiff by the backend — and therefore into Equation X
    // — so we only need to surface the rows when they are non-zero.
    const otherIn = Number(dayData?.otherIn) || 0;
    const otherOut = Number(dayData?.otherOut) || 0;
    const matchDiffRaw = Number(dayData?.matchTicketsDiffRaw) || 0;
    const jackpotNotPay = Number(dayData?.jackpotNotPay) || 0;
    const employeeRows = dayData?.employees || [];
    const employeePulls = employeeRows.reduce(
      (s, e) => s + (Number(e.pulls) || 0),
      0
    );
    // Ticket Total OUT = actual recorded ticket-outs (reading-out − raw diff);
    // matchDiffRawWithOther is the reading-out (incl. other-out) vs. ticket gap.
    const ticketOut = readingOut - matchDiffRaw;
    const matchDiffRawWithOther = matchDiffRaw + otherOut;

    // Generic label/value row for Pulls Comparison and Match Tickets.
    const Line = ({ label, value, strong, tone }) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 12,
          padding: '8px 0',
        }}
      >
        <div
          style={{
            fontSize: 14.5,
            lineHeight: 1.2,
            color: strong ? '#0f172a' : '#64748b',
            fontWeight: strong ? 600 : 400,
          }}
        >
          {label}
        </div>
        <div
          style={{
            ...monoStyle,
            fontSize: 14.5,
            whiteSpace: 'nowrap',
            fontWeight: tone !== undefined ? 600 : 500,
            color: tone !== undefined ? toneLight(tone) : '#334155',
          }}
        >
          {value}
        </div>
      </div>
    );

    const Eyebrow = ({ children, style }) => (
      <div
        style={{
          fontSize: 11.5,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.12em',
          color: '#94a3b8',
          marginBottom: 6,
          ...style,
        }}
      >
        {children}
      </div>
    );

    const proofRows = [
      { label: 'Pulls Gap', val: pullsGap, strong: false },
      { label: 'Match Tickets', val: matchDiff, strong: false },
      { label: 'Employee Shorts', val: empShorts, strong: false },
      { label: 'Equation X', val: equationX, strong: true },
      { label: 'Weekly Report', val: shortOver, strong: true },
    ];

    return (
      <>
        {/* ── Card 1 · DAILY ACTIVITY ─────────────────────────── */}
        {hasActivity && (
          <div className="grid-section">
            <h4 className="title-heading">
              <span role="img" aria-label="activity">
                📊
              </span>{' '}
              Daily Activity
            </h4>

            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 24 }}>
              <div style={{ lineHeight: 1.2 }}>
                <div
                  style={{
                    ...monoStyle,
                    fontSize: 24,
                    fontWeight: 600,
                    color: '#0f172a',
                  }}
                >
                  {plain(totalPulls)}
                </div>
                <div style={{ fontSize: 11.5, color: '#94a3b8' }}>
                  Total pulls
                </div>
              </div>
              <div style={{ lineHeight: 1.2 }}>
                <div
                  style={{
                    ...monoStyle,
                    fontSize: 24,
                    fontWeight: 600,
                    color: '#0f172a',
                  }}
                >
                  {totalCustomers.toLocaleString('en-US')}
                </div>
                <div style={{ fontSize: 11.5, color: '#94a3b8' }}>
                  Customers
                </div>
              </div>
              <div
                style={{
                  lineHeight: 1.2,
                  marginLeft: 'auto',
                  textAlign: 'right',
                }}
              >
                <div
                  style={{
                    ...monoStyle,
                    fontSize: 15,
                    fontWeight: 600,
                    color: '#64748b',
                  }}
                >
                  {avgPerCustomer == null ? '—' : plain(avgPerCustomer)}
                </div>
                <div style={{ fontSize: 11.5, color: '#94a3b8' }}>
                  Avg / customer
                </div>
              </div>
            </div>

            {/* Share bar — morning vs night (spec §4.2) */}
            <div
              style={{
                marginTop: 12,
                display: 'flex',
                height: 6,
                borderRadius: 999,
                overflow: 'hidden',
                background: '#f1f5f9',
              }}
            >
              {shifts.map((s, i) => (
                <div
                  key={i}
                  style={{ width: `${s.share}%`, background: s.dot }}
                />
              ))}
            </div>

            {/* Shift grid */}
            <div
              style={{
                marginTop: 12,
                border: '1px solid #f1f5f9',
                borderRadius: 10,
                overflow: 'hidden',
                display: 'grid',
                gridTemplateColumns: shifts.length === 2 ? '1fr 1fr' : '1fr',
              }}
            >
              {shifts.map((s, i) => (
                <div
                  key={i}
                  style={{
                    padding: '12px 14px',
                    borderRight:
                      shifts.length === 2 && i === 0
                        ? '1px solid #f1f5f9'
                        : 'none',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 6,
                      marginBottom: 6,
                    }}
                  >
                    <span
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: 999,
                        background: s.dot,
                      }}
                    />
                    <span
                      style={{
                        fontSize: 12.5,
                        fontWeight: 500,
                        color: '#64748b',
                      }}
                    >
                      {s.label}
                    </span>
                    <span
                      style={{
                        ...monoStyle,
                        fontSize: 11,
                        color: '#cbd5e1',
                        marginLeft: 'auto',
                      }}
                    >
                      {s.share}%
                    </span>
                  </div>
                  <div
                    style={{
                      ...monoStyle,
                      fontSize: 17,
                      fontWeight: 600,
                      color: '#0f172a',
                    }}
                  >
                    {plain(s.pull)}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: '#94a3b8',
                      marginTop: 4,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 6,
                      flexWrap: 'wrap',
                    }}
                  >
                    <span style={monoStyle}>
                      {s.customers.toLocaleString('en-US')}
                    </span>
                    customers
                    <span style={{ color: '#e2e8f0' }}>·</span>
                    <span style={monoStyle}>
                      {s.customers > 0
                        ? plain(Math.round(s.pull / s.customers))
                        : '—'}
                    </span>
                    avg
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── Card 2 · EQUATION X ──────────────────────────────── */}
        {hasRecon && (
          <div className="grid-section">
            <h4 className="title-heading">
              <span role="img" aria-label="equation">
                🧮
              </span>{' '}
              Equation X
            </h4>

            {/* Proof panel (dark ink surface) */}
            <div
              style={{ background: '#1c2a4a', borderRadius: 12, padding: 16 }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 11.5,
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: '0.12em',
                      color: '#94a3b8',
                    }}
                  >
                    Equation X — Proof
                  </div>
                  <div
                    style={{
                      ...monoStyle,
                      fontSize: 30,
                      fontWeight: 600,
                      lineHeight: 1.15,
                      marginTop: 4,
                      color: isBalanced ? '#7ee2b8' : '#ffa3b1',
                    }}
                  >
                    {hasShortOver ? signed(shortOver) : '—'}
                  </div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>
                    Short / Over
                  </div>
                </div>
                {hasShortOver && (
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: '0.03em',
                      padding: '4px 10px',
                      borderRadius: 6,
                      background: isBalanced
                        ? 'rgba(52,211,153,0.15)'
                        : 'rgba(251,113,133,0.15)',
                      color: isBalanced ? '#6ee7b7' : '#fda4af',
                    }}
                  >
                    {isBalanced ? 'Balanced' : 'Mismatch'}
                  </span>
                )}
              </div>

              {/* Proof list — five rows, each on its own line */}
              <div
                style={{
                  ...monoStyle,
                  marginTop: 16,
                  borderRadius: 8,
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.10)',
                  padding: '4px 14px',
                  fontSize: 14,
                }}
              >
                {proofRows.map((rr, i) => (
                  <div
                    key={rr.label}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '10px 0',
                      borderBottom:
                        i < proofRows.length - 1
                          ? '1px solid rgba(255,255,255,0.10)'
                          : 'none',
                    }}
                  >
                    <span
                      style={{
                        color: rr.strong ? '#ffffff' : '#cbd5e1',
                        fontWeight: rr.strong ? 600 : 400,
                      }}
                    >
                      {rr.label}
                    </span>
                    <span
                      style={{
                        color: toneDark(rr.val),
                        fontWeight: rr.strong ? 600 : 400,
                      }}
                    >
                      {signed(rr.val)}
                    </span>
                  </div>
                ))}
              </div>

              {/* Verdict sentence */}
              {hasShortOver && (
                <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 10 }}>
                  {isBalanced
                    ? 'Both totals agree — the difference is fully identified.'
                    : 'The two totals don’t agree — check data entry below.'}
                </div>
              )}

              {/* Expand control */}
              <button
                type="button"
                onClick={() =>
                  this.setState((st) => ({
                    dailyAnalysisOpen: !st.dailyAnalysisOpen,
                  }))
                }
                aria-expanded={dailyAnalysisOpen}
                style={{
                  marginTop: 12,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  borderRadius: 8,
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.10)',
                  padding: 10,
                  fontSize: 12.5,
                  fontWeight: 500,
                  color: '#cbd5e1',
                  cursor: 'pointer',
                }}
              >
                {dailyAnalysisOpen
                  ? 'Hide breakdown'
                  : 'Tap to see the full breakdown'}
                <span
                  style={{
                    fontSize: 11,
                    display: 'inline-block',
                    transform: dailyAnalysisOpen ? 'rotate(180deg)' : 'none',
                    transition: 'transform 0.15s',
                  }}
                >
                  ▾
                </span>
              </button>
            </div>

            {/* Breakdown — rendered only when expanded (spec §4.3) */}
            {dailyAnalysisOpen && (
              <div style={{ paddingTop: 14 }}>
                {/* Subsection 1 — Pulls Comparison */}
                <div>
                  <Eyebrow>Pulls Comparison</Eyebrow>
                  <Line label="Reading Total IN" value={plain(readingIn)} />
                  {otherIn !== 0 && (
                    <Line label="Other In" value={plain(otherIn)} />
                  )}
                  <Line
                    label="Employee Total Pulls"
                    value={plain(employeePulls)}
                  />
                  <Line
                    label="Pulls Gap"
                    value={signed(pullsGap)}
                    strong
                    tone={pullsGap}
                  />
                </div>

                {/* Subsection 2 — Match Tickets */}
                <div
                  style={{
                    borderTop: '1px solid #f1f5f9',
                    marginTop: 8,
                    paddingTop: 14,
                  }}
                >
                  <Eyebrow>Match Tickets</Eyebrow>
                  <Line label="Reading Total OUT" value={plain(readingOut)} />
                  {otherOut !== 0 && (
                    <Line label="Other Out" value={plain(otherOut)} />
                  )}
                  <Line label="Ticket Total OUT" value={plain(ticketOut)} />
                  {jackpotNotPay !== 0 ? (
                    <>
                      <Line
                        label="Difference"
                        value={signed(matchDiffRawWithOther)}
                        tone={matchDiffRawWithOther}
                      />
                      <Line
                        label="Jackpot Not Pay"
                        value={plain(jackpotNotPay)}
                      />
                      <Line
                        label="Real Difference"
                        value={signed(matchDiff)}
                        strong
                        tone={matchDiff}
                      />
                    </>
                  ) : (
                    <Line
                      label="Difference"
                      value={signed(matchDiff)}
                      strong
                      tone={matchDiff}
                    />
                  )}
                </div>

                {/* Subsection 3 — Employee Shorts / Overs */}
                <div
                  style={{
                    borderTop: '1px solid #f1f5f9',
                    marginTop: 8,
                    paddingTop: 14,
                  }}
                >
                  <Eyebrow>Employee Shorts / Overs</Eyebrow>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      paddingBottom: 6,
                      borderBottom: '1px solid #f1f5f9',
                    }}
                  >
                    <span style={{ fontSize: 11.5, color: '#94a3b8' }}>
                      Employee
                    </span>
                    <span style={{ fontSize: 11.5, color: '#94a3b8' }}>
                      Short / Over
                    </span>
                  </div>
                  {employeeRows.length === 0 ? (
                    <div
                      style={{
                        fontSize: 13,
                        color: '#94a3b8',
                        padding: '12px 0',
                      }}
                    >
                      No employee shift data for this session.
                    </div>
                  ) : (
                    employeeRows.map((e, i) => {
                      const meta = empMeta(e.userId, e.name);
                      return (
                        <div
                          key={(e.clockId || '') + '-' + i}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            padding: '10px 0',
                            borderTop: i === 0 ? 'none' : '1px solid #f1f5f9',
                          }}
                        >
                          <div
                            style={{
                              width: 32,
                              height: 32,
                              borderRadius: 8,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: 12.5,
                              fontWeight: 600,
                              flexShrink: 0,
                              background: meta.fill,
                              color: meta.ink,
                            }}
                          >
                            {initialOf(e.name)}
                          </div>
                          <div style={{ minWidth: 0, flex: 1 }}>
                            <div
                              style={{
                                fontSize: 14.5,
                                fontWeight: 500,
                                color: '#0f172a',
                                lineHeight: 1.2,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {titleCase(e.name)}
                            </div>
                            <div
                              style={{
                                fontSize: 12,
                                color: '#94a3b8',
                                marginTop: 3,
                              }}
                            >
                              Pulls{' '}
                              <span style={{ ...monoStyle, color: '#64748b' }}>
                                {e.didPulls ? plain(e.pulls) : '—'}
                              </span>{' '}
                              · Tickets Out{' '}
                              <span style={{ ...monoStyle, color: '#64748b' }}>
                                {plain(e.ticketOut)}
                              </span>
                            </div>
                          </div>
                          <div
                            style={{
                              ...monoStyle,
                              fontSize: 14.5,
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              color: toneLight(e.shiftShort),
                            }}
                          >
                            {signed(e.shiftShort)}
                          </div>
                        </div>
                      );
                    })
                  )}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      borderTop: '1px solid #e2e8f0',
                      paddingTop: 12,
                      marginTop: 4,
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: '#0f172a',
                      }}
                    >
                      Total
                    </span>
                    <span
                      style={{
                        ...monoStyle,
                        fontSize: 14.5,
                        fontWeight: 600,
                        color: toneLight(empShorts),
                      }}
                    >
                      {signed(empShorts)}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Open Match Tickets — always visible, outside the breakdown (spec §4.4).
                Opens the Match Tickets screen directly on this day's reading
                session, and stashes the current week/day/tab so "Back" returns
                the manager to exactly where they were in the Weekly Report. */}
            <button
              type="button"
              onClick={() => this.openMatchTicketsForDay(dayData)}
              style={{
                marginTop: 14,
                width: '100%',
                borderRadius: 12,
                background: '#fff',
                border: '1px solid #e2e8f0',
                padding: '14px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
              }}
            >
              <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span
                  role="img"
                  aria-label="ticket"
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 14,
                    background: '#E8EBFF',
                  }}
                >
                  🎟️
                </span>
                <span style={{ textAlign: 'left' }}>
                  <span
                    style={{
                      display: 'block',
                      fontSize: 14.5,
                      fontWeight: 600,
                      color: '#0f172a',
                      lineHeight: 1.2,
                    }}
                  >
                    Open Match Tickets
                  </span>
                  <span
                    style={{
                      display: 'block',
                      fontSize: 12,
                      color: '#94a3b8',
                      marginTop: 2,
                    }}
                  >
                    Review ticket-by-ticket detail
                  </span>
                </span>
              </span>
              <span style={{ color: '#cbd5e1', fontSize: 16 }}>↗</span>
            </button>
          </div>
        )}
      </>
    );
  };

  renderShortAnalysis = () => {
    const { shortAnalysis } = this.props;
    const { selectedDay } = this.state;
    const Card = this.sxCard;
    const Row = this.sxRow;

    if (!shortAnalysis || !shortAnalysis.days) {
      return (
        <div style={{ padding: 24, color: '#6B7280', textAlign: 'center' }}>
          Loading Short Analysis…
        </div>
      );
    }

    const dayData = (shortAnalysis.days || []).find(
      (d) => d.day === selectedDay
    );
    if (!dayData) {
      return (
        <div
          style={{
            background: '#FFF',
            borderRadius: 18,
            padding: '40px 20px',
            textAlign: 'center',
            margin: '12px 0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          }}
        >
          <div style={{ fontSize: 40, marginBottom: 12 }}>
            <span role="img" aria-label="no data">
              📭
            </span>
          </div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 700,
              color: '#374151',
              marginBottom: 6,
            }}
          >
            No Session Data
          </div>
          <div style={{ fontSize: 13, color: '#9CA3AF' }}>
            No reading session was recorded for {selectedDay}.
          </div>
        </div>
      );
    }

    // matchTicketsDiff from backend is the "real" diff (raw − jackpotNotPay);
    // matchTicketsDiffRaw is the unadjusted reading-out vs. ticket-out diff.
    const matchDiff = Number(dayData.matchTicketsDiff) || 0;
    const matchDiffRaw = Number(dayData.matchTicketsDiffRaw) || 0;
    const jackpotNotPay = Number(dayData.jackpotNotPay) || 0;
    const pullsGap = Number(dayData.pullsGap) || 0;
    // "Other In" / "Other Out" from the readings tab fold into the two
    // reconciliations: reading-in + other-in for pulls, reading-out + other-out
    // for match tickets.
    const otherIn = Number(dayData.otherIn) || 0;
    const otherOut = Number(dayData.otherOut) || 0;
    const empShorts = Number(dayData.employeeShortsTotal) || 0;
    const weeklyShort = Number(dayData.weeklyShortOver) || 0;
    const equationX = Number(dayData.equationX) || 0;
    const matches = !!dayData.match;

    const sortedEmps = [...(dayData.employees || [])].sort(
      (a, b) => (a.shiftShort ?? 0) - (b.shiftShort ?? 0)
    );

    const totalEmployeePulls = (dayData.employees || []).reduce(
      (s, e) => s + (Number(e.pulls) || 0),
      0
    );
    // Ticket Out Total reconstructs actual recorded ticket-outs from the
    // raw (machine-only) reading diff (readingOut − rawDiff = ticketOutValue).
    const ticketOutTotal =
      (Number(dayData.readingTotalOut) || 0) - matchDiffRaw;
    // Displayed raw difference includes other-out on the reading-out side:
    // (readingOut + otherOut) − ticketOut = matchDiffRaw + otherOut.
    const matchDiffRawWithOther = matchDiffRaw + otherOut;

    const notes = this.buildShortAnalysisNotes(dayData);

    return (
      <div
        style={{
          fontFamily:
            "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
        }}
      >
        {/* Summary Header */}
        <div
          style={{
            background: 'linear-gradient(135deg, #1E293B 0%, #334155 100%)',
            borderRadius: 18,
            padding: '20px 18px',
            marginBottom: 12,
            color: '#FFF',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: '#94A3B8',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                }}
              >
                Short / Over
              </div>
              <div
                style={{
                  fontSize: 34,
                  fontWeight: 800,
                  marginTop: 4,
                  fontFamily: "'JetBrains Mono', monospace",
                  color:
                    weeklyShort < 0
                      ? '#FCA5A5'
                      : weeklyShort > 0
                      ? '#6EE7B7'
                      : '#CBD5E1',
                }}
              >
                {this.fmtMoney(weeklyShort)}
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#E0E7FF' }}>
                {dayData.day}
              </div>
              <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 2 }}>
                {dayData.dateFormatted || '—'}
              </div>
            </div>
          </div>
        </div>

        {/* Pulls Comparison */}
        <Card title="Pulls Comparison" icon="📥" accent="#6366F1">
          <Row
            label="Reading Total IN"
            value={this.fmtPlain(dayData.readingTotalIn)}
            border
          />
          <Row label="Other In" value={this.fmtPlain(otherIn)} border />
          <Row
            label="Employee Total Pulls"
            value={this.fmtPlain(totalEmployeePulls)}
            border
          />
          <Row
            label="Pulls Gap"
            value={this.sxBadge(pullsGap, 'md')}
            sub="General — not attributable to specific employee"
            bold
          />
        </Card>

        {/* Match Tickets */}
        <Card
          title="Match Tickets"
          icon="🎫"
          accent={matchDiff < 0 ? '#DC2626' : '#10B981'}
        >
          <Row
            label="Reading Out Total"
            value={this.fmtPlain(dayData.readingTotalOut)}
            border
          />
          <Row label="Other Out" value={this.fmtPlain(otherOut)} border />
          <Row
            label="Ticket Out Total"
            value={this.fmtPlain(ticketOutTotal)}
            border
          />
          {jackpotNotPay !== 0 ? (
            <>
              <Row
                label="Difference"
                value={this.sxBadge(matchDiffRawWithOther, 'md')}
                border
              />
              <Row
                label="Jackpot Not Pay"
                value={this.fmtPlain(jackpotNotPay)}
                border
              />
              <Row
                label="Real Difference"
                value={this.sxBadge(matchDiff, 'md')}
                sub={
                  matchDiff > 0
                    ? 'Unrecorded ticket-outs (cushion, after jackpot not paid)'
                    : matchDiff < 0
                    ? 'Over-tickets — employees paid out MORE'
                    : 'Perfect match after jackpot not paid'
                }
                bold
              />
            </>
          ) : (
            <Row
              label="Difference"
              value={this.sxBadge(matchDiff, 'md')}
              sub={
                matchDiff > 0
                  ? 'Unrecorded ticket-outs (cushion)'
                  : matchDiff < 0
                  ? 'Over-tickets — employees paid out MORE'
                  : 'Perfect match'
              }
              bold
            />
          )}
        </Card>

        {/* Employee Shorts */}
        <Card title="Employee Shorts" icon="👥" accent="#F59E0B">
          {sortedEmps.length === 0 ? (
            <div style={{ fontSize: 13, color: '#6B7280' }}>
              No employee shift data for this session.
            </div>
          ) : (
            <>
              {sortedEmps.map((emp) => this.sxEmployeeRow(emp, false))}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px 14px',
                  background: '#F9FAFB',
                  borderRadius: 10,
                  border: '1px solid #E5E7EB',
                  marginTop: 4,
                }}
              >
                <span
                  style={{ fontSize: 13, fontWeight: 700, color: '#374151' }}
                >
                  Total Employee Shorts
                </span>
                {this.sxBadge(empShorts, 'md')}
              </div>
            </>
          )}
        </Card>

        {/* Equation X Proof */}
        <Card
          title="Equation X — Proof"
          icon="🧮"
          accent={matches ? '#8B5CF6' : '#DC2626'}
          alert={!matches}
        >
          <div
            style={{
              background: matches ? '#F8FAFC' : '#FEF2F2',
              borderRadius: 12,
              padding: '16px',
              border: matches ? '2px dashed #CBD5E1' : '2px dashed #FCA5A5',
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            {[
              { label: 'Pulls Gap', val: pullsGap },
              { label: 'Match Tickets', val: matchDiff },
              { label: 'Employee Shorts', val: empShorts },
            ].map((item, i) => (
              <div
                key={item.label}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '6px 0',
                  fontSize: 14,
                  color: '#334155',
                  borderBottom:
                    i < 2
                      ? `1px solid ${matches ? '#E2E8F0' : '#FECACA'}`
                      : 'none',
                }}
              >
                <span>{item.label}</span>
                <span
                  style={{
                    color: item.val < 0 ? '#DC2626' : '#059669',
                    fontWeight: 600,
                  }}
                >
                  {this.fmtMoney(item.val)}
                </span>
              </div>
            ))}
            <div
              style={{
                borderTop: `2px solid ${matches ? '#64748B' : '#EF4444'}`,
                paddingTop: 10,
                marginTop: 8,
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: 16,
                fontWeight: 800,
              }}
            >
              <span>Equation X</span>
              <span style={{ color: equationX < 0 ? '#DC2626' : '#059669' }}>
                {this.fmtMoney(equationX)}
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: 16,
                fontWeight: 800,
                paddingTop: 6,
              }}
            >
              <span>Weekly Report</span>
              <span style={{ color: weeklyShort < 0 ? '#DC2626' : '#059669' }}>
                {this.fmtMoney(weeklyShort)}
              </span>
            </div>
            {matches ? (
              <div
                style={{
                  textAlign: 'center',
                  marginTop: 10,
                  fontSize: 13,
                  color: '#059669',
                  fontWeight: 700,
                  background: '#D1FAE5',
                  borderRadius: 8,
                  padding: '8px 0',
                }}
              >
                ✓ Balance Matched - Difference Identified
              </div>
            ) : (
              <div
                style={{
                  textAlign: 'center',
                  marginTop: 10,
                  fontSize: 13,
                  color: '#991B1B',
                  fontWeight: 700,
                  background: '#FEE2E2',
                  borderRadius: 8,
                  padding: '8px 0',
                }}
              >
                ✗ MISMATCH — check data entry
              </div>
            )}
          </div>
        </Card>

        {/* Analysis & Recommendations */}
        <Card title="Analysis & Recommendations" icon="📋" accent="#0EA5E9">
          {notes.map((note, i) => this.sxNoteCard(note, i))}
        </Card>

        {/* Equation X is included in the Full Report PDF via the toolbar download button */}
      </div>
    );
  };

  downloadShortAnalysisPdf = (dayData) => {
    const { userInfo } = this.props;
    const locName = userInfo?.selectedLocationName || 'NUVE SYSTEM';
    console.log(this.props);
    const C = PDF_COLORS;
    const doc = new jsPDF({ unit: 'pt', format: 'letter' });
    const pageW = doc.internal.pageSize.getWidth();
    const margin = 40;
    const f = this.fmtMoney;

    // Header (indigo, matches UI gradient start #312E81)
    doc.setFillColor(49, 46, 129);
    doc.rect(0, 0, pageW, 48, 'F');
    doc
      .setFont('helvetica', 'bold')
      .setFontSize(14)
      .setTextColor(...C.WHITE);
    doc.text(locName, margin, 22);
    doc
      .setFont('helvetica', 'normal')
      .setFontSize(10)
      .setTextColor(199, 210, 254);
    doc.text(`Short Analysis (Equation X) — ${dayData.day}`, margin, 38);
    doc.setFontSize(9).setTextColor(...C.WHITE);
    doc.text(dayData.dateFormatted || '', pageW - margin, 22, {
      align: 'right',
    });

    let y = 100;
    const isShort = (dayData.weeklyShortOver ?? 0) < 0;

    // Short/Over big number
    doc
      .setFont('helvetica', 'bold')
      .setFontSize(11)
      .setTextColor(...C.GRAY_TEXT);
    doc.text('Weekly Report Short/Over', margin, y);
    y += 32;
    doc
      .setFontSize(28)
      .setTextColor(isShort ? 220 : 22, isShort ? 38 : 163, isShort ? 38 : 74);
    doc.text(f(dayData.weeklyShortOver), margin, y);
    y += 28;

    const pdfTotalPulls = (dayData.employees || []).reduce(
      (s, e) => s + (Number(e.pulls) || 0),
      0
    );
    const pdfMatchDiff = Number(dayData.matchTicketsDiff) || 0;
    const pdfMatchDiffRaw = Number(dayData.matchTicketsDiffRaw) || 0;
    const pdfJackpotNotPay = Number(dayData.jackpotNotPay) || 0;
    const pdfOtherIn = Number(dayData.otherIn) || 0;
    const pdfOtherOut = Number(dayData.otherOut) || 0;
    const pdfTicketOutTotal =
      (Number(dayData.readingTotalOut) || 0) - pdfMatchDiffRaw;
    const pdfMatchDiffRawWithOther = pdfMatchDiffRaw + pdfOtherOut;

    // Pulls Comparison
    autoTable(doc, {
      startY: y,
      head: [['Pulls Comparison', '']],
      body: [
        ['Reading Total IN', f(dayData.readingTotalIn)],
        ['Other In', f(pdfOtherIn)],
        ['Employee Total Pulls', f(pdfTotalPulls)],
        ['Pulls Gap', f(dayData.pullsGap)],
      ],
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [79, 70, 229], textColor: 255 },
      margin: { left: margin, right: margin },
    });
    y = doc.lastAutoTable.finalY + 16;

    // Match Tickets
    const pdfMatchBody = [
      ['Reading Out Total', f(dayData.readingTotalOut)],
      ['Other Out', f(pdfOtherOut)],
      ['Ticket Out Total', f(pdfTicketOutTotal)],
      [
        'Difference',
        f(pdfJackpotNotPay !== 0 ? pdfMatchDiffRawWithOther : pdfMatchDiff),
      ],
    ];
    if (pdfJackpotNotPay !== 0) {
      pdfMatchBody.push(['Jackpot Not Pay', f(pdfJackpotNotPay)]);
      pdfMatchBody.push(['Real Difference', f(pdfMatchDiff)]);
    }
    pdfMatchBody.push([
      'Meaning',
      pdfMatchDiff < 0
        ? 'Over-tickets — direct loss'
        : pdfMatchDiff > 0
        ? 'Unrecorded ticket-outs — cushion'
        : 'Perfect match',
    ]);
    autoTable(doc, {
      startY: y,
      head: [['Match Tickets', '']],
      body: pdfMatchBody,
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [5, 150, 105], textColor: 255 },
      margin: { left: margin, right: margin },
    });
    y = doc.lastAutoTable.finalY + 16;

    // Employee Shorts
    autoTable(doc, {
      startY: y,
      head: [['Employee', 'Pulls', 'Ticket-Out', 'Short/Over']],
      body: (dayData.employees || []).map((e) => [
        e.name,
        f(e.pulls),
        f(e.ticketOut),
        f(e.shiftShort),
      ]),
      foot: [['Total', '', '', f(dayData.employeeShortsTotal)]],
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [37, 99, 235], textColor: 255 },
      footStyles: {
        fillColor: [240, 240, 245],
        textColor: 33,
        fontStyle: 'bold',
      },
      margin: { left: margin, right: margin },
    });
    y = doc.lastAutoTable.finalY + 16;

    // Equation X proof
    autoTable(doc, {
      startY: y,
      head: [['Equation X Proof', '']],
      body: [
        ['Pulls Gap', f(dayData.pullsGap)],
        ['+ Match Tickets Difference', f(dayData.matchTicketsDiff)],
        ['+ Employee Shorts Total', f(dayData.employeeShortsTotal)],
        ['= Equation X', f(dayData.equationX)],
        ['vs Weekly Report Short/Over', f(dayData.weeklyShortOver)],
        [
          'Result',
          dayData.match
            ? 'BALANCE MATCHED - DIFFERENCE IDENTIFIED'
            : 'MISMATCH — check data entry',
        ],
      ],
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [99, 102, 241], textColor: 255 },
      margin: { left: margin, right: margin },
    });
    y = doc.lastAutoTable.finalY + 30;

    // Footer
    doc.setFontSize(8).setTextColor(...C.GRAY_TEXT);
    const genDate = new Date().toLocaleString('en-US', {
      timeZone: 'America/Chicago',
    });
    doc.text(
      `Generated by NuVe System — ${genDate}`,
      margin,
      doc.internal.pageSize.getHeight() - 24
    );

    const fname = `Short Analysis - ${
      dayData.day
    } - ${new Date().getTime()}.pdf`;
    doc.save(fname);

    this.setState({ shortAnalysisPdfReady: true });
    setTimeout(() => this.setState({ shortAnalysisPdfReady: false }), 3000);
  };

  renderSummaryTable = () => {
    const { summary, employeeSummary, summaryBreakdown, userInfo } = this.props;
    if (!summary || summary.length === 0) return null;

    // Basic keeps the week-at-a-glance table only. The Summary Breakdown card
    // (Manager Loan to Bank) and the per-day employee short / Zelle table are
    // paid-tier, same as the Manager Loan and Daily Analysis tabs.
    const fullReport = hasFullWeeklyReport(userInfo);
    const sb = fullReport ? summaryBreakdown : null;

    const fmt = (n) => {
      const v = n ?? 0;
      const abs = Math.round(Math.abs(v)).toLocaleString();
      return v < 0 ? `($${abs})` : `$${abs}`;
    };

    // Loan Summary tiles. Prefer the server's WEEK TOTAL row so the card can
    // never disagree with the column above it; fall back to summing the day
    // rows for a week that came back without one.
    const weekRow = summary.find((r) => r.day === 'WEEK TOTAL');
    const sumDays = (key) =>
      summary
        .filter((r) => r.day !== 'WEEK TOTAL')
        .reduce((acc, r) => acc + (Number(r[key]) || 0), 0);
    const totalLoanIn = weekRow
      ? Number(weekRow.loanIn) || 0
      : sumDays('loanIn');
    const totalLoanOut = weekRow
      ? Number(weekRow.loanOut) || 0
      : sumDays('loanOut');
    const netLoanBalance = totalLoanIn - totalLoanOut;

    return (
      <div
        style={{
          p: { xs: 2, sm: 4 },
          width: '100%',
          height: 'calc(100vh - 300px)',
          overflowX: 'auto',
        }}
      >
        <div className="summary-container">
          <table className="summary-table">
            <thead>
              <tr>
                <th>Day</th>
                <th>Net Profit</th>
                <th>Gross Profit</th>
                <th>Short/Over</th>
                <th>Loan In</th>
                <th>Loan Out</th>
                <th>Customers</th>
                <th>Total In</th>
                <th>Total Out</th>
                <th>JP Other In</th>
                <th>JP Other Out</th>
                <th>Match</th>
                <th>Match %</th>
                <th>Payout %</th>
                <th>Hold %</th>
              </tr>
            </thead>
            <tbody>
              {summary.map((row, index) => {
                const isTotalRow = row.day === 'WEEK TOTAL';
                const boldStyle = isTotalRow ? { fontWeight: 'bold' } : {};

                return (
                  <tr key={index}>
                    <td style={boldStyle} data-label="Day">
                      {row.day}
                    </td>

                    <td
                      style={boldStyle}
                      data-label="Net Profit"
                      className={row.netProfit < 0 ? 'negative' : 'positive'}
                    >
                      {row.netProfit < 0
                        ? `($${Math.abs(row.netProfit).toLocaleString()})`
                        : `$${row.netProfit.toLocaleString()}`}
                    </td>
                    <td style={boldStyle} data-label="Gross Profit">
                      ${row.grossProfit.toLocaleString()}
                    </td>
                    <td
                      style={boldStyle}
                      data-label="Short/Over"
                      className={row.shortOver < 0 ? 'negative' : ''}
                    >
                      {row.shortOver < 0
                        ? `($${Math.abs(row.shortOver).toLocaleString()})`
                        : `$${row.shortOver.toLocaleString()}`}
                    </td>
                    <td style={boldStyle} data-label="Loan In">
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                        }}
                      >
                        ${(row.loanIn || 0).toLocaleString()}
                        {row.loanInComments && (
                          <Tooltip title="View Breakdown">
                            <IconButton
                              size="small"
                              style={{ padding: '2px' }}
                              onClick={() =>
                                this.handleCommentOpenDialog(row.loanInComments)
                              }
                            >
                              <DescriptionIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </span>
                    </td>
                    <td style={boldStyle} data-label="Loan Out">
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                        }}
                      >
                        ${(row.loanOut || 0).toLocaleString()}
                        {row.loanOutComments && (
                          <Tooltip title="View Breakdown">
                            <IconButton
                              size="small"
                              style={{ padding: '2px' }}
                              onClick={() =>
                                this.handleCommentOpenDialog(
                                  row.loanOutComments
                                )
                              }
                            >
                              <DescriptionIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </span>
                    </td>
                    <td style={boldStyle} data-label="Customers">
                      {row.custCount}
                    </td>

                    <td style={boldStyle} data-label="Total In">
                      ${row.totalIn.toLocaleString()}
                    </td>
                    <td style={boldStyle} data-label="Total Out">
                      ${row.totalOut.toLocaleString()}
                    </td>
                    <td style={boldStyle} data-label="JP Other In">
                      ${row.jpOtherIn.toLocaleString()}
                    </td>
                    <td style={boldStyle} data-label="JP Other Out">
                      ${row.jpOtherOut.toLocaleString()}
                    </td>

                    <td style={boldStyle} data-label="Match">
                      ${row.matchAmount.toLocaleString()}
                    </td>

                    <td style={boldStyle} data-label="Match %">
                      {row.matchPct !== '' &&
                      row.matchPct !== null &&
                      row.matchPct !== undefined
                        ? `${row.matchPct}%`
                        : ''}
                    </td>

                    <td style={boldStyle} data-label="Payout %">
                      {row.mchPayoutPct !== '' &&
                      row.mchPayoutPct !== null &&
                      row.mchPayoutPct !== undefined
                        ? `${row.mchPayoutPct}%`
                        : ''}
                    </td>

                    <td style={boldStyle} data-label="Hold %">
                      {row.mchHoldPct !== '' &&
                      row.mchHoldPct !== null &&
                      row.mchHoldPct !== undefined
                        ? `${row.mchHoldPct}%`
                        : ''}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {fullReport && (
          <div
            style={{
              marginTop: '24px',
              border: '1px solid #dbe3ec',
              borderRadius: '12px',
              background: '#fff',
              padding: '16px 16px 18px',
            }}
          >
            <p
              style={{
                margin: '0 0 12px',
                fontSize: '13px',
                fontWeight: 'bold',
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
                color: '#1b2a4a',
              }}
            >
              Loan Summary (This Week)
            </p>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: this.state.isMobile
                  ? '1fr'
                  : 'repeat(3, 1fr)',
                gap: '12px',
              }}
            >
              {this.renderLoanTile(
                'Total Loan In',
                totalLoanIn,
                'Money loaned to customers (this week)',
                '#1e8449',
                '#eafaf1',
                '↓'
              )}
              {this.renderLoanTile(
                'Total Loan Out',
                totalLoanOut,
                'Money given out / paid to customers (this week)',
                '#c0392b',
                '#fdecea',
                '↑'
              )}
              {this.renderLoanTile(
                'Net Loan Balance',
                netLoanBalance,
                'Loan In - Loan Out. Negative = more out than in',
                netLoanBalance < 0 ? '#c0392b' : '#1e8449',
                netLoanBalance < 0 ? '#fdecea' : '#eafaf1',
                <CalculateIcon style={{ fontSize: '16px' }} />
              )}
            </div>
          </div>
        )}

        {sb && (
          <div
            style={{
              maxWidth: '560px',
              marginLeft: this.state.isMobile ? '0px' : '24px',
              marginRight: this.state.isMobile ? '0px' : '24px',
              width: this.state.isMobile ? '100%' : 'auto',
            }}
          >
            {/* ── Top white card ── */}
            <div
              style={{
                background: 'var(--color-background-primary)',
                border: '1px solid var(--color-border-tertiary)',
                borderRadius: 'var(--border-radius-lg)',
                padding: '20px 20px 16px',
                marginBottom: '10px',
                overflowX: 'auto',
              }}
            >
              {/* Header */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '18px',
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    color: 'black',
                  }}
                >
                  Summary Breakdown
                </p>
                <span
                  style={{
                    width: '1px',
                    height: '16px',
                    background: 'var(--color-border-tertiary)',
                  }}
                />
                <p
                  style={{
                    margin: 0,
                    fontSize: '13px',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    color: '#2471a3',
                    letterSpacing: '0.04em',
                  }}
                >
                  Manager Loan to Bank
                </p>
              </div>

              {/* 3-card row: Previous + This Week = Total */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr auto 1fr auto 1fr',
                  gap: '8px',
                  alignItems: 'center',
                  marginBottom: '14px',
                }}
              >
                <div
                  style={{
                    background: '#c0392b',
                    color: '#fff',
                    borderRadius: '6px',
                    padding: '10px 6px',
                    fontSize: '11px',
                    fontWeight: 700,
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    lineHeight: '1.3',
                  }}
                >
                  Previous Week
                  <br />
                  Manager Loan
                  <br />
                  to Bank
                </div>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: 'var(--color-text-secondary)',
                  }}
                >
                  +
                </span>
                <div
                  style={{
                    background: '#2471a3',
                    color: '#fff',
                    borderRadius: '6px',
                    padding: '10px 6px',
                    fontSize: '11px',
                    fontWeight: 700,
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    lineHeight: '1.3',
                  }}
                >
                  This Week
                  <br />
                  Manager Loan
                  <br />
                  to Bank
                </div>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: 'var(--color-text-secondary)',
                  }}
                >
                  =
                </span>
                <div
                  style={{
                    background: '#1e8449',
                    color: '#fff',
                    borderRadius: '6px',
                    padding: '10px 6px',
                    fontSize: '12px',
                    fontWeight: 700,
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    lineHeight: '1.3',
                  }}
                >
                  Total
                </div>
              </div>

              {/* Values row */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr auto 1fr auto 1fr',
                  gap: '8px',
                  alignItems: 'center',
                  marginBottom: '4px',
                }}
              >
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 700,
                    color: '#c0392b',
                  }}
                >
                  {fmt(sb.previousWeekManagerLoan)}
                </div>
                <span
                  style={{
                    fontSize: '14px',
                    color: 'var(--color-text-secondary)',
                  }}
                >
                  +
                </span>
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 700,
                    color: '#2471a3',
                  }}
                >
                  {fmt(sb.thisWeekManagerLoanIn)}
                </div>
                <span
                  style={{
                    fontSize: '14px',
                    color: 'var(--color-text-secondary)',
                  }}
                >
                  =
                </span>
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 700,
                    color: '#1e8449',
                    background: '#eafaf1',
                    borderRadius: '5px',
                    padding: '6px 4px',
                  }}
                >
                  {fmt(sb.totalManagerLoan)}
                </div>
              </div>

              {/* Deductions Section */}
              <div
                style={{
                  borderTop: '1px solid var(--color-border-tertiary)',
                  marginTop: '16px',
                  paddingTop: '14px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                  }}
                >
                  <span style={{ fontSize: '13px', color: 'black' }}>
                    <strong style={{ textTransform: 'uppercase' }}>
                      Deductions
                    </strong>{' '}
                    (This Week)
                  </span>
                  <span
                    style={{
                      fontSize: '14px',
                      fontWeight: 700,
                      color: '#c0392b',
                    }}
                  >
                    - {fmt(sb.thisWeekDeductions)}
                  </span>
                </div>

                <div
                  style={{
                    background: '#f5f6fa',
                    borderRadius: '6px',
                    padding: '10px 12px',
                  }}
                >
                  <div
                    style={{
                      fontSize: '12px',
                      color: '#2471a3',
                      fontWeight: 600,
                      marginBottom: '8px',
                    }}
                  >
                    Applied to This Week First, then Previous Week
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '6px 0',
                      borderBottom: '1px solid var(--color-border-tertiary)',
                      fontSize: '13px',
                    }}
                  >
                    <span style={{ color: 'var(--color-text-secondary)' }}>
                      From This Week ({fmt(sb.thisWeekManagerLoanIn)})
                    </span>
                    <span style={{ color: '#c0392b', fontWeight: 600 }}>
                      - {fmt(sb.fromThisWeekDeduction)}
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '6px 0 0',
                      fontSize: '13px',
                    }}
                  >
                    <span style={{ color: 'var(--color-text-secondary)' }}>
                      From Previous Week ({fmt(sb.previousWeekManagerLoan)})
                    </span>
                    <span style={{ color: '#c0392b', fontWeight: 600 }}>
                      - {fmt(sb.fromPreviousWeekDeduction)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Remaining Manager Loan To Bank */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '12px',
                  padding: '12px 12px',
                  background: '#f5f6fa',
                  borderRadius: '6px',
                }}
              >
                <span
                  style={{
                    fontSize: '13px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    color: 'black',
                  }}
                >
                  Remaining Manager Loan to Bank
                </span>
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 700,
                    color: '#1e8449',
                    background: '#eafaf1',
                    padding: '5px 10px',
                    borderRadius: '5px',
                  }}
                >
                  {fmt(sb.remainingManagerLoan)}
                </span>
              </div>
            </div>

            {/* ── Bottom dark card ── */}
            <div
              style={{
                background: '#1a2f5a',
                borderRadius: 'var(--border-radius-lg)',
                padding: '18px 20px 20px',
              }}
            >
              {/* Net Profit */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 0',
                  borderBottom: '1px solid rgba(255,255,255,0.10)',
                }}
              >
                <span
                  style={{ fontSize: '14px', color: 'rgba(255,255,255,0.85)' }}
                >
                  Net Profit (This Week)
                </span>
                <span
                  style={{ fontSize: '15px', fontWeight: 500, color: '#fff' }}
                >
                  {fmt(sb.weekNetProfit)}
                </span>
              </div>

              {/* Adjustments */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 0',
                  borderBottom: '1px solid rgba(255,255,255,0.10)',
                }}
              >
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '7px' }}
                >
                  <span
                    style={{
                      fontSize: '14px',
                      color: 'rgba(255,255,255,0.85)',
                    }}
                  >
                    Adjustments
                  </span>
                </div>
                <span
                  style={{
                    fontSize: '15px',
                    fontWeight: 500,
                    color: sb.adjustment < 0 ? '#2ecc71' : '#e74c3c',
                  }}
                >
                  {sb.adjustment < 0
                    ? `+ $${Math.round(sb.adjustment).toLocaleString()}`
                    : `– ($${Math.round(
                        Math.abs(sb.adjustment)
                      ).toLocaleString()})`}
                </span>
              </div>

              {/* Available to Approve */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingTop: '16px',
                }}
              >
                <span
                  style={{ fontSize: '15px', fontWeight: 500, color: '#fff' }}
                >
                  Total Net Profit:
                </span>
                <span
                  style={{
                    fontSize: '22px',
                    fontWeight: 500,
                    color: sb.availableToApprove < 0 ? '#e74c3c' : '#2ecc71',
                  }}
                >
                  {fmt(sb.availableToApprove)}
                </span>
              </div>
            </div>
          </div>
        )}

        {fullReport && (
          <div className="summary-container" style={{ marginTop: '24px' }}>
            <table className="summary-table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Short/Over</th>
                  <th>Employee Names</th>
                  <th>Zelle</th>
                  <th>Receive By</th>
                </tr>
              </thead>
              <tbody>
                {employeeSummary?.map((row, index) => {
                  const isTotalRow = row.day === 'WEEK TOTAL';
                  const boldStyle = isTotalRow ? { fontWeight: 'bold' } : {};

                  return (
                    <tr key={index}>
                      <td style={boldStyle} data-label="Day">
                        {row.day}
                      </td>

                      <td
                        style={boldStyle}
                        data-label="Short/Over"
                        className={row.shortOver < 0 ? 'negative' : ''}
                      >
                        {row.shortOver < 0
                          ? `($${Math.abs(row.shortOver).toLocaleString()})`
                          : `$${row.shortOver.toLocaleString()}`}
                      </td>

                      <td style={boldStyle} data-label="Employee Names">
                        {row.employeeNames?.map((emp) => emp.name).join(', ') ||
                          ''}
                      </td>

                      <td style={boldStyle} data-label="Zelle">
                        {row.zelle != null
                          ? `$${row.zelle.toLocaleString()}`
                          : ''}
                      </td>

                      <td style={boldStyle} data-label="Receive By">
                        {row.receiveBy?.join(', ') || ''}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  // One tile of the Loan Summary card. Kept out of renderSummaryTable so the
  // three only differ by the values passed in.
  renderLoanTile = (label, amount, hint, accent, bg, glyph) => (
    <div
      style={{
        border: `1px solid ${accent}33`,
        borderRadius: '10px',
        background: bg,
        padding: '14px 16px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          marginBottom: '6px',
        }}
      >
        <span
          style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            background: accent,
            color: '#fff',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '15px',
            fontWeight: 'bold',
            flexShrink: 0,
          }}
        >
          {glyph}
        </span>
        <span
          style={{
            fontSize: '12px',
            fontWeight: 'bold',
            letterSpacing: '0.03em',
            textTransform: 'uppercase',
            color: '#425466',
          }}
        >
          {label}
        </span>
      </div>
      <div
        style={{
          fontSize: '26px',
          fontWeight: 'bold',
          color: accent,
          lineHeight: 1.2,
        }}
      >
        {amount < 0
          ? `($${Math.abs(Math.round(amount)).toLocaleString()})`
          : `$${Math.round(amount).toLocaleString()}`}
      </div>
      <div style={{ fontSize: '12px', color: '#5b6b7f', marginTop: '4px' }}>
        {hint}
      </div>
    </div>
  );

  // Get the Monday that closes the reading week opened by the given Tuesday
  getMondayFromTuesday = (tuesdayDate) => {
    const monday = new Date(tuesdayDate);
    monday.setDate(tuesdayDate.getDate() + 6);
    return monday;
  };

  // ── Filter display shift: stored week vs shown week ──
  //
  // The reading week the backend stores and reports on runs TUESDAY ->
  // MONDAY, and that is what applyDateRange sends and what every report
  // field is keyed on — none of that moves. Operators, though, read and
  // talk about their week as MONDAY -> SUNDAY, so the filter dialog renders
  // the range shifted back one day and shifts the user's pick forward again
  // before it touches state. A stored week of the 25th–31st therefore shows
  // as the 24th–30th.
  //
  // The shift lives ONLY in the two pickers below. state.fromDate /
  // state.toDate remain the real Tue/Mon pair everywhere else — the fetch,
  // the restore, the PDFs — so nothing downstream has to know about it.
  static DISPLAY_OFFSET_DAYS = -1;

  // Stored (Tue/Mon) -> shown (Mon/Sun)
  toDisplayDate = (date) =>
    this.shiftDays(date, ReportView.DISPLAY_OFFSET_DAYS);

  // Shown (Mon/Sun) -> stored (Tue/Mon)
  fromDisplayDate = (date) =>
    this.shiftDays(date, -ReportView.DISPLAY_OFFSET_DAYS);

  shiftDays = (date, days) => {
    if (!date) return null;
    const shifted = new Date(date);
    shifted.setDate(date.getDate() + days);
    return shifted;
  };

  // What the From picker may land on, in DISPLAY space
  isMonday = (date) => date.getDay() === 1;

  // Handle 'fromDate' — the user picks the displayed Monday; state keeps the
  // Tuesday it stands for.
  handleFromDateChange = (displayDate) => {
    if (!displayDate || !this.isMonday(displayDate)) return;

    const date = this.fromDisplayDate(displayDate);
    const toDate = this.getMondayFromTuesday(date);
    this.setState({
      fromDate: date,
      toDate,
    });
  };

  // Handle 'toDate' — the user picks the displayed Sunday, which must be the
  // one that closes the week fromDate opened.
  handleToDateChange = (displayDate) => {
    if (!displayDate) return;

    const { fromDate } = this.state;
    if (!fromDate) return;

    const validSunday = this.toDisplayDate(this.getMondayFromTuesday(fromDate));
    if (displayDate.toDateString() !== validSunday.toDateString()) return;

    this.setState({ toDate: this.fromDisplayDate(displayDate) });
  };

  handleAddExpense = () => {
    const { newExpense } = this.state;
    // Guard the handler too, not just the disabled button — an expense with no
    // type would land in the expense set ungrouped.
    if (!newExpense.expenseType || !newExpense.expenseType.trim()) {
      this.openFeedbackBar('error', 'Please pick an expense type.');
      return;
    }
    const { report } = this.props;
    const { selectedDay } = this.state;

    const selectedReport = report[selectedDay] || {};
    const expenseSet = [...(selectedReport.expenseSet || [])];

    const totalIndex = expenseSet.findIndex(
      (e) => e.description?.toLowerCase() === 'total'
    );

    const expenseToAdd = {
      ...newExpense,
      amount: parseFloat(newExpense.amount) || 0,
      isManager: true,
    };

    // Insert before total or at end if not found
    if (totalIndex >= 0) {
      expenseSet.splice(totalIndex, 0, expenseToAdd);
    } else {
      expenseSet.push(expenseToAdd);
    }

    // Update total if it exists
    const totalAmount = expenseSet
      .filter((e) => e.description?.toLowerCase() !== 'total')
      .reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0);

    const updatedSet = expenseSet.map((e) =>
      e.description?.toLowerCase() === 'total'
        ? { ...e, amount: totalAmount }
        : e
    );

    const callback = (success, message) => {
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.setState({
          showAddExpenseDialog: false,
          newExpense: {
            description: '',
            expenseType: '',
            amount: '',
            comments: '',
          },
        });

        this.refreshComponent(this.state.selectedSessionIds);
      }
    };

    this.props.updateReportField(
      selectedReport.sessionIds,
      'expenseSet',
      updatedSet,
      this.props.userInfo.selectedLocationId,
      callback
    );
  };

  handleDeleteExpense = () => {
    const { rowToDelete } = this.state;
    const { report } = this.props;
    const { selectedDay } = this.state;

    const selectedReport = report[selectedDay] || {};
    const expenseSet = [...(selectedReport.expenseSet || [])];

    if (
      rowToDelete !== null &&
      rowToDelete >= 0 &&
      rowToDelete < expenseSet.length
    ) {
      expenseSet.splice(rowToDelete, 1);
    }

    // Recalculate total
    const totalAmount = expenseSet
      .filter((e) => e.description?.toLowerCase() !== 'total')
      .reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0);

    const updatedSet = expenseSet.map((e) =>
      e.description?.toLowerCase() === 'total'
        ? { ...e, amount: totalAmount }
        : e
    );

    const callback = (success, message) => {
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.refreshComponent(this.state.selectedSessionIds);
      }
    };

    this.props.updateReportField(
      selectedReport.sessionIds,
      'expenseSet',
      updatedSet,
      this.props.userInfo.selectedLocationId,
      callback
    );

    this.setState({
      showDeleteDialog: false,
      rowToDelete: null,
    });
  };

  renderManagerSetting = () => {
    return (
      <ManagerSetting
        userInfo={this.props.userInfo}
        isBack={this.isBack}
        managerSetting={this.props.managerSetting}
        saveManagerSetting={this.props.saveManagerSetting}
        getManagerSummary={this.props.getManagerSummary}
      />
    );
  };

  // Read-only interactive shift report opened from the audit-log chip.
  // Mirrors the Employee Session shift view; while the loaded sessionData
  // doesn't yet match the clicked target, show a spinner.
  renderShiftDetail = () => {
    const target = this.state.shiftDetailTarget || {};
    const { sessionData, loadingSessionReports } = this.props;
    const matched =
      sessionData &&
      sessionData.sessionId === target.clockId &&
      sessionData.userId === target.userId;
    const headerButtons = [
      {
        icon: <KeyboardBackspaceIcon />,
        handler: () => this.closeShiftDetail(),
        title: BACK,
      },
    ];
    // The Readings-tab chip supplies full header meta (sessionId/date/timeIn/
    // timeOut); the audit-log chip supplies only userId/clockId/userName. So
    // fall back to the metadata getSessionReports now returns on sessionData —
    // but only once it MATCHES this target, otherwise a stale prior load would
    // briefly show the wrong shift's times.
    const meta = matched
      ? {
          userName: target.userName || sessionData.employeeName,
          sessionNumber: target.sessionId || sessionData.sessionNumber,
          date: target.date || sessionData.date,
          timeIn: target.timeIn || sessionData.clockIn,
          timeOut: target.timeOut || sessionData.clockOut,
        }
      : {
          userName: target.userName,
          sessionNumber: target.sessionId,
          date: target.date,
          timeIn: target.timeIn,
          timeOut: target.timeOut,
        };
    // Date arrives as "MM-dd-yyyy" (dashes, from DateUtil.formatDateMMDDYYYY)
    // and timeIn/timeOut as "h:mm a". deriveAssignedDay's parser expects
    // slash-separated US dates, so swap dashes for slashes and stitch the
    // date+time into one string.
    // Hours worked — computed from the full clock-in/out datetimes the
    // backend returns on sessionData (the header timeIn/timeOut may be
    // time-only, which can't be differenced reliably).
    const hoursLabel = matched
      ? formatHoursWorked(sessionData.hoursWorked)
      : null;
    const slashDate = (meta.date || '').replace(/-/g, '/');
    const dayLabel = deriveAssignedDay({
      timeIn:
        slashDate && meta.timeIn
          ? `${slashDate} ${meta.timeIn}`
          : slashDate || undefined,
    });
    // Shape the header meta into the { id, employee, clockIn, clockOut,
    // hoursWorked, assignedDay } object PdfBody/suggestedFilename expect —
    // same as EmployeeSession.buildSessionMeta.
    const pdfReady = matched && !loadingSessionReports;
    const sessionMeta = pdfReady
      ? {
          id: meta.sessionNumber,
          employee: meta.userName,
          clockIn: sessionData.clockIn || meta.timeIn,
          clockOut: sessionData.clockOut || meta.timeOut,
          hoursWorked: sessionData.hoursWorked,
          assignedDay: dayLabel,
        }
      : null;
    if (sessionMeta) {
      // Not `disabled` while busy — the backdrop spinner signals progress and
      // handleDownloadShiftPdf returns early on re-entry, so double-clicks are
      // a no-op.
      headerButtons.push({
        icon: <GetApp />,
        handler: () => this.handleDownloadShiftPdf(sessionMeta),
        title: 'Download PDF',
      });
    }
    return (
      <React.Fragment>
        <CustomToolbar
          title={'Shift Report'}
          createTitle={''}
          backTitle={''}
          headerButtons={headerButtons}
        />
        {/* Rich header — mirrors employeeSession ReportDetailScreen: icon,
            employee name, session #, clock in/out, and assigned day. */}
        <Box sx={{ px: 2, pt: 1.5, maxWidth: 760, mx: 'auto', width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 1.5,
                background: TOKENS.blue50,
                border: `1px solid ${TOKENS.blue200}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <DescriptionIcon sx={{ color: TOKENS.blue700, fontSize: 26 }} />
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: 20, fontWeight: 700, color: TOKENS.slate900 }}
              >
                {meta.userName || 'Shift Report'}
              </Typography>
              <Typography sx={{ fontSize: 13, color: TOKENS.slate500 }}>
                Session #{meta.sessionNumber || '—'}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 1,
              mt: 1.25,
            }}
          >
            {this.renderHeaderPill(
              dayLabel,
              TOKENS.blue50,
              TOKENS.blue700,
              TOKENS.blue200
            )}
            {this.renderHeaderPill(
              `In: ${meta.timeIn || '—'}`,
              TOKENS.emerald50,
              TOKENS.emerald700,
              TOKENS.emerald200
            )}
            {this.renderHeaderPill(
              `Out: ${meta.timeOut || 'Active'}`,
              meta.timeOut ? TOKENS.red50 : TOKENS.slate50,
              meta.timeOut ? TOKENS.red700 : TOKENS.slate500,
              meta.timeOut ? TOKENS.red200 : TOKENS.slate200
            )}
            {meta.date &&
              this.renderHeaderPill(
                meta.date,
                TOKENS.slate50,
                TOKENS.slate500,
                TOKENS.slate200
              )}
            {hoursLabel &&
              this.renderHeaderPill(
                `${hoursLabel} worked`,
                TOKENS.amber50,
                TOKENS.amber700,
                TOKENS.amber200
              )}
          </Box>
        </Box>
        {!matched || loadingSessionReports ? (
          <Backdrop
            open
            sx={{
              position: 'relative',
              minHeight: 240,
              color: '#1976d2',
              background: 'transparent',
            }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <Box sx={{ px: 2, maxWidth: 760, mx: 'auto', width: '100%' }}>
            <ShiftDetail
              readOnly
              session={null}
              sessionData={sessionData}
              customers={this.props.customers}
              employees={this.props.employees}
              categories={this.props.categories}
              manageBonusList={this.props.manageBonusList}
            />
          </Box>
        )}
        {pdfReady && (
          // Offscreen PdfBody — kept in the live DOM (positioned far off the
          // viewport) so html2canvas can snapshot real layout sizes when the
          // toolbar Download PDF button fires. Mirrors EmployeeSession.jsx.
          <div
            style={{
              position: 'fixed',
              left: -10000,
              top: 0,
              width: 720,
              background: '#fff',
              padding: 24,
              fontFamily: 'sans-serif',
              pointerEvents: 'none',
            }}
          >
            <div ref={this.shiftPdfRef}>
              <PdfBody
                type="shift"
                session={sessionMeta}
                sessionData={sessionData}
                locationName={this.props.userInfo?.selectedLocationName}
                customers={this.props.customers}
                employees={this.props.employees}
                manageBonusList={this.props.manageBonusList}
              />
            </div>
          </div>
        )}
        <Backdrop
          open={this.state.shiftPdfBusy}
          sx={{
            zIndex: (theme) => theme.zIndex.modal + 100,
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            background: 'rgba(0,0,0,0.6)',
          }}
        >
          <CircularProgress color="inherit" />
          <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
            Generating PDF…
          </Typography>
        </Backdrop>
      </React.Fragment>
    );
  };

  // Small rounded label used in the shift-report header (day, clock in/out,
  // date). Mirrors the Chip styling on the Employee Session report screen.
  renderHeaderPill = (label, bg, color, border) => (
    <Box
      sx={{
        height: 22,
        px: 1,
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '11px',
        fontSize: 12,
        fontWeight: 700,
        textTransform: 'uppercase',
        background: bg,
        color,
        border: `1px solid ${border}`,
      }}
    >
      {label}
    </Box>
  );

  isBack = () => {
    this.setState({ isSettings: false });
  };

  isManager = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return roles.includes('ROLE_ADMIN');
  };

  fmt = (val) => (val == null ? '$0' : `$${Number(val).toLocaleString()}`);

  // ────────────────────────────────────────────────────────────
  // PDF DOWNLOAD (client-side, jsPDF + autoTable)
  // ────────────────────────────────────────────────────────────
  pdfFmt = (v) => {
    const n = Number(v) || 0;
    return n < 0
      ? `($${Math.abs(n).toLocaleString()})`
      : `$${n.toLocaleString()}`;
  };

  buildProfitRows = (r) => {
    const totalExpenses = (r.expenseSet || [])
      .filter((i) => i.description !== 'Total')
      .reduce((s, i) => s + (i.amount || 0), 0);
    const computedTotalIn =
      (r.openingBalance || 0) +
      (r.totalIn || 0) +
      (r.jpOtherIn || 0) +
      (r.employeeShortPay || 0) +
      (r.loanIn || 0) +
      (r.addBank || 0);
    const computedReadingOut =
      (r.totalOut || 0) + (r.jpOtherOut || 0) - (r.jackpotNotPay || 0);
    const computedTotalOut =
      computedReadingOut + (r.minusBank || 0) + (totalExpenses || 0);
    const difference = computedTotalIn - computedTotalOut;

    return [
      ['Opening Balance', this.pdfFmt(r.openingBalance)],
      ['Reading Total IN', this.pdfFmt((r.totalIn || 0) + (r.jpOtherIn || 0))],
      ['Employee Short Payment', this.pdfFmt(r.employeeShortPay)],
      ['Loan In', this.pdfFmt(r.loanIn)],
      ['Add Bank', this.pdfFmt(r.addBank)],
      ['Total IN', this.pdfFmt(computedTotalIn)],
      ['Reading Total OUT', this.pdfFmt(computedReadingOut)],
      ['Minus Bank', this.pdfFmt(r.minusBank)],
      ['All Expenses', this.pdfFmt(totalExpenses)],
      ['Total OUT', this.pdfFmt(computedTotalOut)],
      ['Difference', this.pdfFmt(difference)],
      ['Ending Balance', this.pdfFmt(r.endingBalance)],
      ['Short / Over', this.pdfFmt(r.shortOver)],
      ['Net Profit', this.pdfFmt(r.netProfit)],
      ['Customers', String(r.customers?.length || 0)],
    ];
  };

  downloadWeeklyPdf = (mode) => {
    const { report, summary, employeeSummary, summaryBreakdown, userInfo } =
      this.props;
    const { selectedDay, fromDate, toDate } = this.state;
    const locName = userInfo?.selectedLocationName || 'NUVE SYSTEM';
    const C = PDF_COLORS;
    // The PDF has to answer the same plan question the tabs do -- a Manager
    // Loan tab a Standard user can't open but CAN download is not hidden.
    // Money in / money out / readings / expenses / closing balance are the
    // basic report and always render.
    const fullReport = hasFullWeeklyReport(userInfo);

    const formatDateShort = (d) => {
      if (!d) return '';
      return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    };

    const formatDateLong = (d) => {
      if (!d) return '';
      return d.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    };

    const dateRangeStr = `${formatDateShort(fromDate)} – ${formatDateShort(
      toDate
    )}`;

    const doc = new jsPDF({ unit: 'pt', format: 'letter' });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = 40;
    const contentW = pageW - margin * 2;

    // ── format helpers ──
    const pf = (v) => {
      const n = Number(v) || 0;
      return n < 0
        ? `($${Math.abs(n).toLocaleString()})`
        : `$${n.toLocaleString()}`;
    };

    const fmtRound = (n) => {
      const v = n ?? 0;
      const abs = Math.round(Math.abs(v)).toLocaleString();
      return v < 0 ? `($${abs})` : `$${abs}`;
    };

    const now = new Date();
    const genDate =
      now.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }) +
      ' ' +
      now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

    let pageNum = 0;

    // ── page chrome (header bar + footer) ──
    const drawChrome = (sub) => {
      pageNum++;
      // Navy header band with a thin indigo accent rule beneath it.
      doc.setFillColor(...C.NAVY);
      doc.rect(0, 0, pageW, 40, 'F');
      doc.setFillColor(...C.INDIGO);
      doc.rect(0, 40, pageW, 2.5, 'F');
      doc
        .setFont('helvetica', 'bold')
        .setFontSize(13)
        .setTextColor(...C.WHITE);
      doc.text(locName, margin, 26);
      doc
        .setFont('helvetica', 'normal')
        .setFontSize(9)
        .setTextColor(185, 189, 232);
      doc.text(sub, pageW - margin, 26, { align: 'right' });
      // Footer: hairline rule + muted meta.
      doc.setDrawColor(...C.BORDER).setLineWidth(0.75);
      doc.line(margin, pageH - 36, pageW - margin, pageH - 36);
      doc
        .setFont('helvetica', 'normal')
        .setFontSize(8)
        .setTextColor(...C.GRAY_TEXT);
      doc.text(`${locName} · Generated ${genDate}`, margin, pageH - 24);
      doc.text(`Page ${pageNum}`, pageW - margin, pageH - 24, {
        align: 'right',
      });
    };

    let subtitle = '';

    const newPage = () => {
      doc.addPage();
      drawChrome(subtitle);
    };

    // ── section heading: colored accent bar + navy label ──
    const heading = (title, y, color = C.BLUE_SECTION) => {
      doc.setFillColor(...color);
      doc.rect(margin, y - 9, 3.5, 13, 'F');
      doc
        .setFont('helvetica', 'bold')
        .setFontSize(12.5)
        .setTextColor(...C.DARK_TEXT);
      doc.text(title, margin + 11, y);
      return y + 6;
    };

    // ── generic styled table ──
    const table = (body, startY, opts = {}) => {
      const { amtColor, totalLabel, threeCol, headRow } = opts;

      autoTable(doc, {
        startY,
        head: headRow ? [headRow] : undefined,
        body,
        theme: 'plain',
        showHead: headRow ? 'firstPage' : false,
        margin: { left: margin, right: margin },
        tableWidth: contentW,
        styles: {
          fontSize: 10,
          cellPadding: { top: 7, bottom: 7, left: 10, right: 10 },
          lineWidth: 0,
          textColor: C.DARK_TEXT,
          font: 'helvetica',
        },
        headStyles: headRow
          ? {
              fillColor: C.NAVY,
              textColor: C.WHITE,
              fontStyle: 'bold',
              fontSize: 9,
              cellPadding: { top: 6, bottom: 6, left: 10, right: 10 },
            }
          : undefined,
        columnStyles: threeCol
          ? {
              0: { cellWidth: 70, fontStyle: 'bold' },
              1: { cellWidth: 'auto' },
              2: { halign: 'right', cellWidth: 90 },
            }
          : {
              0: { cellWidth: 'auto' },
              1: { halign: 'right', cellWidth: 110 },
            },
        alternateRowStyles: { fillColor: C.LIGHT_BG },

        didParseCell: (data) => {
          if (data.section !== 'body') return;
          const idx = data.row.index;
          const col = data.column.index;
          const last = idx === body.length - 1;
          const raw = (data.cell.raw || '').toString();
          const amtCol = threeCol ? 2 : 1;

          if (last && totalLabel) {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fontSize = 11;
          }
          if (col === amtCol && amtColor) {
            data.cell.styles.textColor = amtColor;
          }
          if (raw.startsWith('(') || raw.startsWith('-$')) {
            data.cell.styles.textColor = C.RED_OUT;
          }
          if (threeCol && col === 0) {
            const t = raw.toLowerCase();
            if (t.includes('loan') || t === '+')
              data.cell.styles.textColor = C.GREEN_IN;
            if (t.includes('minus') || t === '-')
              data.cell.styles.textColor = C.RED_OUT;
          }
        },

        didDrawCell: (data) => {
          if (data.section !== 'body') return;
          if (data.row.index === body.length - 1 && totalLabel) {
            doc.setDrawColor(...C.INDIGO).setLineWidth(1.2);
            doc.line(
              data.cell.x,
              data.cell.y,
              data.cell.x + data.cell.width,
              data.cell.y
            );
          }
        },
      });

      return doc.lastAutoTable.finalY;
    };

    // ── balance-check block: 3 KPI tiles + navy Net Profit hero ──
    const balanceCheck = (y, expected, ending, shortOver, netProfit) => {
      // Keep the whole block together on one page.
      if (y + 200 > pageH - 60) {
        newPage();
        y = 72;
      }

      y = heading('BALANCE CHECK', y, C.INDIGO);
      y += 12;

      // Three KPI tiles: Difference · Ending Balance · Short / Over
      const gap = 12;
      const tileW = (contentW - gap * 2) / 3;
      const tileH = 64;
      const tiles = [
        {
          label: 'DIFFERENCE',
          sub: 'Money In - Money Out',
          val: expected,
          color: expected < 0 ? C.RED_OUT : C.DARK_TEXT,
        },
        {
          label: 'ENDING BALANCE',
          sub: 'Cash counted at close',
          val: ending,
          color: C.DARK_TEXT,
        },
        {
          label: 'SHORT / OVER',
          sub: 'Ending - Difference',
          val: shortOver,
          color: shortOver < 0 ? C.RED_OUT : C.GREEN_IN,
        },
      ];
      tiles.forEach((t, i) => {
        const x = margin + i * (tileW + gap);
        doc.setFillColor(...C.LIGHT_BG);
        doc.roundedRect(x, y, tileW, tileH, 6, 6, 'F');
        doc.setDrawColor(...C.BORDER).setLineWidth(0.75);
        doc.roundedRect(x, y, tileW, tileH, 6, 6, 'S');
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(7.5)
          .setTextColor(...C.GRAY_TEXT);
        doc.text(t.label, x + tileW / 2, y + 17, { align: 'center' });
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(17)
          .setTextColor(...t.color);
        doc.text(pf(t.val), x + tileW / 2, y + 40, { align: 'center' });
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(6.5)
          .setTextColor(...C.GRAY_TEXT);
        doc.text(t.sub, x + tileW / 2, y + 54, { align: 'center' });
      });
      y += tileH + 18;

      // Net Profit hero — navy card with a big colored figure.
      const heroH = 58;
      doc.setFillColor(...C.NAVY);
      doc.roundedRect(margin, y, contentW, heroH, 8, 8, 'F');
      doc.setFillColor(...C.INDIGO);
      doc.rect(margin + 6, y + 12, 3, heroH - 24, 'F');
      doc
        .setFont('helvetica', 'bold')
        .setFontSize(11)
        .setTextColor(...C.WHITE);
      doc.text('NET PROFIT', margin + 22, y + 27);
      doc
        .setFont('helvetica', 'normal')
        .setFontSize(8)
        .setTextColor(150, 156, 200);
      doc.text('This shift', margin + 22, y + 41);
      const npColor = netProfit < 0 ? [255, 139, 131] : [74, 222, 155];
      doc
        .setFont('helvetica', 'bold')
        .setFontSize(26)
        .setTextColor(...npColor);
      doc.text(pf(netProfit), margin + contentW - 22, y + 38, {
        align: 'right',
      });
      return y + heroH + 20;
    };

    // ── employees + notes section ──
    const empNotes = (y, r) => {
      if (y > pageH - 120) {
        newPage();
        y = 72;
      }
      const emps = r.employeeDetails || [];
      if (emps.length) {
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(9)
          .setTextColor(...C.DARK_TEXT);
        const line =
          'EMPLOYEES ON SHIFT: ' +
          emps
            .map((e) => `${(e.name || '').toUpperCase()} (${e.timeIn || ''})`)
            .join(' · ');
        const lines = doc.splitTextToSize(line, contentW);
        doc.text(lines, margin, y);
        y += lines.length * 12 + 10;
      }
      if (y < pageH - 80) {
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(9)
          .setTextColor(...C.DARK_TEXT);
        doc.text('NOTES:', margin, y);
        y += 6;
        doc.setDrawColor(200, 200, 200).setLineWidth(0.5);
        doc.roundedRect(margin, y, contentW, 50, 4, 4, 'S');
      }
      return y + 60;
    };

    const ensureSpace = (need) => {
      if (y + need > pageH - 60) {
        newPage();
        y = 72;
      }
    };

    // ══════════════════════════════════════════════════════════
    //  BUILD THE PDF
    // ══════════════════════════════════════════════════════════
    const r = (report && selectedDay && report[selectedDay]) || {};
    const totalExpenses = (r.expenseSet || [])
      .filter((i) => i.description !== 'Total')
      .reduce((s, i) => s + (i.amount || 0), 0);
    const realIn = (r.totalIn || 0) + (r.jpOtherIn || 0);
    const realOut =
      (r.totalOut || 0) + (r.jpOtherOut || 0) - (r.jackpotNotPay || 0);
    const computedTotalIn =
      (r.openingBalance || 0) +
      realIn +
      (r.employeeShortPay || 0) +
      (r.loanIn || 0) +
      (r.addBank || 0);
    const computedTotalOut = realOut + (r.minusBank || 0) + totalExpenses;
    const difference = computedTotalIn - computedTotalOut;
    const custCount = r.customers?.length || 0;
    const dayLabel = selectedDay || '';

    // ══════════════════════════════════════════════════════════
    //  SUMMARY MODE — includes all 3 sections
    // ══════════════════════════════════════════════════════════
    if (mode === 'summary') {
      subtitle = `Weekly Summary — ${dateRangeStr}`;
      drawChrome(subtitle);
      let y = 72;
      doc
        .setFont('helvetica', 'bold')
        .setFontSize(18)
        .setTextColor(...C.DARK_TEXT);
      doc.text('Complete Weekly Summary', pageW / 2, y, { align: 'center' });
      y += 14;
      doc
        .setFont('helvetica', 'normal')
        .setFontSize(10)
        .setTextColor(...C.GRAY_TEXT);
      doc.text(dateRangeStr, pageW / 2, y, { align: 'center' });
      y += 20;

      // ────────────────────────────────────────────
      // 1. MAIN SUMMARY TABLE
      // ────────────────────────────────────────────
      if (summary?.length) {
        const head = [
          'Day',
          'Net Profit',
          'Gross',
          'Short/Over',
          'Loan In',
          'Loan Out',
          'Total In',
          'Total Out',
          'JP In',
          'JP Out',
          'Cust',
          'Match',
          'Match%',
          'Payout%',
          'Hold%',
        ];
        const body = summary.map((row) => [
          row.day,
          pf(row.netProfit),
          pf(row.grossProfit),
          pf(row.shortOver),
          pf(row.loanIn),
          pf(row.loanOut),
          pf(row.totalIn),
          pf(row.totalOut),
          pf(row.jpOtherIn),
          pf(row.jpOtherOut),
          String(row.custCount || 0),
          pf(row.matchAmount),
          row.matchPct != null ? `${row.matchPct}%` : '',
          row.mchPayoutPct != null ? `${row.mchPayoutPct}%` : '',
          row.mchHoldPct != null ? `${row.mchHoldPct}%` : '',
        ]);
        autoTable(doc, {
          startY: y,
          head: [head],
          body,
          theme: 'grid',
          headStyles: {
            fillColor: C.BLUE_HEADER,
            textColor: C.WHITE,
            fontSize: 7,
            fontStyle: 'bold',
            cellPadding: 4,
          },
          styles: { fontSize: 7, cellPadding: 3 },
          alternateRowStyles: { fillColor: C.LIGHT_BG },
          margin: { left: 20, right: 20 },
          didParseCell: (data) => {
            if (data.section !== 'body') return;
            const raw = (data.cell.raw || '').toString();
            if (raw.startsWith('(') || raw.startsWith('-$'))
              data.cell.styles.textColor = C.RED_OUT;
            if (data.row.raw?.[0] === 'WEEK TOTAL')
              data.cell.styles.fontStyle = 'bold';
          },
        });
        y = doc.lastAutoTable.finalY + 24;

        // Loan In breakdown notes — mirror the UI's breakdown dialog by
        // listing each day's CUSTOMER PAY LOANS comments below the table.
        // Require both a non-zero loanIn and non-empty comments so a day with
        // a stale CUSTOMER PAY LOANS note but zero amount stays out.
        const loanNotes = summary
          .filter(
            (row) =>
              row.day !== 'WEEK TOTAL' &&
              Number(row.loanIn || 0) !== 0 &&
              (row.loanInComments || '').trim()
          )
          .map((row) => ({ day: row.day, text: row.loanInComments.trim() }));

        if (loanNotes.length) {
          if (y + 60 > pageH - 60) {
            newPage();
            y = 72;
          }
          y = heading('LOAN IN — BREAKDOWN', y, C.DARK_TEXT);
          y += 8;
          autoTable(doc, {
            startY: y,
            head: [['Day', 'Notes']],
            body: loanNotes.map((n) => [n.day, n.text]),
            theme: 'grid',
            headStyles: {
              fillColor: C.BLUE_HEADER,
              textColor: C.WHITE,
              fontSize: 8,
              fontStyle: 'bold',
              cellPadding: 4,
            },
            styles: { fontSize: 8, cellPadding: 4, valign: 'top' },
            columnStyles: { 0: { cellWidth: 90, fontStyle: 'bold' } },
            alternateRowStyles: { fillColor: C.LIGHT_BG },
            margin: { left: 20, right: 20 },
          });
          y = doc.lastAutoTable.finalY + 24;
        }

        const loanOutNotes = summary
          .filter(
            (row) =>
              row.day !== 'WEEK TOTAL' &&
              Number(row.loanOut || 0) !== 0 &&
              (row.loanOutComments || '').trim()
          )
          .map((row) => ({ day: row.day, text: row.loanOutComments.trim() }));

        if (loanOutNotes.length) {
          if (y + 60 > pageH - 60) {
            newPage();
            y = 72;
          }
          y = heading('LOAN OUT - BREAKDOWN', y, C.DARK_TEXT);
          y += 8;
          autoTable(doc, {
            startY: y,
            head: [['Day', 'Notes']],
            body: loanOutNotes.map((n) => [n.day, n.text]),
            theme: 'grid',
            headStyles: {
              fillColor: C.BLUE_HEADER,
              textColor: C.WHITE,
              fontSize: 8,
              fontStyle: 'bold',
              cellPadding: 4,
            },
            styles: { fontSize: 8, cellPadding: 4, valign: 'top' },
            columnStyles: { 0: { cellWidth: 90, fontStyle: 'bold' } },
            alternateRowStyles: { fillColor: C.LIGHT_BG },
            margin: { left: 20, right: 20 },
          });
          y = doc.lastAutoTable.finalY + 24;
        }
      }

      // ────────────────────────────────────────────
      // 2. LOAN SUMMARY
      // ────────────────────────────────────────────
      if (fullReport && summary?.length) {
        const weekRow = summary.find((r) => r.day === 'WEEK TOTAL');
        const sumDays = (key) =>
          summary
            .filter((r) => r.day !== 'WEEK TOTAL')
            .reduce((acc, r) => acc + (Number(r[key]) || 0), 0);
        const totalLoanIn = weekRow
          ? Number(weekRow.loanIn) || 0
          : sumDays('loanIn');
        const totalLoanOut = weekRow
          ? Number(weekRow.loanOut) || 0
          : sumDays('loanOut');
        const netLoanBalance = totalLoanIn - totalLoanOut;

        // Take whichever of the running cursor and the last table bottom is
        // further down the page -- section 1 may have ended with no table.
        y = doc.lastAutoTable ? Math.max(y, doc.lastAutoTable.finalY + 24) : y;
        if (y + 90 > pageH - 60) {
          newPage();
          y = 72;
        }
        y = heading('LOAN SUMMARY (THIS WEEK)', y, C.DARK_TEXT);
        y += 8;

        autoTable(doc, {
          startY: y,
          head: [['Total Loan In', 'Total Loan Out', 'Net Loan Balance']],
          body: [
            [pf(totalLoanIn), pf(totalLoanOut), pf(netLoanBalance)],
            [
              'Money loaned to customers',
              'Money given out / paid to customers',
              'Loan In - Loan Out',
            ],
          ],
          theme: 'grid',
          headStyles: {
            fillColor: C.BLUE_HEADER,
            textColor: C.WHITE,
            fontSize: 8,
            fontStyle: 'bold',
            cellPadding: 5,
            halign: 'center',
          },
          styles: { fontSize: 8, cellPadding: 5, halign: 'center' },
          margin: { left: margin, right: margin },
          didParseCell: (data) => {
            if (data.section !== 'body') return;
            if (data.row.index === 0) {
              data.cell.styles.fontSize = 13;
              data.cell.styles.fontStyle = 'bold';
              const raw = (data.cell.raw || '').toString();
              data.cell.styles.textColor =
                raw.startsWith('(') || raw.startsWith('-$')
                  ? C.RED_OUT
                  : C.DARK_TEXT;
            } else {
              data.cell.styles.textColor = C.GRAY_TEXT;
            }
          },
        });
        y = doc.lastAutoTable.finalY + 24;
      }

      // ────────────────────────────────────────────
      // 3. SUMMARY BREAKDOWN
      // ────────────────────────────────────────────
      // Paid-tier only -- a section a Basic user cannot open on screen
      // must not arrive in their downloaded PDF either.
      const sb = fullReport ? summaryBreakdown : null;
      if (sb) {
        // Check if we need a new page
        if (y + 220 > pageH - 60) {
          newPage();
          y = 72;
        }

        y = heading(
          'SUMMARY BREAKDOWN  |  MANAGER LOAN TO BANK',
          y,
          C.DARK_TEXT
        );
        y += 8;

        const breakdownX = margin;
        const breakdownW = Math.min(contentW, 520);
        const colW = breakdownW / 5;
        const colX = (i) => breakdownX + colW * i;

        // Header pills row: Prev Week | + | This Week | = | Total
        const drawPill = (x, w, label1, label2, bgColor) => {
          doc.setFillColor(...bgColor);
          doc.roundedRect(x + 2, y, w - 4, 38, 4, 4, 'F');
          doc
            .setFont('helvetica', 'bold')
            .setFontSize(7)
            .setTextColor(...C.WHITE);
          if (label2) {
            doc.text(label1, x + w / 2, y + 16, { align: 'center' });
            doc.text(label2, x + w / 2, y + 28, { align: 'center' });
          } else {
            doc.text(label1, x + w / 2, y + 22, { align: 'center' });
          }
        };

        drawPill(
          colX(0),
          colW,
          'PREVIOUS WEEK',
          'MANAGER LOAN TO BANK',
          [192, 57, 43]
        );
        drawPill(
          colX(2),
          colW,
          'THIS WEEK',
          'MANAGER LOAN TO BANK',
          [36, 113, 163]
        );
        drawPill(colX(4), colW, 'TOTAL', '', [30, 132, 73]);

        // operator signs
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(12)
          .setTextColor(...C.GRAY_TEXT);
        doc.text('+', colX(1) + colW / 2, y + 22, { align: 'center' });
        doc.text('=', colX(3) + colW / 2, y + 22, { align: 'center' });
        // Drop the values well below the pill (pill bottom is at y + 38;
        // 11pt text drawn from baseline needs ~9pt of top clearance so the
        // amounts don't visually stick to the label text above).
        y += 58;

        // Values row
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(192, 57, 43);
        doc.text(fmtRound(sb.previousWeekManagerLoan), colX(0) + colW / 2, y, {
          align: 'center',
        });
        doc.setTextColor(36, 113, 163);
        doc.text(fmtRound(sb.thisWeekManagerLoanIn), colX(2) + colW / 2, y, {
          align: 'center',
        });
        // Total pill
        doc.setFillColor(234, 250, 241);
        doc.roundedRect(colX(4) + 4, y - 11, colW - 8, 18, 4, 4, 'F');
        doc.setTextColor(30, 132, 73);
        doc.text(fmtRound(sb.totalManagerLoan), colX(4) + colW / 2, y, {
          align: 'center',
        });
        y += 20;

        // Divider
        doc.setDrawColor(220, 220, 220).setLineWidth(0.5);
        doc.line(breakdownX, y, breakdownX + breakdownW, y);
        y += 14;

        // DEDUCTIONS (This Week) row
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(10)
          .setTextColor(...C.DARK_TEXT);
        doc.text('DEDUCTIONS', breakdownX, y);
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(10)
          .setTextColor(...C.GRAY_TEXT);
        doc.text('(This Week)', breakdownX + 70, y);
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(192, 57, 43);
        doc.text(
          `- ${fmtRound(sb.thisWeekDeductions)}`,
          breakdownX + breakdownW,
          y,
          { align: 'right' }
        );
        y += 10;

        // Applied to box
        doc.setFillColor(245, 246, 250);
        doc.roundedRect(breakdownX, y, breakdownW, 50, 4, 4, 'F');
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(8)
          .setTextColor(36, 113, 163);
        doc.text(
          'Applied to This Week First, then Previous Week',
          breakdownX + 8,
          y + 12
        );
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(9)
          .setTextColor(...C.GRAY_TEXT);
        doc.text(
          `From This Week (${fmtRound(sb.thisWeekManagerLoanIn)})`,
          breakdownX + 8,
          y + 26
        );
        doc.setTextColor(192, 57, 43).setFont('helvetica', 'bold');
        doc.text(
          `- ${fmtRound(sb.fromThisWeekDeduction)}`,
          breakdownX + breakdownW - 8,
          y + 26,
          { align: 'right' }
        );
        doc.setFont('helvetica', 'normal').setTextColor(...C.GRAY_TEXT);
        doc.text(
          `From Previous Week (${fmtRound(sb.previousWeekManagerLoan)})`,
          breakdownX + 8,
          y + 40
        );
        doc.setTextColor(192, 57, 43).setFont('helvetica', 'bold');
        doc.text(
          `- ${fmtRound(sb.fromPreviousWeekDeduction)}`,
          breakdownX + breakdownW - 8,
          y + 40,
          { align: 'right' }
        );
        y += 60;

        // Remaining Manager Loan To Bank
        doc.setFillColor(245, 246, 250);
        doc.roundedRect(breakdownX, y, breakdownW, 28, 4, 4, 'F');
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(10)
          .setTextColor(...C.DARK_TEXT);
        doc.text('REMAINING MANAGER LOAN TO BANK', breakdownX + 8, y + 18);
        doc.setFillColor(234, 250, 241);
        doc.roundedRect(breakdownX + breakdownW - 90, y + 6, 82, 16, 4, 4, 'F');
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(10)
          .setTextColor(30, 132, 73);
        doc.text(
          fmtRound(sb.remainingManagerLoan),
          breakdownX + breakdownW - 8,
          y + 18,
          { align: 'right' }
        );
        y += 40;

        y += 8;

        // ── Dark navy card (Net Profit, Adjustments, Total) ──
        if (y + 120 > pageH - 60) {
          newPage();
          y = 72;
        }

        const cardX = margin;
        const cardW = Math.min(contentW, 520);
        const cardH = 110;

        doc.setFillColor(...C.DARK_NAVY);
        doc.roundedRect(cardX, y, cardW, cardH, 6, 6, 'F');

        let cy = y + 20;

        // Net Profit row

        doc
          .setFont('helvetica', 'normal')
          .setFontSize(10)
          .setTextColor(...C.WHITE);
        doc.text('Net Profit (This Week)', cardX + 16, cy);
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(...C.WHITE);
        doc.text(fmtRound(sb.weekNetProfit), cardX + cardW - 16, cy, {
          align: 'right',
        });

        // Divider line
        cy += 12;
        doc.setDrawColor(50, 65, 110); // slightly lighter than navy to simulate transparency
        doc.setLineWidth(0.5);
        doc.line(cardX + 16, cy, cardX + cardW - 16, cy);
        cy += 16;

        // Adjustments row
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(10)
          .setTextColor(...C.WHITE);
        doc.text('Adjustments', cardX + 16, cy);

        const adjVal = sb.adjustment || 0;
        const adjColor = adjVal < 0 ? [46, 204, 113] : [231, 76, 60]; // green if negative (addition), red if positive (deduction)
        const adjText =
          adjVal < 0
            ? `+ $${Math.round(Math.abs(adjVal)).toLocaleString()}`
            : `– ($${Math.round(Math.abs(adjVal)).toLocaleString()})`;
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(...adjColor);
        doc.text(adjText, cardX + cardW - 16, cy, { align: 'right' });

        // Divider
        cy += 12;
        doc.setDrawColor(50, 65, 110);
        doc.setLineWidth(0.5);
        doc.line(cardX + 16, cy, cardX + cardW - 16, cy);
        cy += 20;

        // Total Net Profit row
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(...C.WHITE);
        doc.text('Total Net Profit:', cardX + 16, cy);

        const totalNetProfit = sb.availableToApprove || 0;
        const totalColor = totalNetProfit < 0 ? [231, 76, 60] : [46, 204, 113];
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(16)
          .setTextColor(...totalColor);
        doc.text(fmtRound(totalNetProfit), cardX + cardW - 16, cy + 2, {
          align: 'right',
        });

        y += cardH + 24;
      }

      // ────────────────────────────────────────────
      // 4. EMPLOYEE SUMMARY TABLE
      // ────────────────────────────────────────────
      if (fullReport && employeeSummary?.length) {
        if (y + 100 > pageH - 60) {
          newPage();
          y = 72;
        }

        y += 4;

        const empHead = [
          'Day',
          'Short/Over',
          'Employee Names',
          'Zelle',
          'Receive By',
        ];
        const empBody = employeeSummary.map((row) => [
          row.day || '',
          row.shortOver < 0
            ? `($${Math.abs(row.shortOver).toLocaleString()})`
            : `$${(row.shortOver || 0).toLocaleString()}`,
          row.employeeNames?.map((emp) => emp.name).join(', ') || '',
          row.zelle != null ? `$${row.zelle.toLocaleString()}` : '',
          row.receiveBy?.join(', ') || '',
        ]);

        autoTable(doc, {
          startY: y,
          head: [empHead],
          body: empBody,
          theme: 'grid',
          headStyles: {
            fillColor: C.BLUE_HEADER,
            textColor: C.WHITE,
            fontSize: 8,
            fontStyle: 'bold',
            cellPadding: 5,
          },
          styles: { fontSize: 8, cellPadding: 4 },
          alternateRowStyles: { fillColor: C.LIGHT_BG },
          margin: { left: margin, right: margin },
          columnStyles: {
            0: { cellWidth: 70 },
            1: { cellWidth: 70, halign: 'right' },
            2: { cellWidth: 'auto' },
            3: { cellWidth: 60, halign: 'right' },
            4: { cellWidth: 80 },
          },
          didParseCell: (data) => {
            if (data.section !== 'body') return;
            const raw = (data.cell.raw || '').toString();
            // Negatives in red
            if (raw.startsWith('(') || raw.startsWith('-$'))
              data.cell.styles.textColor = C.RED_OUT;
            // Bold the WEEK TOTAL row
            if (data.row.raw?.[0] === 'WEEK TOTAL')
              data.cell.styles.fontStyle = 'bold';
          },
        });
      }

      Utils.handlePdfAction(
        doc.output('arraybuffer'),
        'download',
        `Weekly_Summary_${formatDateShort(fromDate).replace(
          /[\s,]+/g,
          '_'
        )}_to_${formatDateShort(toDate).replace(/[\s,]+/g, '_')}.pdf`
      );
      return;
    }

    // ══════════════════════════════════════════════════════════
    //  QUICK / FULL (day report)
    // ══════════════════════════════════════════════════════════
    subtitle = `Weekly Report — Week ending ${formatDateShort(toDate)}`;
    drawChrome(subtitle);
    let y = 72;

    const title =
      mode === 'quick'
        ? 'WEEKLY CASH FLOW — QUICK SUMMARY'
        : 'WEEKLY REPORT — FULL DETAIL';
    doc
      .setFont('helvetica', 'bold')
      .setFontSize(20)
      .setTextColor(...C.DARK_TEXT);
    doc.text(title, pageW / 2, y, { align: 'center' });
    y += 16;
    doc
      .setFont('helvetica', 'normal')
      .setFontSize(10)
      .setTextColor(...C.GRAY_TEXT);
    doc.text(
      `${dayLabel} · Week ending ${formatDateLong(
        toDate
      )} · ${custCount} Customers`,
      pageW / 2,
      y,
      { align: 'center' }
    );
    y += 24;

    // ── MONEY IN ──
    y = heading('MONEY IN', y, C.GREEN_IN);
    const inRows = [];
    inRows.push(['Opening Balance', pf(r.openingBalance)]);
    inRows.push(['Total IN (machines)', pf(realIn)]);
    if ((r.employeeShortPay || 0) !== 0)
      inRows.push(['Employee Short Payment', pf(r.employeeShortPay)]);
    if ((r.loanIn || 0) !== 0) inRows.push(['Loan In', pf(r.loanIn)]);
    if ((r.addBank || 0) !== 0) inRows.push(['Add Bank', pf(r.addBank)]);
    inRows.push(['TOTAL MONEY IN', pf(computedTotalIn)]);
    y = table(inRows, y + 4, {
      amtColor: C.DARK_TEXT,
      totalLabel: 'TOTAL MONEY IN',
    });
    y += 26;

    // ── MONEY OUT ──
    y = heading('MONEY OUT', y, C.RED_OUT);
    const outRows = [
      ['Total Expenses', pf(totalExpenses)],
      ['Total OUT (machine payouts)', pf(realOut)],
    ];
    if ((r.minusBank || 0) !== 0) outRows.push(['Minus Bank', pf(r.minusBank)]);
    outRows.push(['TOTAL MONEY OUT', pf(computedTotalOut)]);
    y = table(outRows, y + 4, {
      amtColor: C.DARK_TEXT,
      totalLabel: 'TOTAL MONEY OUT',
    });
    y += 20;

    // ── BALANCE CHECK ──
    y = balanceCheck(
      y,
      difference,
      r.endingBalance || 0,
      r.shortOver || 0,
      r.netProfit || 0
    );

    // ── QUICK → done ──
    if (mode === 'quick') {
      y = empNotes(y, r);
      Utils.handlePdfAction(
        doc.output('arraybuffer'),
        'download',
        `Quick_Summary_${dayLabel}_${formatDateShort(toDate).replace(
          /[\s,]+/g,
          '_'
        )}.pdf`
      );
      return;
    }

    // ══════════════════════════════════════════════════════════
    //  FULL REPORT — additional pages
    // ══════════════════════════════════════════════════════════

    // ── MACHINE READINGS ──
    newPage();
    y = 72;
    y = heading('READINGS', y, C.BLUE_SECTION);
    y = table(
      [
        ['Total IN', pf(r.totalIn)],
        ['Total OUT', pf(r.totalOut)],
        ['JP / Other In', pf(r.jpOtherIn)],
        ['JP / Other Out', pf(r.jpOtherOut)],
        ['Jackpot Not Pay', pf(r.jackpotNotPay)],
        ['GROSS PROFIT', pf(r.grossProfit)],
      ],
      y + 4,
      { totalLabel: 'GROSS PROFIT', amtColor: C.DARK_TEXT }
    );
    y += 20;

    // ── TOTALS BY MACHINE TYPE ──
    // Same breakdown as the on-screen Readings card and the Master Reading PDF:
    // In / Out / Difference / Points / Bonus / Net, per machine type, from the
    // server-aggregated r.machineTypeTotals.
    const mtt = canViewReadingSummary(userInfo)
      ? (r.machineTypeTotals || []).filter(
          (t) => t.inValue || t.outValue || t.points || t.bonus
        )
      : [];
    if (mtt.length) {
      ensureSpace(70 + mtt.length * 16);
      y = heading('TOTALS BY MACHINE TYPE', y, C.INDIGO);
      const mNum = (n) => Math.round(n || 0).toLocaleString();
      const mMoney = (n) => pf(Math.round(n || 0));
      const mttTotals = mtt.reduce(
        (a, t) => ({
          inValue: a.inValue + (t.inValue || 0),
          outValue: a.outValue + (t.outValue || 0),
          difference: a.difference + (t.difference || 0),
          points: a.points + (t.points || 0),
          bonus: a.bonus + (t.bonus || 0),
          net: a.net + (t.net || 0),
        }),
        { inValue: 0, outValue: 0, difference: 0, points: 0, bonus: 0, net: 0 }
      );
      const mttBody = mtt.map((t) => [
        t.type,
        mMoney(t.inValue),
        mMoney(t.outValue),
        mMoney(t.difference),
        mNum(t.points),
        mNum(t.bonus),
        mMoney(t.net),
      ]);
      mttBody.push([
        'TOTAL',
        mMoney(mttTotals.inValue),
        mMoney(mttTotals.outValue),
        mMoney(mttTotals.difference),
        mNum(mttTotals.points),
        mNum(mttTotals.bonus),
        mMoney(mttTotals.net),
      ]);
      autoTable(doc, {
        startY: y + 4,
        head: [
          ['Machine Type', 'In', 'Out', 'Difference', 'Points', 'Bonus', 'Net'],
        ],
        body: mttBody,
        theme: 'grid',
        headStyles: {
          fillColor: C.NAVY,
          textColor: C.WHITE,
          fontSize: 8,
          fontStyle: 'bold',
          halign: 'right',
          cellPadding: 5,
        },
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: C.DARK_TEXT,
          lineColor: C.BORDER,
          lineWidth: 0.5,
        },
        alternateRowStyles: { fillColor: C.LIGHT_BG },
        margin: { left: margin, right: margin },
        columnStyles: {
          0: { halign: 'left', fontStyle: 'bold' },
          1: { halign: 'right' },
          2: { halign: 'right' },
          3: { halign: 'right' },
          4: { halign: 'right' },
          5: { halign: 'right' },
          6: { halign: 'right' },
        },
        didParseCell: (data) => {
          if (data.section !== 'body') return;
          const raw = (data.cell.raw || '').toString();
          const isTotalRow = data.row.index === mttBody.length - 1;
          if (isTotalRow) {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fillColor = C.NAVY;
            data.cell.styles.textColor = C.WHITE;
            if (data.column.index === 6) {
              data.cell.styles.textColor =
                raw.startsWith('(') || raw.startsWith('-$')
                  ? [255, 139, 131]
                  : [74, 222, 155];
            }
            return;
          }
          if (raw.startsWith('(') || raw.startsWith('-$'))
            data.cell.styles.textColor = C.RED_OUT;
        },
      });
      y = doc.lastAutoTable.finalY + 20;
    }

    // ── METER PULLS ──
    // The morning/night split is Daily Analysis material (it is computed
    // and rendered by renderDailyAnalysis on screen), so it travels with
    // that tab's entitlement rather than with Readings.
    if (fullReport) {
      y = heading('METER PULLS', y, C.TEAL_CUST);
      const pullDiff = Math.abs((r.morningPull || 0) - (r.nightPull || 0));
      y = table(
        [
          ['Morning Pull', (r.morningPull || 0).toLocaleString()],
          ['Night Pull', (r.nightPull || 0).toLocaleString()],
          ['Difference', pullDiff.toLocaleString()],
        ],
        y + 4,
        { amtColor: C.TEAL_CUST }
      );
      y += 20;
    }

    // ── CUSTOMER COUNT ──
    y = heading('CUSTOMER COUNT', y, C.BLUE_SECTION);
    y = table([['Total Customers', String(custCount)]], y + 4, {
      amtColor: C.TEAL_CUST,
    });
    y += 20;

    // ── ALL EXPENSES ──
    ensureSpace(200);
    y = heading('ALL EXPENSES', y, C.ORANGE_EXP);
    const expRows = (r.expenseSet || [])
      .filter((e) => e.description?.toLowerCase() !== 'total')
      .filter((e) => (e.amount || 0) !== 0)
      .map((e) => [e.description || '', pf(e.amount)]);
    expRows.push(['TOTAL EXPENSES', pf(totalExpenses)]);
    y = table(expRows, y + 4, {
      amtColor: C.ORANGE_EXP,
      totalLabel: 'TOTAL EXPENSES',
    });

    // ── CLOSING BALANCE ──
    newPage();
    y = 72;
    y = heading('CLOSING BALANCE', y, C.BLUE_SECTION);
    y = table(
      [
        ['Bank 1', pf(r.bank1)],
        ['Bank 2', pf(r.bank2)],
        ['Bank 3', pf(r.bank3)],
        ['Manager', pf(r.manager)],
        ['ATM', pf(r.atm)],
        ['Zelle', pf(r.zelle)],
        ['Supervisor', pf(r.supervisor)],
        ['ENDING BALANCE', pf(r.endingBalance)],
      ],
      y + 4,
      { totalLabel: 'ENDING BALANCE', amtColor: C.DARK_TEXT }
    );
    y += 20;

    // ── MANAGER LOAN TO BANK ──
    if (fullReport) {
      ensureSpace(120);
      y = heading('MANAGER LOAN TO BANK', y, C.BLUE_SECTION);
      const bbRows = (r.bankBoardList || []).map((trx) => {
        const lbl = trx.amount < 0 ? 'Minus' : 'Loan In';
        const dt = new Date(trx.createdDate).toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        });
        return [
          lbl,
          `${trx.employeeName || ''} ${dt}`,
          pf(Math.abs(trx.amount)),
        ];
      });
      bbRows.push(['TOTAL', '', pf(r.bankBoardBalance)]);
      y = table(bbRows, y + 4, {
        threeCol: true,
        totalLabel: 'TOTAL',
        amtColor: C.DARK_TEXT,
        headRow: ['Type', 'Name', 'Amount'],
      });
      y += 20;
    }

    // ── DAILY ANALYSIS (Activity + Equation X, breakdown fully expanded) ──
    // Mirrors the merged Daily Analysis tab; the PDF always renders the full
    // breakdown regardless of the on-screen collapse state (spec §10). No
    // Analysis & Recommendations, no Other In/Out (spec §12 removals).
    const { shortAnalysis } = this.props;
    const dayDataForPdf = shortAnalysis?.days?.find(
      (d) => d.day === selectedDay
    );
    if (fullReport && dayDataForPdf) {
      ensureSpace(260);
      y = heading('DAILY ANALYSIS', y, [74, 79, 186]);

      // Daily Activity — pulls / customers per shift come from the report day.
      const paMorningPull = Number(r.morningPull) || 0;
      const paNightPull = Number(r.nightPull) || 0;
      const paMorningCust = Number(r.morningCount) || 0;
      const paNightCust = Number(r.nightCount) || 0;
      const paTotalPulls = paMorningPull + paNightPull;
      const paTotalCust = paMorningCust + paNightCust;
      const paAvg =
        paTotalCust > 0 ? Math.round(paTotalPulls / paTotalCust) : null;

      y = table(
        [
          ['Total Pulls', pf(paTotalPulls)],
          ['Customers', paTotalCust.toLocaleString()],
          ['Avg / Customer', paAvg == null ? '—' : pf(paAvg)],
          [
            'Morning Shift',
            `${pf(paMorningPull)}  ·  ${paMorningCust.toLocaleString()} cust`,
          ],
          [
            'Night Shift',
            `${pf(paNightPull)}  ·  ${paNightCust.toLocaleString()} cust`,
          ],
        ],
        y + 4,
        { headRow: ['Daily Activity', ''] }
      );
      y += 12;

      const pdfTotalPulls = (dayDataForPdf.employees || []).reduce(
        (s, e) => s + (Number(e.pulls) || 0),
        0
      );
      const pdfMatchDiff = Number(dayDataForPdf.matchTicketsDiff) || 0;
      const pdfMatchDiffRaw = Number(dayDataForPdf.matchTicketsDiffRaw) || 0;
      const pdfOtherIn = Number(dayDataForPdf.otherIn) || 0;
      const pdfOtherOut = Number(dayDataForPdf.otherOut) || 0;
      const pdfJackpotNotPay = Number(dayDataForPdf.jackpotNotPay) || 0;
      // Ticket Total OUT = actual recorded ticket-outs (reading-out − raw diff).
      // Other In / Other Out are already folded into pullsGap / matchTicketsDiff
      // (and Equation X); they are surfaced as rows only when non-zero.
      const pdfTicketOutTotal =
        (Number(dayDataForPdf.readingTotalOut) || 0) - pdfMatchDiffRaw;
      const pdfMatchDiffRawWithOther = pdfMatchDiffRaw + pdfOtherOut;

      const pdfPullsRows = [
        ['Reading Total IN', pf(dayDataForPdf.readingTotalIn)],
      ];
      if (pdfOtherIn !== 0) pdfPullsRows.push(['Other In', pf(pdfOtherIn)]);
      pdfPullsRows.push(['Employee Total Pulls', pf(pdfTotalPulls)]);
      pdfPullsRows.push(['Pulls Gap', pf(dayDataForPdf.pullsGap)]);
      y = table(pdfPullsRows, y + 4, { headRow: ['Pulls Comparison', ''] });
      y += 12;

      const pdfMatchRows = [
        ['Reading Total OUT', pf(dayDataForPdf.readingTotalOut)],
      ];
      if (pdfOtherOut !== 0) pdfMatchRows.push(['Other Out', pf(pdfOtherOut)]);
      pdfMatchRows.push(['Ticket Total OUT', pf(pdfTicketOutTotal)]);
      if (pdfJackpotNotPay !== 0) {
        pdfMatchRows.push(['Difference', pf(pdfMatchDiffRawWithOther)]);
        pdfMatchRows.push(['Jackpot Not Pay', pf(pdfJackpotNotPay)]);
        pdfMatchRows.push(['Real Difference', pf(pdfMatchDiff)]);
      } else {
        pdfMatchRows.push(['Difference', pf(pdfMatchDiff)]);
      }
      y = table(pdfMatchRows, y + 4, { headRow: ['Match Tickets', ''] });
      y += 12;

      y = table(
        (dayDataForPdf.employees || [])
          .map((e) => [e.name, pf(e.pulls), pf(e.ticketOut), pf(e.shiftShort)])
          .concat([['Total', '', '', pf(dayDataForPdf.employeeShortsTotal)]]),
        y + 4,
        {
          headRow: ['Employee', 'Pulls', 'Tickets Out', 'Short / Over'],
          threeCol: false,
          totalLabel: 'Total',
        }
      );
      y += 12;

      y = table(
        [
          ['Pulls Gap', pf(dayDataForPdf.pullsGap)],
          ['Match Tickets', pf(dayDataForPdf.matchTicketsDiff)],
          ['Employee Shorts', pf(dayDataForPdf.employeeShortsTotal)],
          ['Equation X', pf(dayDataForPdf.equationX)],
          ['Weekly Report', pf(dayDataForPdf.weeklyShortOver)],
          [
            'Result',
            dayDataForPdf.match ? 'Balanced' : 'Mismatch — check data entry',
          ],
        ],
        y + 4,
        { headRow: ['Equation X Proof', ''] }
      );
      y += 20;
    }

    // ── MACHINE PERCENTAGES ──
    ensureSpace(140);
    y = heading('MACHINE PERCENTAGES', y, C.PURPLE_PCT);
    const mp = r.machinePercentages || {};
    y = table(
      allowedPercentageRows(
        userInfo,
        [
          {
            field: 'machinePayoutPct',
            label: 'Machine Payout (Total OUT / Total IN)',
          },
          {
            field: 'machineHoldPct',
            label: 'Machine Hold (Gross Profit / Total IN)',
          },
          {
            field: 'gameroomPayoutPct',
            label: 'Gameroom Payout (Expenses / Total IN)',
          },
          { field: 'weKeptPct', label: 'We Kept (Net Profit / Total IN)' },
        ],
        BASIC_MACHINE_PCT_FIELDS
      ).map(({ field, label }) => [
        label,
        mp[field] != null ? `${mp[field]}%` : '0%',
      ]),
      y + 4,
      { amtColor: C.PURPLE_PCT }
    );
    y += 20;

    // ── EXPENSE PERCENTAGES ──
    ensureSpace(200);
    y = heading('EXPENSE PERCENTAGES', y, C.ORANGE_EXP);
    doc
      .setFont('helvetica', 'normal')
      .setFontSize(9)
      .setTextColor(...C.GRAY_TEXT);
    doc.text(
      `Each expense as % of Total IN (${pf(r.totalIn)})`,
      margin + 11,
      y + 12
    );
    y += 20;

    const pct = r.percentages || {};
    const pctRows = allowedPercentageRows(
      userInfo,
      [
        { field: 'matchPct', label: 'Match' },
        { field: 'highRollerMatchPct', label: 'High Roller Match' },
        { field: 'bonusPct', label: 'Bonus' },
        { field: 'employeePct', label: 'Employees' },
        { field: 'drawingsPct', label: 'Drawings' },
        { field: 'samsPct', label: "Sam's" },
        { field: 'foodExpensePct', label: 'Food Expense' },
        { field: 'maintenancePct', label: 'Maintenance/Upgrades' },
        { field: 'miscellaneousTotal', label: 'Miscellaneous' },
        { field: 'totalPayPct', label: 'Total Pay' },
      ],
      BASIC_EXPENSE_PCT_FIELDS
    )
      .filter(({ field }) => pct[field] != null && pct[field] !== 0)
      .map(({ field, label }) => [label, `${pct[field]}%`]);

    const tpIdx = pctRows.findIndex((row) => row[0] === 'Total Pay');
    if (tpIdx > -1 && tpIdx !== pctRows.length - 1) {
      const tp = pctRows.splice(tpIdx, 1)[0];
      pctRows.push(tp);
    }
    y = table(pctRows, y + 4, {
      amtColor: C.ORANGE_EXP,
      totalLabel: 'Total Pay',
    });
    y += 16;

    // ── EMPLOYEES + NOTES ──
    y = empNotes(y, r);

    Utils.handlePdfAction(
      doc.output('arraybuffer'),
      'download',
      `Full_Weekly_Report_${dayLabel}_${formatDateShort(toDate).replace(
        /[\s,]+/g,
        '_'
      )}.pdf`
    );
  };

  render() {
    const { report, allSessionIds } = this.props;
    const {
      selectedDay,
      selectedSessionIds,
      fromDate,
      toDate,
      nameInput,
      amountInput,
      type,
      showPdfViewer,
      pdfData,
      scale,
      editSummaryMode,
    } = this.state;

    // The filter renders the week shifted back one day (Mon -> Sun) while
    // state keeps the stored Tue -> Mon pair. See the display-shift block by
    // handleFromDateChange.
    const displayFromDate = this.toDisplayDate(fromDate);
    const displayToDate = this.toDisplayDate(toDate);
    const validSunday = fromDate
      ? this.toDisplayDate(this.getMondayFromTuesday(fromDate))
      : null;

    const hasReportData = report && Object.keys(report).length > 0;
    const selectedReport = hasReportData ? report[selectedDay] || {} : {};

    const totalExpenses = (selectedReport.expenseSet || [])
      .filter((item) => item.description !== 'Total')
      .reduce((sum, item) => sum + (item.amount || 0), 0);

    const bankBoardList = selectedReport.bankBoardList || [];
    const bankBoardBalance = selectedReport.bankBoardBalance || 0;
    const bankOpeningBalance = selectedReport.bankOpeningBalance || 0;
    const isApplyDisabled = !amountInput || !type || !nameInput;
    // Owner-only edit/remove on the Manager Loan To Bank rows, surfaced with
    // the same Edit Summary toggle that reveals the card's Apply row.
    const canManageBankBoard = this.canManageBankBoard() && editSummaryMode;

    const { description, amount, expenseType } = this.state.newExpense;
    // Expense Type is required — an untyped expense can't be grouped into the
    // weekly expense breakdown, so block the save instead of letting it through.
    const isSaveDisabled =
      !description.trim() ||
      !expenseType ||
      !expenseType.trim() ||
      !amount.trim() ||
      isNaN(Number(amount));

    const { bankList = [] } = selectedReport;

    const customerPayLoans = bankList.find(
      (b) => b.description?.toUpperCase() === 'CUSTOMER PAY LOANS'
    );

    //check to disable manager summary

    const disableButton = !this.canEditReport();

    let headerButtons;

    headerButtons = [];
    if (this.state.showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <PrintIcon />,
          title: 'Print PDF',
          handler: () => {
            const { pdfData } = this.state;
            if (!pdfData) return;
            Utils.handlePdfAction(pdfData, 'print', 'print.pdf');
          },
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span key="zoom-label" style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else if (this.state.showAuditLog) {
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        handler: () => this.setState({ showAuditLog: false }),
        title: 'Back',
      });
    } else {
      this.isManager() &&
        this.userHasATMRole() &&
        (this.state.isSettings
          ? headerButtons.push({
              icon: <KeyboardBackspaceIcon />,
              handler: () => this.setState({ isSettings: false }),
              title: 'Back',
            })
          : headerButtons.push({
              icon: <SettingsIcon />,
              handler: () => this.setState({ isSettings: true }),
              title: 'Manager Settings',
            }));

      if (
        !this.state.isSettings &&
        this.canViewAuditLog() &&
        this.hasAuditLogForCurrentSessions()
      ) {
        headerButtons.push({
          icon: (
            <span className="weekly-report-audit-flash-wrap">
              <span className="weekly-report-audit-flash-ring" />
              <FactCheckIcon className="weekly-report-audit-flash" />
            </span>
          ),
          handler: () => this.setState({ showAuditLog: true }),
          title: 'Audit Log — changes recorded',
        });
      }
    }

    const isDaySelected =
      selectedDay && selectedDay !== 'MANAGER' && hasReportData;

    if (isDaySelected && !this.state.showPdfViewer && !this.state.isSettings) {
      headerButtons.push({
        icon: <GetApp ref={this.pdfBtnRef} />,
        handler: this.handlePdfPopperToggle,
        title: 'Download PDF',
      });
    }

    return (
      <React.Fragment>
        {/* The shift-detail overlay renders its own back toolbar, so suppress
            this one whenever it's open (it can be opened from the readings tab
            where showAuditLog is false). */}
        {!this.state.showShiftDetail &&
          (!this.state.showAuditLog || this.state.showPdfViewer) && (
            <CustomToolbar
              title={
                this.state.isSettings ? 'Manager Settings' : 'Weekly Report'
              }
              createTitle={''}
              backTitle={''}
              headerButtons={headerButtons}
            />
          )}

        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <Dialog
          open={this.state.showDeleteDialog}
          onClose={() => this.setState({ showDeleteDialog: false })}
        >
          <DialogTitle>Confirm</DialogTitle>
          <DialogContent style={{ marginBottom: '16px' }}>
            Are you sure you want to remove this expense?
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                width: '100px',
                marginBottom: '16px',
              }}
              onClick={() => this.setState({ showDeleteDialog: false })}
            >
              Cancel
            </Button>
            <Button
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
              color="primary"
              variant="contained"
              onClick={this.handleDeleteExpense}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Manager Loan To Bank — owner edit ───────────────────────── */}
        <Dialog
          open={Boolean(this.state.bankEntryToEdit)}
          onClose={this.handleCloseBankEntryEdit}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>Edit Bank Entry</DialogTitle>
          <DialogContent style={{ marginBottom: '16px' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                paddingTop: '8px',
              }}
            >
              {/* Employee rows are real bank transactions and are always an
                  addition to the bank, so the type is fixed for them. */}
              {this.state.bankEntryToEdit?.source !== 'employee' && (
                <TextField
                  select
                  label="Type"
                  value={this.state.bankEditType}
                  onChange={(e) =>
                    this.setState({ bankEditType: e.target.value })
                  }
                  fullWidth
                >
                  <MenuItem value="add">Add</MenuItem>
                  <MenuItem value="minus">Minus</MenuItem>
                </TextField>
              )}
              <TextField
                label="Name"
                value={this.state.bankEditName}
                onChange={(e) =>
                  this.setState({ bankEditName: e.target.value })
                }
                fullWidth
              />
              <TextField
                label="Amount"
                value={this.state.bankEditAmount}
                onChange={(e) =>
                  this.setState({
                    bankEditAmount: e.target.value.replace(/\D/g, ''),
                  })
                }
                fullWidth
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ width: '100px', marginBottom: '16px' }}
              onClick={this.handleCloseBankEntryEdit}
            >
              Cancel
            </Button>
            <Button
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
              color="primary"
              variant="contained"
              disabled={
                this.state.bankEntryBusy ||
                !this.state.bankEditAmount ||
                !this.state.bankEditName.trim()
              }
              onClick={this.handleSaveBankEntryEdit}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Manager Loan To Bank — owner delete confirmation ────────── */}
        <Dialog
          open={Boolean(this.state.bankEntryToDelete)}
          onClose={() => this.setState({ bankEntryToDelete: null })}
        >
          <DialogTitle>Confirm</DialogTitle>
          <DialogContent style={{ marginBottom: '16px' }}>
            Are you sure you want to remove this bank entry
            {this.state.bankEntryToDelete
              ? ` of $${Math.abs(
                  Number(this.state.bankEntryToDelete.amount) || 0
                ).toLocaleString()}`
              : ''}
            ? This will change the bank balance for the week.
            {this.state.bankEntryToDelete?.source === 'employee' && (
              <div style={{ marginTop: '10px', color: '#b45309' }}>
                This row is {this.state.bankEntryToDelete.employeeName}&rsquo;s
                shift transaction — removing it here also removes it from their
                shift report.
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              style={{ width: '100px', marginBottom: '16px' }}
              onClick={() => this.setState({ bankEntryToDelete: null })}
            >
              Cancel
            </Button>
            <Button
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
              color="primary"
              variant="contained"
              disabled={this.state.bankEntryBusy}
              onClick={this.handleConfirmBankEntryDelete}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* Amount + reason for a hand-edited Cash Flow figure. A dialog
            rather than the inline row: two fields of different shapes do
            not fit beside each other in that column, and the reason is
            the half people read back later. */}
        <Dialog
          open={this.state.noteEditor.open}
          onClose={this.closeNoteEditor}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Edit {this.state.noteEditor.label}</DialogTitle>
          <DialogContent>
            <TextField
              label="Amount"
              type="number"
              variant="outlined"
              style={{ marginTop: '8px' }}
              InputLabelProps={{ shrink: true }}
              fullWidth
              autoFocus
              value={this.state.noteEditor.amount}
              onChange={(e) =>
                this.handleNoteEditorChange('amount', e.target.value)
              }
            />
            <TextField
              label="Comment"
              variant="outlined"
              style={{ marginTop: '24px' }}
              InputLabelProps={{ shrink: true }}
              fullWidth
              multiline
              rows={3}
              required
              placeholder="Why was this changed?"
              error={!(this.state.noteEditor.note || '').trim()}
              helperText={
                !(this.state.noteEditor.note || '').trim()
                  ? 'A comment is required.'
                  : 'Shown in the Loan In breakdown with the amount and your name.'
              }
              value={this.state.noteEditor.note}
              onChange={(e) =>
                this.handleNoteEditorChange('note', e.target.value)
              }
            />
            {this.state.noteEditor.savedBy && (
              <div
                style={{
                  marginTop: '12px',
                  fontSize: '12px',
                  color: '#94a3b8',
                }}
              >
                Last changed by {this.state.noteEditor.savedBy}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              style={{ width: '100px', marginBottom: '16px' }}
              onClick={this.closeNoteEditor}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
              disabled={!(this.state.noteEditor.note || '').trim()}
              onClick={this.saveNoteEditor}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.showAddExpenseDialog}
          onClose={() => this.setState({ showAddExpenseDialog: false })}
        >
          <DialogTitle>Add Expense</DialogTitle>
          <DialogContent>
            <TextField
              variant="outlined"
              style={{
                marginTop: '8px',
              }}
              InputLabelProps={{ shrink: true }}
              label="Description"
              fullWidth
              value={this.state.newExpense.description}
              onChange={(e) =>
                this.setState({
                  newExpense: {
                    ...this.state.newExpense,
                    description: e.target.value,
                  },
                })
              }
            />

            <Autocomplete
              className="expense-type"
              options={expenses}
              style={{
                marginTop: '24px',
              }}
              getOptionLabel={(option) => option || ''}
              value={this.state.newExpense.expenseType || ''}
              onChange={(event, value) => {
                this.setState({
                  newExpense: {
                    ...this.state.newExpense,
                    expenseType: value || '',
                  },
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  name="expenseType"
                  label="Expense Type"
                  variant="outlined"
                  error={!this.state.newExpense.expenseType}
                  helperText={
                    this.state.newExpense.expenseType
                      ? ''
                      : 'Pick an expense type to save.'
                  }
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />

            <TextField
              label="Amount"
              type="number"
              style={{
                marginTop: '24px',
              }}
              variant="outlined"
              inputProps={{ min: 0 }}
              InputLabelProps={{ shrink: true }}
              fullWidth
              value={this.state.newExpense.amount}
              onChange={(e) =>
                this.setState({
                  newExpense: {
                    ...this.state.newExpense,
                    amount: e.target.value,
                  },
                })
              }
            />
            <TextField
              style={{
                marginTop: '24px',
              }}
              label="Comments"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              fullWidth
              multiline
              rows={3}
              value={this.state.newExpense.comments}
              onChange={(e) =>
                this.setState({
                  newExpense: {
                    ...this.state.newExpense,
                    comments: e.target.value,
                  },
                })
              }
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                width: '100px',
                marginBottom: '16px',
              }}
              onClick={() => this.setState({ showAddExpenseDialog: false })}
            >
              Cancel
            </Button>
            <Button
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
              variant="contained"
              onClick={this.handleAddExpense}
              color="primary"
              disabled={isSaveDisabled}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.isCommentDialogOpen}
          onClose={this.handleCommentCloseDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: '16px',
              padding: '16px',
            },
          }}
        >
          <DialogTitle>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Breakdown
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Typography
              variant="body1"
              sx={{ color: '#444', whiteSpace: 'pre-line' }}
            >
              {this.state.selectedComment}
            </Typography>
            {/*<Typography variant="body1" sx={{ color: '#444' }}>*/}
            {/*  {this.state.selectedComment}*/}
            {/*</Typography>*/}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCommentCloseDialog}
              variant="contained"
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.isDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="date-range-dialog"
        >
          <DialogTitle id="date-range-dialog">Filters</DialogTitle>
          <DialogContent>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div className="row-report">
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="From Date (Monday only)"
                  format="yyyy-MM-dd"
                  value={displayFromDate}
                  onChange={this.handleFromDateChange}
                  shouldDisableDate={(date) => !this.isMonday(date)}
                  disableMaskedInput
                />

                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="To Date (Sunday only)"
                  format="yyyy-MM-dd"
                  value={displayToDate}
                  onChange={this.handleToDateChange}
                  shouldDisableDate={(date) => {
                    if (!validSunday) return true;
                    return date.toDateString() !== validSunday.toDateString();
                  }}
                  disableMaskedInput
                />
              </div>
            </MuiPickersUtilsProvider>
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              onClick={this.handleDialogClose}
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              Cancel
            </Button>

            <Button
              autoFocus
              variant="contained"
              onClick={this.applyDateRange}
              color="primary"
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              {' '}
              Apply
            </Button>
          </DialogActions>
        </Dialog>

        {this.state.showShiftDetail ? (
          this.renderShiftDetail()
        ) : showPdfViewer ? (
          <RenderPurchaseOrderPDFPreview
            data={pdfData}
            handleSubmit={this.handleSubmit}
            creating={true}
            handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
            handlePdfLoadError={this.props.handlePdfLoadError}
            scale={scale}
          />
        ) : this.state.showAuditLog ? (
          <WeeklyReportAuditLog
            sessionIds={this.state.selectedSessionIds}
            onBack={() => this.setState({ showAuditLog: false })}
            onViewShiftReport={this.handleViewShiftReport}
          />
        ) : this.state.isSettings ? (
          this.renderManagerSetting()
        ) : (
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
          >
            {/* ── Session ID selector + filter button ── */}
            <div className="dateLocationBlock">
              <IconButton
                className="filter-button"
                onClick={this.handleDialogOpen}
                size="small"
                aria-label="Filter"
              >
                <FilterIcon />
              </IconButton>

              <div style={{ flex: 1 }}>
                <Autocomplete
                  className="locationDateFieldss"
                  options={[...allSessionIds].sort(
                    (a, b) => parseInt(a) - parseInt(b)
                  )}
                  getOptionLabel={(entry) => entry || ''}
                  multiple
                  autoHighlight
                  disableClearable={false}
                  onChange={(event, value) => {
                    this.setState({ selectedSessionIds: value }, () => {
                      this.refreshComponent(this.state.selectedSessionIds);
                    });
                  }}
                  value={selectedSessionIds}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option}
                        variant="outlined"
                        label={option}
                        {...getTagProps({ index })}
                        color="primary"
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Reading Session IDs"
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      name="sessionSelect"
                    />
                  )}
                />
              </div>
            </div>

            <div ref={this.dayRowRef}>{this.dateSelectRow()}</div>

            {selectedDay === 'MANAGER'
              ? this.renderManagerTable()
              : selectedDay === 'SUMMARY'
              ? this.renderSummaryTable()
              : hasReportData && (
                  <div className="report-container">
                    <Button
                      variant="outlined"
                      style={{ marginBottom: '16px' }}
                      startIcon={
                        this.state.editSummaryMode ? (
                          <VisibilityIcon />
                        ) : (
                          <EditIcon />
                        )
                      }
                      onClick={() =>
                        this.setState({
                          editSummaryMode: !this.state.editSummaryMode,
                        })
                      }
                      sx={{ mb: 2 }}
                      disabled={disableButton}
                    >
                      {this.state.editSummaryMode
                        ? 'View Summary'
                        : 'Edit Summary'}
                    </Button>
                    <div className="grid-slider" ref={this.reportContainerRef}>
                      {/* ════════════════════════════════════════
                              1. PROFIT GRID
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'profit' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="cash">
                              💵
                            </span>{' '}
                            Cash Flow
                          </h4>

                          {/* Money In */}
                          <div className="profit-section">
                            <div className="profit-section-header">
                              <span className="profit-section-dot profit-section-dot--in" />
                              <span className="profit-section-title">
                                <span role="img" aria-label="money in">
                                  ⬇️
                                </span>{' '}
                                Money In
                              </span>
                            </div>

                            {[
                              {
                                label: 'Opening Balance',
                                field: 'openingBalance',
                                editable: true,
                                requiresWeekStart: true,
                                hideIfNotWeekStart: false,
                              },
                              {
                                label: 'Reading Total IN',
                                field: 'totalIn',
                                editable: false,
                                requiresWeekStart: false,
                              },
                              {
                                label: 'Employee Short Payment',
                                field: 'employeeShortPay',
                                editable: true,
                                requiresWeekStart: false,
                              },
                              {
                                label: 'Loan In',
                                field: 'loanIn',
                                editable: true,
                                requiresWeekStart: false,
                              },
                              {
                                label: 'Add Bank',
                                field: 'addBank',
                                editable: false,
                                requiresWeekStart: false,
                              },
                            ].map(
                              ({
                                label,
                                field,
                                editable,
                                requiresWeekStart,
                                hideIfNotWeekStart,
                              }) => {
                                if (
                                  hideIfNotWeekStart &&
                                  !selectedReport.weekStart
                                )
                                  return null;
                                let value = selectedReport[field] || 0;
                                if (field === 'totalIn') {
                                  value =
                                    (selectedReport.totalIn || 0) +
                                    (selectedReport.jpOtherIn || 0);
                                }

                                // Hide zero-value rows in preview mode
                                if (!editSummaryMode && value === 0)
                                  return null;

                                const canEdit =
                                  editable &&
                                  (!requiresWeekStart ||
                                    selectedReport.weekStart);

                                // Mirrors ReportService.loanInNoteLine so
                                // the Cash Flow dialog and the Summary tab
                                // read identically. No headings: the line
                                // says what it is.
                                const loanInBreakdown =
                                  field === 'loanIn'
                                    ? [
                                        formatLoanInNoteLine(selectedReport),
                                        (
                                          customerPayLoans?.comments || ''
                                        ).trim(),
                                      ]
                                        .filter(Boolean)
                                        .join('\n')
                                    : '';
                                const hasLoanInBreakdown = !!loanInBreakdown;

                                return (
                                  <div key={field}>
                                    {!this.state.editingFields[field] ? (
                                      <div className="profit-row">
                                        <span className="profit-row-label">
                                          {label}
                                        </span>
                                        <div className="profit-row-value">
                                          <span>${value.toLocaleString()}</span>
                                          {hasLoanInBreakdown && (
                                            <Tooltip title="View Breakdown">
                                              <IconButton
                                                size="small"
                                                style={{
                                                  marginLeft: '2px',
                                                  padding: '2px',
                                                }}
                                                onClick={() =>
                                                  this.handleCommentOpenDialog(
                                                    loanInBreakdown
                                                  )
                                                }
                                              >
                                                <DescriptionIcon fontSize="small" />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                          {canEdit && editSummaryMode && (
                                            <IconButton
                                              size="small"
                                              style={{
                                                marginLeft: '2px',
                                                padding: '2px',
                                              }}
                                              onClick={() =>
                                                // Fields that carry a
                                                // reason get a proper
                                                // dialog; a comment does
                                                // not fit in the inline
                                                // row beside the figure.
                                                NOTE_FIELDS.includes(field)
                                                  ? this.openNoteEditor(
                                                      field,
                                                      label,
                                                      selectedReport
                                                    )
                                                  : this.handleEditClick(
                                                      field,
                                                      selectedReport[field] || 0
                                                    )
                                              }
                                            >
                                              <EditIcon
                                                style={{
                                                  fontSize: '14px',
                                                  color: '#aaa',
                                                }}
                                              />
                                            </IconButton>
                                          )}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="profit-edit-row">
                                        <div className="profit-edit-row-label">
                                          {label}
                                        </div>
                                        <div className="profit-edit-controls">
                                          <input
                                            type="number"
                                            className="profit-edit-input"
                                            value={
                                              this.state.fieldValues[field]
                                            }
                                            onChange={(e) =>
                                              this.handleFieldChange(field, e)
                                            }
                                          />
                                          <button
                                            className="profit-apply-btn"
                                            onClick={() =>
                                              this.handleApplyClick(field)
                                            }
                                          >
                                            Apply
                                          </button>
                                          <IconButton
                                            size="small"
                                            className="profit-close-btn"
                                            onClick={() =>
                                              this.setState((prev) => ({
                                                editingFields: {
                                                  ...prev.editingFields,
                                                  [field]: false,
                                                },
                                              }))
                                            }
                                          >
                                            <CloseIcon
                                              style={{ fontSize: '16px' }}
                                            />
                                          </IconButton>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              }
                            )}

                            {/* Total IN */}
                            {(() => {
                              const computedTotalIn =
                                (selectedReport.openingBalance || 0) +
                                (selectedReport.totalIn || 0) +
                                (selectedReport.jpOtherIn || 0) +
                                (selectedReport.employeeShortPay || 0) +
                                (selectedReport.loanIn || 0) +
                                (selectedReport.addBank || 0);
                              return (
                                <div className="profit-total-row profit-total-row--in">
                                  <span className="profit-total-label profit-total-label--in">
                                    Total IN
                                  </span>
                                  <span className="profit-total-value profit-total-value--in">
                                    ${computedTotalIn.toLocaleString()}
                                  </span>
                                </div>
                              );
                            })()}
                          </div>

                          {/* Money Out */}
                          <div className="profit-section">
                            <div className="profit-section-header">
                              <span className="profit-section-dot profit-section-dot--out" />
                              <span className="profit-section-title">
                                <span role="img" aria-label="money out">
                                  ⬆️
                                </span>{' '}
                                Money Out
                              </span>
                            </div>

                            {[
                              {
                                label: 'Reading Total OUT',
                                field: 'totalOut',
                                editable: false,
                              },
                              {
                                label: 'Minus Bank',
                                field: 'minusBank',
                                editable: false,
                              },
                            ].map(({ label, field }) => {
                              let value = selectedReport[field] || 0;
                              if (field === 'totalOut') {
                                value =
                                  (selectedReport.totalOut || 0) +
                                  (selectedReport.jpOtherOut || 0) -
                                  (selectedReport.jackpotNotPay || 0);
                              }
                              if (!editSummaryMode && value === 0) return null;
                              return (
                                <div key={field} className="profit-row">
                                  <span className="profit-row-label">
                                    {label}
                                  </span>
                                  <span className="profit-row-value">
                                    ${value.toLocaleString()}
                                  </span>
                                </div>
                              );
                            })}

                            {(editSummaryMode || totalExpenses !== 0) && (
                              <div className="profit-row">
                                <span className="profit-row-label">
                                  All Expenses
                                </span>
                                <span className="profit-row-value">
                                  ${(totalExpenses || 0).toLocaleString()}
                                </span>
                              </div>
                            )}

                            {/* Total OUT */}
                            {(() => {
                              const computedReadingOut =
                                (selectedReport.totalOut || 0) +
                                (selectedReport.jpOtherOut || 0) -
                                (selectedReport.jackpotNotPay || 0);
                              const computedTotalOut =
                                computedReadingOut +
                                (selectedReport.minusBank || 0) +
                                (totalExpenses || 0);
                              return (
                                <div className="profit-total-row profit-total-row--out">
                                  <span className="profit-total-label profit-total-label--out">
                                    Total OUT
                                  </span>
                                  <span className="profit-total-value profit-total-value--out">
                                    ${computedTotalOut.toLocaleString()}
                                  </span>
                                </div>
                              );
                            })()}
                          </div>

                          {/* Difference */}
                          {(() => {
                            const computedTotalIn =
                              (selectedReport.openingBalance || 0) +
                              (selectedReport.totalIn || 0) +
                              (selectedReport.jpOtherIn || 0) +
                              (selectedReport.employeeShortPay || 0) +
                              (selectedReport.loanIn || 0) +
                              (selectedReport.addBank || 0);
                            const computedReadingOut =
                              (selectedReport.totalOut || 0) +
                              (selectedReport.jpOtherOut || 0) -
                              (selectedReport.jackpotNotPay || 0);
                            const computedTotalOut =
                              computedReadingOut +
                              (selectedReport.minusBank || 0) +
                              (totalExpenses || 0);
                            const difference =
                              computedTotalIn - computedTotalOut;
                            return (
                              <div className="profit-difference">
                                <span className="profit-difference-label">
                                  Difference
                                </span>
                                <span
                                  className="profit-difference-value"
                                  style={{
                                    color:
                                      difference < 0 ? '#ef4444' : '#16a34a',
                                  }}
                                >
                                  {difference < 0
                                    ? `($${Math.abs(
                                        difference
                                      ).toLocaleString()})`
                                    : `$${difference.toLocaleString()}`}
                                </span>
                              </div>
                            );
                          })()}

                          {/* Ending Balance */}
                          <div className="profit-ending-balance">
                            <span className="profit-ending-balance-label">
                              Ending Balance
                            </span>
                            <span className="profit-ending-balance-value">
                              $
                              {selectedReport.endingBalance?.toLocaleString() ||
                                '0'}
                            </span>
                          </div>

                          {/* Short / Over */}
                          <div className="profit-short-over">
                            <span className="profit-short-over-label">
                              Short / Over
                            </span>
                            <span
                              className={`profit-short-over-value ${
                                selectedReport.shortOver < 0
                                  ? 'profit-short-over-value--negative'
                                  : 'profit-short-over-value--positive'
                              }`}
                            >
                              {selectedReport.shortOver < 0
                                ? `-$${Math.abs(
                                    selectedReport.shortOver
                                  ).toLocaleString()}`
                                : `$${
                                    selectedReport.shortOver?.toLocaleString() ||
                                    '0'
                                  }`}
                            </span>
                          </div>

                          {/* Net Profit + Customers */}
                          <div className="profit-summary-grid">
                            <div
                              className={`profit-net-card ${
                                selectedReport.netProfit < 0
                                  ? 'negative'
                                  : 'positive'
                              }`}
                            >
                              <div className="profit-net-card-label">
                                Net Profit
                              </div>
                              <div className="profit-net-card-value">
                                {selectedReport.netProfit < 0
                                  ? `-$${Math.abs(
                                      selectedReport.netProfit
                                    ).toLocaleString()}`
                                  : `$${
                                      selectedReport.netProfit?.toLocaleString() ||
                                      '0'
                                    }`}
                              </div>
                            </div>
                            <div className="profit-customers-card">
                              <div className="profit-customers-card-label">
                                Customers
                              </div>
                              <div className="profit-customers-card-value">
                                {selectedReport?.customers?.length || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              2. EXPENSES GRID
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'expenses' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="expenses">
                              📋
                            </span>{' '}
                            Expenses
                          </h4>
                          <div className="grid">
                            {selectedReport.expenseSet &&
                            selectedReport.expenseSet.length > 0 ? (
                              selectedReport.expenseSet.map(
                                (expense, index) => {
                                  const isTotal =
                                    expense.description?.toLowerCase() ===
                                    'total';

                                  if (isTotal) {
                                    return (
                                      <React.Fragment key={index}>
                                        {/* Add Expense button — edit mode only */}
                                        {editSummaryMode && (
                                          <div className="item">
                                            <Tooltip
                                              title="Add Expense"
                                              style={{
                                                width: '36px',
                                                height: '36px',
                                              }}
                                            >
                                              <IconButton
                                                onClick={() =>
                                                  this.setState({
                                                    showAddExpenseDialog: true,
                                                  })
                                                }
                                              >
                                                <AddCircleIcon
                                                  fontSize="small"
                                                  color="secondary"
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </div>
                                        )}
                                        <div
                                          className="item"
                                          style={{ backgroundColor: '#e0f5e9' }}
                                        >
                                          <span>{expense.description}</span>
                                          <div
                                            style={{
                                              color: 'black',
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            $
                                            {expense.amount?.toLocaleString() ||
                                              0}
                                          </div>
                                        </div>

                                        {/* Employees Shift — moved here from the
                                            Readings tab; shown right after the
                                            expenses Total. */}
                                        <div
                                          className="item"
                                          style={{ marginTop: '16px' }}
                                        >
                                          <span
                                            style={{ marginBottom: '16px' }}
                                          >
                                            <strong>
                                              <span
                                                role="img"
                                                aria-label="employees"
                                              >
                                                👥
                                              </span>{' '}
                                              Employees Shift
                                            </strong>
                                          </span>
                                          {selectedReport.employeeDetails
                                            ?.length > 0 ? (
                                            <div
                                              style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '8px',
                                                alignItems: 'flex-start',
                                                padding: 0,
                                                margin: 0,
                                              }}
                                            >
                                              {selectedReport.employeeDetails.map(
                                                (employee, empIdx) => (
                                                  <Chip
                                                    key={`${employee.userId}-${employee.sessionId}-${employee.date}-${empIdx}`}
                                                    label={`${employee.name} - ${employee.date} ${employee.timeIn}`}
                                                    clickable
                                                    onClick={() =>
                                                      this.handleViewShiftReport(
                                                        {
                                                          userId:
                                                            employee.userId,
                                                          locationId:
                                                            employee.locationId,
                                                          clockId:
                                                            employee.clockId,
                                                          userName:
                                                            employee.name,
                                                          sessionId:
                                                            employee.sessionId,
                                                          date: employee.date,
                                                          timeIn:
                                                            employee.timeIn,
                                                          timeOut:
                                                            employee.timeOut,
                                                        }
                                                      )
                                                    }
                                                  />
                                                )
                                              )}
                                            </div>
                                          ) : (
                                            <span>No employees</span>
                                          )}
                                        </div>
                                      </React.Fragment>
                                    );
                                  }

                                  // In preview mode, hide expenses with amount 0
                                  if (
                                    !editSummaryMode &&
                                    (expense.amount === 0 ||
                                      expense.amount == null)
                                  )
                                    return null;

                                  return (
                                    <div
                                      key={index}
                                      className="item"
                                      style={{
                                        backgroundColor: expense.isManager
                                          ? '#ffe5b4'
                                          : 'transparent',
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '6px',
                                        }}
                                      >
                                        {expense.description}
                                        {expense.comments && (
                                          <Tooltip title="View Comment">
                                            <IconButton
                                              size="small"
                                              onClick={() =>
                                                this.handleCommentOpenDialog(
                                                  expense.comments
                                                )
                                              }
                                            >
                                              <DescriptionIcon fontSize="small" />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                      </span>
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          width: '100%',
                                          alignItems: 'center',
                                        }}
                                      >
                                        ${expense.amount?.toLocaleString() || 0}
                                        {/* Delete button — edit mode only */}
                                        {expense.isManager &&
                                          editSummaryMode && (
                                            <IconButton
                                              style={{
                                                width: '36px',
                                                height: '36px',
                                              }}
                                              onClick={() =>
                                                this.setState({
                                                  showDeleteDialog: true,
                                                  rowToDelete: index,
                                                })
                                              }
                                            >
                                              <RemoveCircleIcon
                                                fontSize="small"
                                                color="error"
                                              />
                                            </IconButton>
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              )
                            ) : (
                              <div className="item">No expenses recorded.</div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              3. READINGS GRID
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'readings' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="readings">
                              🎰
                            </span>{' '}
                            Readings
                          </h4>
                          <div className="grid">
                            {(editSummaryMode ||
                              (selectedReport.totalIn || 0) !== 0) && (
                              <div className="item">
                                <span>Total IN</span>$
                                {selectedReport.totalIn?.toLocaleString() || 0}
                              </div>
                            )}

                            {(editSummaryMode ||
                              (selectedReport.totalOut || 0) !== 0) && (
                              <div className="item">
                                <span>Total OUT</span>$
                                {selectedReport.totalOut?.toLocaleString() || 0}
                              </div>
                            )}

                            {/* Jackpot Not Pay */}
                            {(editSummaryMode ||
                              (selectedReport.jackpotNotPay || 0) !== 0) && (
                              <div className="item">
                                <span>Jackpot Not Pay</span> $
                                {this.state.editingFields.jackpotNotPay ? (
                                  <>
                                    <input
                                      type="number"
                                      value={
                                        this.state.fieldValues.jackpotNotPay
                                      }
                                      onChange={(e) =>
                                        this.handleFieldChange(
                                          'jackpotNotPay',
                                          e
                                        )
                                      }
                                      style={{
                                        marginLeft: '8px',
                                        width: '120px',
                                        padding: '6px 8px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        this.handleApplyClick('jackpotNotPay')
                                      }
                                      className="profit-apply-btn"
                                      style={{ marginLeft: '8px' }}
                                    >
                                      Apply
                                    </button>
                                    <IconButton
                                      size="small"
                                      style={{ marginLeft: '6px' }}
                                      onClick={() =>
                                        this.setState((prev) => ({
                                          editingFields: {
                                            ...prev.editingFields,
                                            jackpotNotPay: false,
                                          },
                                        }))
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    {selectedReport.jackpotNotPay?.toLocaleString() ||
                                      0}
                                    {editSummaryMode && (
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.handleEditClick(
                                            'jackpotNotPay',
                                            selectedReport.jackpotNotPay || 0
                                          )
                                        }
                                      >
                                        <EditIcon
                                          style={{
                                            fontSize: '14px',
                                            color: '#aaa',
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </div>
                            )}

                            {/* Other In */}
                            {(editSummaryMode ||
                              (selectedReport.jpOtherIn || 0) !== 0) && (
                              <div className="item">
                                <span>Other In</span> $
                                {this.state.editingFields.jpOtherIn ? (
                                  <>
                                    <input
                                      type="number"
                                      value={this.state.fieldValues.jpOtherIn}
                                      onChange={(e) =>
                                        this.handleFieldChange('jpOtherIn', e)
                                      }
                                      style={{
                                        marginLeft: '8px',
                                        width: '120px',
                                        padding: '6px 8px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        this.handleApplyClick('jpOtherIn')
                                      }
                                      className="profit-apply-btn"
                                      style={{ marginLeft: '8px' }}
                                    >
                                      Apply
                                    </button>
                                    <IconButton
                                      size="small"
                                      style={{ marginLeft: '6px' }}
                                      onClick={() =>
                                        this.setState((prev) => ({
                                          editingFields: {
                                            ...prev.editingFields,
                                            jpOtherIn: false,
                                          },
                                        }))
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    {selectedReport.jpOtherIn?.toLocaleString() ||
                                      0}
                                    {editSummaryMode && (
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.handleEditClick(
                                            'jpOtherIn',
                                            selectedReport.jpOtherIn || 0
                                          )
                                        }
                                      >
                                        <EditIcon
                                          style={{
                                            fontSize: '14px',
                                            color: '#aaa',
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </div>
                            )}

                            {/* Other Out */}
                            {(editSummaryMode ||
                              (selectedReport.jpOtherOut || 0) !== 0) && (
                              <div className="item">
                                <span>Other Out</span> $
                                {this.state.editingFields.jpOtherOut ? (
                                  <>
                                    <input
                                      type="number"
                                      value={this.state.fieldValues.jpOtherOut}
                                      onChange={(e) =>
                                        this.handleFieldChange('jpOtherOut', e)
                                      }
                                      style={{
                                        marginLeft: '8px',
                                        width: '120px',
                                        padding: '6px 8px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        this.handleApplyClick('jpOtherOut')
                                      }
                                      className="profit-apply-btn"
                                      style={{ marginLeft: '8px' }}
                                    >
                                      Apply
                                    </button>
                                    <IconButton
                                      size="small"
                                      style={{ marginLeft: '6px' }}
                                      onClick={() =>
                                        this.setState((prev) => ({
                                          editingFields: {
                                            ...prev.editingFields,
                                            jpOtherOut: false,
                                          },
                                        }))
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    {selectedReport.jpOtherOut?.toLocaleString() ||
                                      0}
                                    {editSummaryMode && (
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.handleEditClick(
                                            'jpOtherOut',
                                            selectedReport.jpOtherOut || 0
                                          )
                                        }
                                      >
                                        <EditIcon
                                          style={{
                                            fontSize: '14px',
                                            color: '#aaa',
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </div>
                            )}

                            {/* Adjusted divider */}
                            <div
                              className="readings-divider"
                              style={{ marginBottom: '8px' }}
                            >
                              <span className="readings-divider-label">
                                Adjusted
                              </span>
                            </div>

                            {/* Real Total In */}
                            <div className="readings-row readings-row--adjusted">
                              <span className="readings-label">
                                <strong>Real Total In</strong>
                              </span>
                              <span className="readings-value readings-value--green">
                                <strong>
                                  $
                                  {(
                                    (selectedReport.totalIn || 0) +
                                    (selectedReport.jpOtherIn || 0)
                                  ).toLocaleString()}
                                </strong>
                              </span>
                            </div>

                            {/* Real Total Out */}
                            <div className="readings-row readings-row--adjusted">
                              <span className="readings-label">
                                <strong>Real Total Out</strong>
                              </span>
                              <span className="readings-value readings-value--red">
                                <strong>
                                  $
                                  {(
                                    (selectedReport.totalOut || 0) +
                                    (selectedReport.jpOtherOut || 0) -
                                    (selectedReport.jackpotNotPay || 0)
                                  ).toLocaleString()}
                                </strong>
                              </span>
                            </div>

                            {/* Gross Profit */}
                            <div className="readings-row readings-row--adjusted item lightGreen">
                              <span>
                                <strong>Gross Profit</strong>
                              </span>
                              <span
                                className={`readings-value ${
                                  selectedReport.grossProfit < 0
                                    ? 'readings-value--red'
                                    : 'readings-value--green'
                                }`}
                              >
                                <strong>
                                  {selectedReport.grossProfit < 0
                                    ? `($${Math.abs(
                                        selectedReport.grossProfit
                                      ).toLocaleString()})`
                                    : `$${
                                        selectedReport.grossProfit?.toLocaleString() ||
                                        0
                                      }`}
                                </strong>
                              </span>
                            </div>
                          </div>

                          {/* Totals by Machine Type — mirrors the Master Reading
                              PDF summary (In / Out / Difference / Points / Bonus
                              / Net), fed from selectedReport.machineTypeTotals. */}
                          {canViewReadingSummary(this.props.userInfo) &&
                            this.renderMachineTypeTotalsCard(selectedReport)}
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              4. CLOSING BALANCE GRID
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'closingBalance' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="bank">
                              🏦
                            </span>{' '}
                            Closing Balance
                          </h4>
                          <div className="grid">
                            {/* Reusable editable field renderer */}
                            {[
                              { label: '🏦 Bank 1', field: 'bank1' },
                              { label: '🏦 Bank 2', field: 'bank2' },
                              { label: '🏦 Bank 3', field: 'bank3' },
                              { label: '👤 Manager', field: 'manager' },
                              { label: '🏧 ATM', field: 'atm' },
                              { label: '📱 Zelle', field: 'zelle' },
                              { label: '👤 Supervisor', field: 'supervisor' },
                            ].map(({ label, field }) => {
                              const value = selectedReport[field] || 0;
                              if (!editSummaryMode && value === 0) return null;
                              return (
                                <div key={field} className="item">
                                  <span>{label}</span> $
                                  {this.state.editingFields[field] ? (
                                    <>
                                      <input
                                        type="number"
                                        value={this.state.fieldValues[field]}
                                        onChange={(e) =>
                                          this.handleFieldChange(field, e)
                                        }
                                        style={{
                                          marginLeft: '8px',
                                          width: '120px',
                                          padding: '6px 8px',
                                          border: '1px solid #ccc',
                                          borderRadius: '4px',
                                        }}
                                      />
                                      <button
                                        onClick={() =>
                                          this.handleApplyClick(field)
                                        }
                                        className="profit-apply-btn"
                                        style={{ marginLeft: '8px' }}
                                      >
                                        Apply
                                      </button>
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.setState((prev) => ({
                                            editingFields: {
                                              ...prev.editingFields,
                                              [field]: false,
                                            },
                                          }))
                                        }
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </>
                                  ) : (
                                    <>
                                      {value.toLocaleString()}
                                      {editSummaryMode && (
                                        <IconButton
                                          size="small"
                                          style={{ marginLeft: '6px' }}
                                          onClick={() =>
                                            this.handleEditClick(field, value)
                                          }
                                        >
                                          <EditIcon
                                            style={{
                                              fontSize: '14px',
                                              color: '#aaa',
                                            }}
                                          />
                                        </IconButton>
                                      )}
                                    </>
                                  )}
                                </div>
                              );
                            })}

                            {/* Subtotal — always show */}
                            <div className="item">
                              <span>Subtotal</span>$
                              {selectedReport.bankSubtotal?.toLocaleString() ||
                                0}
                            </div>

                            {/* Minus Rollover */}
                            {(editSummaryMode ||
                              (selectedReport.minusRollover || 0) !== 0) && (
                              <div className="item">
                                <span>Minus Rollover</span> $
                                {this.state.editingFields.minusRollover ? (
                                  <>
                                    <input
                                      type="number"
                                      value={
                                        this.state.fieldValues.minusRollover
                                      }
                                      onChange={(e) =>
                                        this.handleFieldChange(
                                          'minusRollover',
                                          e
                                        )
                                      }
                                      style={{
                                        marginLeft: '8px',
                                        width: '120px',
                                        padding: '6px 8px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        this.handleApplyClick('minusRollover')
                                      }
                                      className="profit-apply-btn"
                                      style={{ marginLeft: '8px' }}
                                    >
                                      Apply
                                    </button>
                                    <IconButton
                                      size="small"
                                      style={{ marginLeft: '6px' }}
                                      onClick={() =>
                                        this.setState((prev) => ({
                                          editingFields: {
                                            ...prev.editingFields,
                                            minusRollover: false,
                                          },
                                        }))
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    {selectedReport.minusRollover?.toLocaleString() ||
                                      0}
                                    {editSummaryMode && (
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.handleEditClick(
                                            'minusRollover',
                                            selectedReport.minusRollover || 0
                                          )
                                        }
                                      >
                                        <EditIcon
                                          style={{
                                            fontSize: '14px',
                                            color: '#aaa',
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </div>
                            )}

                            {/* E/B Total — always show */}
                            <div className="item">
                              <span>E/B Total</span>$
                              {selectedReport.ebTotal?.toLocaleString() || 0}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              5. MANAGER LOAN TO BANK
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'managerLoan' && (
                        <div className="grid-section bank-board-section">
                          <h4
                            className="title-heading"
                            style={{
                              marginBottom: '15px',
                              fontSize: '18px',
                              fontWeight: '600',
                            }}
                          >
                            <span role="img" aria-label="bank board">
                              📒
                            </span>{' '}
                            Manager Loan To Bank
                          </h4>

                          <div
                            style={{
                              margin: '0 auto',
                              fontFamily: 'Arial, sans-serif',
                              border: '1px solid #e5e7eb',
                              borderRadius: '12px',
                              padding: '20px',
                              boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                              background: '#fff',
                            }}
                          >
                            {/* Input row — edit mode only */}
                            {editSummaryMode && (
                              <div
                                className="bank-board-fields"
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: '10px',
                                  marginBottom: '20px',
                                  alignItems: 'center',
                                }}
                              >
                                <select
                                  value={type}
                                  onChange={this.handleTypeChange}
                                  style={{
                                    height: '39px',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                    flex: '1 1 100px',
                                    minWidth: '100px',
                                    background: '#f9fafb',
                                  }}
                                >
                                  <option value="">Type</option>
                                  <option value="add">Add</option>
                                  <option value="minus">Minus</option>
                                </select>
                                <input
                                  type="text"
                                  value={nameInput}
                                  onChange={this.handleNameChange}
                                  placeholder="Name"
                                  style={{
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                    flex: '1 1 120px',
                                    minWidth: '120px',
                                    background: '#f9fafb',
                                  }}
                                />
                                <input
                                  type="text"
                                  value={amountInput}
                                  onChange={this.handleAmountChange}
                                  placeholder="Amount"
                                  style={{
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                    flex: '1 1 100px',
                                    minWidth: '100px',
                                    background: '#f9fafb',
                                  }}
                                />
                                <button
                                  onClick={this.handleApply}
                                  disabled={isApplyDisabled}
                                  className="profit-apply-btn"
                                  style={{
                                    marginLeft: '0px',
                                    flex: '1 1 80px',
                                    minWidth: '80px',
                                  }}
                                >
                                  Apply
                                </button>
                              </div>
                            )}

                            {/* Transactions */}
                            <div style={{ marginBottom: '15px' }}>
                              <div
                                className="item lightgreen"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  borderBottom: '1px solid #f1f5f9',
                                  borderRadius: '6px',
                                }}
                              >
                                <span style={{ marginTop: '4px' }}>
                                  Opening Balance:
                                </span>
                                <span
                                  style={{
                                    marginTop: '4px',
                                    marginLeft: '8px',
                                    color:
                                      bankOpeningBalance < 0
                                        ? '#dc2626'
                                        : '#16a34a',
                                    fontWeight: '600',
                                  }}
                                >
                                  {bankOpeningBalance < 0 ? '-' : '+'} $
                                  {Math.abs(bankOpeningBalance)}
                                </span>
                              </div>

                              {bankBoardList.map((trx, idx) => (
                                <div
                                  key={trx.entryId || trx.transactionId || idx}
                                  style={{
                                    marginTop: '8px',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '4px 12px',
                                    alignItems: 'center',
                                    padding: '10px 8px',
                                    borderBottom: '1px solid #f1f5f9',
                                    backgroundColor:
                                      idx % 2 === 0 ? '#fafafa' : '#fff',
                                    borderRadius: '6px',
                                  }}
                                >
                                  <span
                                    style={{
                                      color:
                                        trx.amount < 0 ? '#dc2626' : '#16a34a',
                                      fontWeight: '600',
                                      minWidth: '80px',
                                    }}
                                  >
                                    {trx.amount < 0 ? '-' : '+'} $
                                    {Math.abs(trx.amount)}
                                  </span>
                                  <span
                                    style={{
                                      color: '#4b5563',
                                      fontSize: '14px',
                                    }}
                                  >
                                    {new Date(
                                      trx.createdDate
                                    ).toLocaleDateString()}
                                  </span>
                                  <span
                                    style={{
                                      color: '#374151',
                                      fontWeight: '500',
                                      fontSize: '14px',
                                      fontStyle: 'italic',
                                      marginLeft: 'auto',
                                      textAlign: 'right',
                                    }}
                                  >
                                    — {trx.employeeName} ({trx.userName})
                                  </span>

                                  {/* Owner-only edit / remove. Rows carry the
                                      record they came from, so a row carried
                                      forward from an earlier day still edits
                                      its own originating session. */}
                                  {canManageBankBoard && (
                                    <span
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <IconButton
                                        title="Edit entry"
                                        style={{
                                          width: '32px',
                                          height: '32px',
                                        }}
                                        onClick={() =>
                                          this.handleOpenBankEntryEdit(trx)
                                        }
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton
                                        title="Remove entry"
                                        style={{
                                          width: '32px',
                                          height: '32px',
                                        }}
                                        onClick={() =>
                                          this.setState({
                                            bankEntryToDelete: trx,
                                          })
                                        }
                                      >
                                        <RemoveCircleIcon
                                          fontSize="small"
                                          color="error"
                                        />
                                      </IconButton>
                                    </span>
                                  )}
                                </div>
                              ))}
                            </div>

                            {/* Balance */}
                            <div
                              style={{
                                textAlign: 'right',
                                fontWeight: 'bold',
                                fontSize: '18px',
                                color: '#111827',
                                padding: '10px',
                                borderRadius: '8px',
                                background: '#f9fafb',
                                boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
                              }}
                            >
                              Balance: ${bankBoardBalance.toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              6. EXPENSES + MACHINE PERCENTAGES (one tab)
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'percentages' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="chart">
                              📊
                            </span>{' '}
                            Expense %
                          </h4>
                          <div className="grid">
                            {allowedPercentageRows(
                              this.props.userInfo,
                              [
                                { label: 'Match', field: 'matchPct' },
                                {
                                  label: 'High Roller Match',
                                  field: 'highRollerMatchPct',
                                },
                                { label: 'Bonus', field: 'bonusPct' },
                                { label: 'Employees', field: 'employeePct' },
                                { label: 'Drawings', field: 'drawingsPct' },
                                { label: "Sam's", field: 'samsPct' },
                                {
                                  label: 'Food Expense',
                                  field: 'foodExpensePct',
                                },
                                {
                                  label: 'Maintenance/Upgrades',
                                  field: 'maintenancePct',
                                },
                                {
                                  label: 'Miscellaneous',
                                  field: 'miscellaneousTotal',
                                },
                                { label: 'Total Pay', field: 'totalPayPct' },
                              ],
                              BASIC_EXPENSE_PCT_FIELDS
                            ).map(({ label, field }) => {
                              const pct = selectedReport.percentages?.[field];
                              if (
                                !editSummaryMode &&
                                (pct === 0 || pct == null)
                              )
                                return null;
                              return (
                                <div key={field} className="item blue">
                                  <span>{label}</span>
                                  <strong>
                                    {pct != null ? `${pct}%` : '0%'}
                                  </strong>
                                </div>
                              );
                            })}
                          </div>

                          <h4
                            className="title-heading"
                            style={{ marginTop: '16px' }}
                          >
                            <span role="img" aria-label="machine">
                              ⚙️
                            </span>{' '}
                            Machine %
                          </h4>
                          <div className="grid">
                            {allowedPercentageRows(
                              this.props.userInfo,
                              [
                                {
                                  label: 'Machine Payout',
                                  field: 'machinePayoutPct',
                                },
                                {
                                  label: 'Machine Hold',
                                  field: 'machineHoldPct',
                                },
                                {
                                  label: 'Gameroom Payout',
                                  field: 'gameroomPayoutPct',
                                },
                                { label: 'We Kept', field: 'weKeptPct' },
                              ],
                              BASIC_MACHINE_PCT_FIELDS
                            ).map(({ label, field }) => {
                              const pct =
                                selectedReport.machinePercentages?.[field];
                              if (
                                !editSummaryMode &&
                                (pct === 0 || pct == null)
                              )
                                return null;
                              return (
                                <div key={field} className="item orange">
                                  <span>{label}</span>
                                  <strong
                                    style={{
                                      color: pct < 0 ? 'red' : 'inherit',
                                    }}
                                  >
                                    {pct != null
                                      ? pct < 0
                                        ? `(${Math.abs(pct)}%)`
                                        : `${pct}%`
                                      : '0%'}
                                  </strong>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              8+9. DAILY ANALYSIS (merged Activity + Equation X)
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'dailyAnalysis' &&
                        this.renderDailyAnalysis()}
                    </div>
                  </div>
                )}
          </div>
        )}

        <Menu
          open={Boolean(this.state.pdfPopperAnchor)}
          anchorEl={this.state.pdfPopperAnchor}
          onClose={this.handlePdfPopperClose}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            elevation: 4,
            style: {
              borderRadius: 10,
              overflow: 'hidden',
              minWidth: 180,
              marginTop: 4,
            },
          }}
        >
          {selectedDay !== 'SUMMARY' && (
            <MenuItem
              onClick={() => this.handlePdfOptionSelect('quick')}
              style={{ gap: 10, padding: '10px 16px', fontSize: 14 }}
            >
              <GetApp style={{ fontSize: 18, color: '#4f46e5' }} />
              Quick Summary (Profit)
            </MenuItem>
          )}
          {selectedDay !== 'SUMMARY' && (
            <MenuItem
              onClick={() => this.handlePdfOptionSelect('full')}
              style={{ gap: 10, padding: '10px 16px', fontSize: 14 }}
            >
              <GetApp style={{ fontSize: 18, color: '#2563eb' }} />
              Full Report (All Sections)
            </MenuItem>
          )}
          {selectedDay === 'SUMMARY' && (
            <MenuItem
              onClick={() => this.handlePdfOptionSelect('summary')}
              style={{ gap: 10, padding: '10px 16px', fontSize: 14 }}
            >
              <GetApp style={{ fontSize: 18, color: '#16a34a' }} />
              Download Summary
            </MenuItem>
          )}
        </Menu>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  viewOnly: viewOnlySelector(state),
  userInfo: userInfoSelector(state),
  loadingData: loadingSelector(state),
  report: reportSelector(state),
  summary: summarySelector(state),
  summaryBreakdown: summaryBreakdownSelector(state),
  employeeSummary: employeeSummarySelector(state),
  allSessionIds: allSessionIdsSelector(state),
  PDFPreviewReady: globalPDFPreviewReadySelector(state),
  managerSetting: managerSettingSelector(state),
  managerSummary: managerSummarySelector(state),
  shortAnalysis: shortAnalysisSelector(state),
  weeklyReportAuditLogs: weeklyReportAuditLogsSelector(state),
  sessionData: sessionDataSelector(state),
  loadingSessionReports: loadingSessionReportsSelector(state),
  customers: customersSelector(state),
  employees: employeesSelector(state),
  categories: categorySelector(state),
  manageBonusList: manageBonusSelector(state),
});

const actionCreators = {
  listReport,
  listSessionIds,
  updateReportField,
  clearWeeklyReport,
  updateManagerBank,
  editBankBoardEntry,
  deleteBankBoardEntry,
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
  getManagerSummary,
  saveManagerSetting,
  saveManagerSummary,
  listShortAnalysis,
  listWeeklyReportAudit,
  loadSessionReports,
  clearSessionReports,
  listAllCustomers,
  getEmployees,
  listManageBonus,
  listCategory,
};

export default withShipment({ actionCreators, mapStateToProps }, ReportView);
